import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: Date;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: Record<string, unknown>;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: string;
};

export type Query = {
  readonly __typename?: 'Query';
  readonly getFrontendVersion: FrontendVersion;
  readonly budgetConfig: BudgetConfig;
  readonly budget: Budget;
  readonly budgets: ReadonlyArray<Budget>;
  readonly contacts: ReadonlyArray<Contact>;
  readonly searchServices: ReadonlyArray<Service>;
  readonly searchPassengers: ReadonlyArray<Passenger>;
  readonly searchDrivers: ReadonlyArray<Driver>;
  readonly passengers: ReadonlyArray<Passenger>;
  readonly passengersForUser: ReadonlyArray<Passenger>;
  readonly passenger: Passenger;
  readonly service?: Maybe<Service>;
  readonly serviceTypes: ReadonlyArray<ServiceType>;
  readonly services?: Maybe<ReadonlyArray<Service>>;
  readonly clients?: Maybe<ReadonlyArray<Client>>;
  readonly client?: Maybe<Client>;
  readonly clientEmployees: ReadonlyArray<ClientEmployee>;
  readonly clientEmployee: ClientEmployee;
  readonly drivers?: Maybe<ReadonlyArray<Driver>>;
  readonly driversByDrivingCompany: ReadonlyArray<Driver>;
  readonly userOrDriver: UserOrDriver;
  readonly user: User;
  readonly isEmailUsedForAuthentication: Scalars['Boolean'];
  readonly isPhoneUsedForAuthentication: Scalars['Boolean'];
  readonly userByEmail?: Maybe<User>;
  readonly driverByEmail?: Maybe<Driver>;
  readonly driver?: Maybe<Driver>;
  readonly drivingCompany: DrivingCompany;
  readonly drivingCompanies: ReadonlyArray<DrivingCompany>;
  readonly vehicle: Vehicle;
  readonly vehicles: ReadonlyArray<Vehicle>;
  readonly vehicleTypes: ReadonlyArray<VehicleType>;
  readonly vehicleBrandModels: ReadonlyArray<VehicleBrandModels>;
  readonly vehicleBrand: VehicleBrandModels;
  readonly vehicleModel: VehicleModel;
  readonly templates: ReadonlyArray<RichTemplate>;
  readonly template?: Maybe<RichTemplate>;
  readonly globalRate?: Maybe<Rate>;
  readonly rate?: Maybe<Rate>;
  readonly rates: ReadonlyArray<Rate>;
  readonly computeItineraryPrice: CandidateAmount;
  readonly serviceOffers: ReadonlyArray<ServiceOffer>;
};

export type QueryBudgetArgs = {
  id: Scalars['ID'];
};

export type QuerySearchServicesArgs = {
  text: Scalars['String'];
};

export type QuerySearchPassengersArgs = {
  email: Scalars['String'];
};

export type QuerySearchDriversArgs = {
  text?: InputMaybe<Scalars['String']>;
  drivingCompanyId?: InputMaybe<Scalars['String']>;
};

export type QueryPassengersForUserArgs = {
  id: Scalars['ID'];
};

export type QueryPassengerArgs = {
  id: Scalars['ID'];
};

export type QueryServiceArgs = {
  id: Scalars['ID'];
};

export type QueryServicesArgs = {
  departureDateMin?: InputMaybe<Scalars['String']>;
  departureDateMax?: InputMaybe<Scalars['String']>;
};

export type QueryClientArgs = {
  id?: InputMaybe<Scalars['ID']>;
  departureDateMin?: InputMaybe<Scalars['String']>;
  departureDateMax?: InputMaybe<Scalars['String']>;
};

export type QueryClientEmployeeArgs = {
  id: Scalars['ID'];
};

export type QueryDriversByDrivingCompanyArgs = {
  drivingCompanyId: Scalars['ID'];
};

export type QueryIsEmailUsedForAuthenticationArgs = {
  email: Scalars['String'];
};

export type QueryIsPhoneUsedForAuthenticationArgs = {
  phone: Scalars['String'];
};

export type QueryUserByEmailArgs = {
  email: Scalars['String'];
};

export type QueryDriverByEmailArgs = {
  email: Scalars['String'];
};

export type QueryDriverArgs = {
  id?: InputMaybe<Scalars['ID']>;
  departureDateMin?: InputMaybe<Scalars['String']>;
  departureDateMax?: InputMaybe<Scalars['String']>;
};

export type QueryDrivingCompanyArgs = {
  id: Scalars['ID'];
};

export type QueryVehicleArgs = {
  id: Scalars['ID'];
};

export type QueryVehiclesArgs = {
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type QueryVehicleBrandArgs = {
  id: Scalars['ID'];
};

export type QueryVehicleModelArgs = {
  id: Scalars['ID'];
};

export type QueryTemplateArgs = {
  id: Scalars['Int'];
};

export type QueryRateArgs = {
  id: Scalars['ID'];
};

export type QueryComputeItineraryPriceArgs = {
  departure?: InputMaybe<DepartureOrArrivalInput>;
  arrival?: InputMaybe<DepartureOrArrivalInput>;
  provision?: InputMaybe<DepartureOrArrivalInput>;
  serviceTypeId: Scalars['String'];
  clientId: Scalars['String'];
  vehicleTypeId: Scalars['String'];
  vehicleModelId?: InputMaybe<Scalars['String']>;
  vehicleBrandId?: InputMaybe<Scalars['String']>;
  hours?: InputMaybe<Scalars['Int']>;
  dinner?: InputMaybe<Scalars['Boolean']>;
  capacity?: InputMaybe<Scalars['Int']>;
};

export type FrontendVersion = {
  readonly __typename?: 'FrontendVersion';
  readonly version: Scalars['String'];
};

export type BudgetConfig = {
  readonly __typename?: 'BudgetConfig';
  readonly status: ReadonlyArray<BudgetStatus>;
  readonly metThrough: ReadonlyArray<BudgetMetThrough>;
  readonly requestSource: ReadonlyArray<BudgetRequestSource>;
  readonly companies: ReadonlyArray<Company>;
  readonly templates: ReadonlyArray<BudgetTemplate>;
  readonly vatTypes: ReadonlyArray<Vat>;
  readonly driverFeatures: ReadonlyArray<ItineraryFeature>;
  readonly vehicleFeatures: ReadonlyArray<ItineraryFeature>;
};

export type BudgetStatus = {
  readonly __typename?: 'BudgetStatus';
  readonly code: Scalars['String'];
  readonly locale: ReadonlyArray<Locale>;
};

export type Locale = {
  readonly __typename?: 'Locale';
  readonly code: CountryLocales;
  readonly value: Scalars['String'];
};

export enum CountryLocales {
  EsEs = 'esES',
}

export type BudgetMetThrough = {
  readonly __typename?: 'BudgetMetThrough';
  readonly code: Scalars['String'];
  readonly locale: ReadonlyArray<Locale>;
};

export type BudgetRequestSource = {
  readonly __typename?: 'BudgetRequestSource';
  readonly code: Scalars['String'];
  readonly locale: ReadonlyArray<Locale>;
};

export type Company = {
  readonly __typename?: 'Company';
  readonly code: CompanyCode;
  readonly data: CompanyData;
};

export enum CompanyCode {
  MiniBusesVipsBarcelona = 'MINI_BUSES_VIPS_BARCELONA',
  MiniVipsCarDrivers = 'MINI_VIPS_CAR_DRIVERS',
}

export type CompanyData = {
  readonly __typename?: 'CompanyData';
  readonly cif: Scalars['String'];
  readonly name: Scalars['String'];
  readonly address: Scalars['String'];
  readonly zip: Scalars['String'];
  readonly location: Scalars['String'];
  readonly region: Scalars['String'];
  readonly phone: Scalars['String'];
  readonly fax: Scalars['String'];
  readonly email: Scalars['String'];
  readonly web: Scalars['String'];
  readonly country: CompanyDataCountry;
};

export type CompanyDataCountry = {
  readonly __typename?: 'CompanyDataCountry';
  readonly esES: Scalars['String'];
  readonly enEN: Scalars['String'];
  readonly enUS: Scalars['String'];
};

export type BudgetTemplate = {
  readonly __typename?: 'BudgetTemplate';
  readonly code: Scalars['String'];
  readonly translation: Scalars['String'];
  readonly template: Template;
};

export type Template = {
  readonly __typename?: 'Template';
  readonly heading: Scalars['String'];
  readonly body: Scalars['String'];
};

export type Vat = {
  readonly __typename?: 'VAT';
  readonly translation: Scalars['String'];
  readonly code: Scalars['String'];
  readonly value: Scalars['Float'];
};

export type ItineraryFeature = {
  readonly __typename?: 'ItineraryFeature';
  readonly id: Scalars['ID'];
  readonly description: Scalars['String'];
  readonly required: Scalars['Boolean'];
};

export type Budget = {
  readonly __typename?: 'Budget';
  readonly id: Scalars['ID'];
  readonly readableId: Scalars['String'];
  readonly validityPeriodStart: Scalars['String'];
  readonly validityPeriodEnd: Scalars['String'];
  readonly creationDate: Scalars['String'];
  readonly attendedBy?: Maybe<Scalars['String']>;
  readonly client: Client;
  readonly status: BudgetStatus;
  readonly company: Company;
  readonly reference?: Maybe<Scalars['String']>;
  readonly contact?: Maybe<Contact>;
  readonly metThrough?: Maybe<BudgetMetThrough>;
  readonly requestSource?: Maybe<BudgetRequestSource>;
  readonly templateHeading?: Maybe<Scalars['String']>;
  readonly templateBody?: Maybe<Scalars['String']>;
  readonly itineraries: ReadonlyArray<Itinerary>;
};

export type Client = {
  readonly __typename?: 'Client';
  readonly id: Scalars['ID'];
  readonly services: ReadonlyArray<Service>;
  readonly nif?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly phone?: Maybe<Scalars['String']>;
  readonly alternatePhone?: Maybe<Scalars['String']>;
  readonly volcanoClientId?: Maybe<Scalars['String']>;
  readonly volcanoEmail?: Maybe<Scalars['String']>;
  readonly template?: Maybe<RichTemplate>;
  readonly email?: Maybe<Scalars['String']>;
  readonly communicationLocale?: Maybe<Scalars['String']>;
  readonly firebaseId?: Maybe<Scalars['String']>;
  readonly hasWebPanelAccount?: Maybe<Scalars['Boolean']>;
  readonly loginEnabled?: Maybe<Scalars['Boolean']>;
  readonly rate?: Maybe<Rate>;
};

export type Service = {
  readonly __typename?: 'Service';
  readonly id: Scalars['ID'];
  readonly volcanoServiceId?: Maybe<Scalars['String']>;
  readonly providerId?: Maybe<Scalars['Int']>;
  readonly budgetReadableId?: Maybe<Scalars['String']>;
  readonly notes?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
  readonly typeId?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
  readonly disturbance?: Maybe<Scalars['Boolean']>;
  readonly description?: Maybe<Scalars['String']>;
  readonly reference?: Maybe<Scalars['String']>;
  readonly serieFact?: Maybe<Scalars['String']>;
  readonly itineraryDescription?: Maybe<Scalars['String']>;
  readonly numOfPassengers?: Maybe<Scalars['Int']>;
  readonly requestedVehicleDescription?: Maybe<Scalars['String']>;
  readonly vehicle?: Maybe<Vehicle>;
  readonly departure?: Maybe<DepartureOrArrival>;
  readonly arrival?: Maybe<DepartureOrArrival>;
  readonly presentationTime?: Maybe<Scalars['String']>;
  readonly driver?: Maybe<Driver>;
  readonly alternateDriver?: Maybe<Driver>;
  readonly client?: Maybe<Client>;
  readonly passengers: ReadonlyArray<Passenger>;
  readonly drivers: ReadonlyArray<Driver>;
  readonly drivingCompany?: Maybe<DrivingCompany>;
  readonly offers: ReadonlyArray<ServiceOffer>;
};

export type Vehicle = {
  readonly __typename?: 'Vehicle';
  readonly id: Scalars['ID'];
  readonly volcanoVehicleId?: Maybe<Scalars['String']>;
  readonly origin?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
  readonly typeID?: Maybe<Scalars['Int']>;
  readonly typeDescription?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
  readonly licensePlate?: Maybe<Scalars['String']>;
  readonly location?: Maybe<Location>;
  readonly brand?: Maybe<Scalars['String']>;
  readonly model?: Maybe<Scalars['String']>;
};

export type Location = {
  readonly __typename?: 'Location';
  readonly longitude?: Maybe<Scalars['String']>;
  readonly latitude?: Maybe<Scalars['String']>;
};

export type DepartureOrArrival = {
  readonly __typename?: 'DepartureOrArrival';
  readonly date?: Maybe<Scalars['String']>;
  readonly address?: Maybe<Scalars['String']>;
  readonly lat?: Maybe<Scalars['Float']>;
  readonly lon?: Maybe<Scalars['Float']>;
  readonly time?: Maybe<Scalars['String']>;
};

export type Driver = {
  readonly __typename?: 'Driver';
  readonly id: Scalars['ID'];
  readonly providerId?: Maybe<Scalars['ID']>;
  readonly received?: Maybe<Scalars['Boolean']>;
  readonly firebaseId?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly phone?: Maybe<Scalars['String']>;
  readonly alternatePhone?: Maybe<Scalars['String']>;
  readonly loginMethod?: Maybe<LoginMethod>;
  readonly loginEnabled: Scalars['Boolean'];
  readonly email?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
  readonly notificationsToken?: Maybe<Scalars['String']>;
  readonly volcanoEmail?: Maybe<Scalars['String']>;
  readonly volcanoDriverId?: Maybe<Scalars['String']>;
  readonly hasLoginCredentials?: Maybe<Scalars['Boolean']>;
  readonly inPrisma?: Maybe<Scalars['Boolean']>;
  readonly inVolcano?: Maybe<Scalars['Boolean']>;
  readonly services: ReadonlyArray<Service>;
  readonly profilePicURI?: Maybe<Scalars['String']>;
  readonly communicationLocale?: Maybe<Scalars['String']>;
  readonly drivingCompany?: Maybe<DrivingCompany>;
  readonly location?: Maybe<Location>;
  readonly serviceOffersBids: ReadonlyArray<ServiceOfferBid>;
};

export enum LoginMethod {
  Phone = 'PHONE',
  Email = 'EMAIL',
}

export type DrivingCompany = {
  readonly __typename?: 'DrivingCompany';
  readonly id: Scalars['ID'];
  readonly volcanoId?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly phone?: Maybe<Scalars['String']>;
  readonly drivers: ReadonlyArray<Driver>;
  readonly emailHasWebPanelAccount: Scalars['Boolean'];
  readonly teamMemberships?: Maybe<ReadonlyArray<DrivingCompanyTeamMembership>>;
};

export type DrivingCompanyTeamMembership = {
  readonly __typename?: 'DrivingCompanyTeamMembership';
  readonly id: Scalars['ID'];
  readonly createdAt: Scalars['String'];
  readonly updatedAt: Scalars['String'];
  readonly role: Scalars['String'];
  readonly drivingCompany: DrivingCompany;
  readonly member: User;
};

export type User = {
  readonly __typename?: 'User';
  readonly id: Scalars['ID'];
  readonly name?: Maybe<Scalars['String']>;
  readonly volcanoClientId?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly isAdmin: Scalars['Boolean'];
  readonly isClient: Scalars['Boolean'];
  readonly client?: Maybe<Client>;
  readonly clientRole?: Maybe<Scalars['String']>;
  readonly disabled?: Maybe<Scalars['Boolean']>;
  readonly hasWebPanelAccount: Scalars['Boolean'];
};

export type ServiceOfferBid = {
  readonly __typename?: 'ServiceOfferBid';
  readonly id: Scalars['ID'];
  readonly createdAt: Scalars['String'];
  readonly updatedAt: Scalars['String'];
  readonly drivingCompany: DrivingCompany;
  readonly status: ServiceOfferUpdateStatus;
};

export enum ServiceOfferUpdateStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

export type Passenger = {
  readonly __typename?: 'Passenger';
  readonly id: Scalars['ID'];
  readonly email: Scalars['String'];
  readonly phone?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
};

export type ServiceOffer = {
  readonly __typename?: 'ServiceOffer';
  readonly id: Scalars['ID'];
  readonly createdAt: Scalars['String'];
  readonly updatedAt: Scalars['String'];
  readonly service?: Maybe<Service>;
  readonly offeredBy: User;
  readonly bids: ReadonlyArray<ServiceOfferBid>;
};

export type RichTemplate = {
  readonly __typename?: 'RichTemplate';
  readonly id: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly createdAt: Scalars['Date'];
  readonly updatedAt: Scalars['Date'];
  readonly heading: Scalars['JSONObject'];
  readonly body: Scalars['JSONObject'];
  readonly createdBy: User;
  readonly numClients: Scalars['Int'];
  readonly clients: ReadonlyArray<User>;
};

export type Rate = {
  readonly __typename?: 'Rate';
  readonly id: Scalars['ID'];
  readonly isGlobal: Scalars['Boolean'];
  readonly createdAt: Scalars['String'];
  readonly updatedAt: Scalars['String'];
  readonly name: Scalars['String'];
  readonly serviceTypes: ReadonlyArray<RateServiceType>;
  readonly vehiclePriceVariables: ReadonlyArray<VehiclePriceVariable>;
  readonly vehicleCategories: ReadonlyArray<VehicleCategory>;
  readonly clients: ReadonlyArray<Client>;
};

export type RateServiceType = {
  readonly __typename?: 'RateServiceType';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly description?: Maybe<Scalars['String']>;
  readonly subtypes: ReadonlyArray<ServiceSubtype>;
};

export type ServiceSubtype = {
  readonly __typename?: 'ServiceSubtype';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly description?: Maybe<Scalars['String']>;
  readonly dinner: Scalars['Boolean'];
  readonly hours: Scalars['Int'];
  readonly fulfillingCondition?: Maybe<FulfillingCondition>;
  readonly priceConditions?: Maybe<PriceCondition>;
};

export type FulfillingCondition = {
  readonly __typename?: 'FulfillingCondition';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly description?: Maybe<Scalars['String']>;
  readonly threshold?: Maybe<Scalars['Float']>;
  readonly conditionType: Scalars['String'];
  readonly conditionActivation?: Maybe<Scalars['String']>;
};

export type PriceCondition = {
  readonly __typename?: 'PriceCondition';
  readonly vehicle: ReadonlyArray<VehiclePriceCondition>;
};

export type VehiclePriceCondition = {
  readonly __typename?: 'VehiclePriceCondition';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly description?: Maybe<Scalars['String']>;
  readonly basePrice: Scalars['Float'];
  readonly extraHourPrice?: Maybe<Scalars['Float']>;
  readonly numPassengers?: Maybe<Scalars['Int']>;
  readonly vehicleTypeId?: Maybe<Scalars['String']>;
  readonly vehicleModelId?: Maybe<Scalars['String']>;
  readonly vehicleBrandId?: Maybe<Scalars['String']>;
};

export type VehiclePriceVariable = {
  readonly __typename?: 'VehiclePriceVariable';
  readonly id: Scalars['ID'];
  readonly vehicleModelId?: Maybe<Scalars['String']>;
  readonly vehicleBrandId?: Maybe<Scalars['String']>;
  readonly vehicleTypeId?: Maybe<Scalars['String']>;
  readonly extraPricePerKm: Scalars['Float'];
  readonly tollPricePerKm: Scalars['Float'];
  readonly airportPrice: Scalars['Float'];
  readonly parkingMontserrat: Scalars['Float'];
  readonly paxNumber: Scalars['Int'];
  readonly extraHourPrice: Scalars['Float'];
};

export type VehicleCategory = {
  readonly __typename?: 'VehicleCategory';
  readonly id: Scalars['ID'];
  readonly vehicleModel?: Maybe<VehicleModel>;
  readonly vehicleBrand?: Maybe<VehicleBrandModels>;
  readonly vehicleType?: Maybe<VehicleType>;
  readonly vehicleCapacity?: Maybe<Scalars['Int']>;
  readonly name: Scalars['String'];
  readonly description?: Maybe<Scalars['String']>;
};

export type VehicleModel = {
  readonly __typename?: 'VehicleModel';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type VehicleBrandModels = {
  readonly __typename?: 'VehicleBrandModels';
  readonly id: Scalars['ID'];
  readonly brand: Scalars['String'];
  readonly models: ReadonlyArray<VehicleModel>;
};

export type VehicleType = {
  readonly __typename?: 'VehicleType';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly category: Scalars['String'];
};

export type Contact = {
  readonly __typename?: 'Contact';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly phone?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
};

export type Itinerary = {
  readonly __typename?: 'Itinerary';
  readonly id: Scalars['ID'];
  readonly realized: Scalars['Boolean'];
  readonly amounts: ReadonlyArray<Amount>;
  readonly departureTime: Scalars['String'];
  readonly arrivalTime: Scalars['String'];
  readonly presentationTime: Scalars['String'];
  readonly serviceTypeId: Scalars['String'];
  readonly dinner: Scalars['Boolean'];
  readonly reference?: Maybe<Scalars['String']>;
  readonly departureGoogleMapsPlaceID?: Maybe<Scalars['String']>;
  readonly departureType?: Maybe<Scalars['String']>;
  readonly departureCity?: Maybe<Scalars['String']>;
  readonly departureAddress?: Maybe<Scalars['String']>;
  readonly departureLat: Scalars['Float'];
  readonly departureLon: Scalars['Float'];
  readonly provisionGoogleMapsPlaceID?: Maybe<Scalars['String']>;
  readonly provisionType?: Maybe<Scalars['String']>;
  readonly provisionCity?: Maybe<Scalars['String']>;
  readonly provisionAddress?: Maybe<Scalars['String']>;
  readonly provisionLat?: Maybe<Scalars['Float']>;
  readonly provisionLon?: Maybe<Scalars['Float']>;
  readonly arrivalGoogleMapsPlaceID?: Maybe<Scalars['String']>;
  readonly arrivalType?: Maybe<Scalars['String']>;
  readonly arrivalCity?: Maybe<Scalars['String']>;
  readonly arrivalAddress?: Maybe<Scalars['String']>;
  readonly arrivalLat: Scalars['Float'];
  readonly arrivalLon: Scalars['Float'];
  readonly numVehicles?: Maybe<Scalars['Int']>;
  readonly numPassengers?: Maybe<Scalars['Int']>;
  readonly itineraryDescription: Scalars['String'];
  readonly groupName?: Maybe<Scalars['String']>;
  readonly flightNumber?: Maybe<Scalars['String']>;
  readonly notes?: Maybe<Scalars['String']>;
  readonly driverFeatures: ReadonlyArray<ItineraryFeature>;
  readonly vehicleFeatures: ReadonlyArray<ItineraryFeature>;
  readonly vehicleCategory?: Maybe<VehicleCategory>;
};

export type Amount = {
  readonly __typename?: 'Amount';
  readonly id: Scalars['ID'];
  readonly vat: Scalars['Float'];
  readonly amount: Scalars['Float'];
  readonly concept?: Maybe<Scalars['String']>;
};

export type ServiceType = {
  readonly __typename?: 'ServiceType';
  readonly id: Scalars['String'];
  readonly typeId: Scalars['String'];
  readonly description: Scalars['String'];
  readonly name: Scalars['String'];
};

export type ClientEmployee = {
  readonly __typename?: 'ClientEmployee';
  readonly id: Scalars['ID'];
  readonly createdAt: Scalars['String'];
  readonly email?: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly phone?: Maybe<Scalars['String']>;
  readonly loginEnabled: Scalars['Boolean'];
  readonly hasWebPanelAccount: Scalars['Boolean'];
};

export type UserOrDriver = User | Driver;

export type DepartureOrArrivalInput = {
  readonly googleMapsPlaceID: Scalars['String'];
  readonly isAirport?: InputMaybe<Scalars['Boolean']>;
};

export type CandidateAmount = {
  readonly __typename?: 'CandidateAmount';
  readonly consult: Scalars['Boolean'];
  readonly amount: Scalars['Float'];
  readonly concept?: Maybe<Scalars['String']>;
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly confirmItinerary: Itinerary;
  readonly createContact: Contact;
  readonly createBudget: Budget;
  readonly updateBudget: Budget;
  readonly deleteBudget: DeleteResult;
  readonly createService?: Maybe<Service>;
  readonly editService: Service;
  readonly cancelService: ActionResult;
  readonly createClientEmployee: ClientEmployee;
  readonly updateClientEmployee: ClientEmployee;
  readonly deleteClientEmployee: DeleteResult;
  readonly createClient: Client;
  readonly updateClient: Client;
  readonly deleteClient: DeleteResult;
  readonly sendPasswordResetEmail: ActionResult;
  readonly createAdmin: Admin;
  readonly giveDriverAccessToApp: Driver;
  readonly createDriver?: Maybe<Driver>;
  readonly updateDriver: Driver;
  readonly deleteDriver: DeleteResult;
  readonly updateUser: User;
  readonly sendNotificationToServiceDriver: NotificationSendStatus;
  readonly connectMainDriverToService: Service;
  readonly createPassenger?: Maybe<Passenger>;
  readonly updatePassenger: Passenger;
  readonly removePassenger: Passenger;
  readonly createVehicleModel: VehicleModel;
  readonly updateVehicleModel: VehicleModel;
  readonly deleteVehicleModel: DeleteResult;
  readonly createVehicleBrand: VehicleBrandModels;
  readonly updateVehicleBrand: VehicleBrandModels;
  readonly deleteVehicleBrand: DeleteResult;
  readonly deleteVehiclePriceVariable: DeleteResult;
  readonly createVehiclePriceVariable: VehiclePriceVariable;
  readonly updateVehiclePriceVariable: VehiclePriceVariable;
  readonly updateServiceSubtype: ServiceSubtype;
  readonly updateVehiclePriceCondition: VehiclePriceCondition;
  readonly createVehiclePriceCondition: VehiclePriceCondition;
  readonly deleteVehiclePriceCondition: DeleteResult;
  readonly assignRateToClients: Rate;
  readonly disassignRateFromClients: Rate;
  readonly cloneRate: Rate;
  readonly updateRate: Rate;
  readonly deleteRate: Scalars['Boolean'];
  readonly createServiceOffer: ReadonlyArray<ServiceOffer>;
  readonly deleteServiceOffer: Scalars['Boolean'];
  readonly ServiceOffer: ServiceOfferNestedMutation;
  readonly DrivingCompany: DrivingCompanyNestedMutation;
  readonly createTemplate: RichTemplate;
  readonly duplicateTemplate: RichTemplate;
  readonly updateTemplate: RichTemplate;
  readonly deleteTemplate: Scalars['Boolean'];
  readonly assignTemplateToClients: RichTemplate;
  readonly disassociateTemplateFromClients: RichTemplate;
};

export type MutationConfirmItineraryArgs = {
  id: Scalars['ID'];
};

export type MutationCreateContactArgs = {
  name: Scalars['String'];
  email: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type MutationCreateBudgetArgs = {
  validityPeriodStart: Scalars['String'];
  validityPeriodEnd: Scalars['String'];
  creationDate: Scalars['String'];
  client: Scalars['String'];
  status: Scalars['String'];
  company: Scalars['String'];
  contactId?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
  metThrough?: InputMaybe<Scalars['String']>;
  requestSource?: InputMaybe<Scalars['String']>;
  templateHeading?: InputMaybe<Scalars['String']>;
  templateBody?: InputMaybe<Scalars['String']>;
  itineraries?: InputMaybe<ReadonlyArray<ItineraryInput>>;
};

export type MutationUpdateBudgetArgs = {
  id: Scalars['ID'];
  creationDate: Scalars['String'];
  validityPeriodStart: Scalars['String'];
  validityPeriodEnd: Scalars['String'];
  client: Scalars['String'];
  status: Scalars['String'];
  company: Scalars['String'];
  contactId?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
  metThrough?: InputMaybe<Scalars['String']>;
  requestSource?: InputMaybe<Scalars['String']>;
  templateHeading?: InputMaybe<Scalars['String']>;
  templateBody?: InputMaybe<Scalars['String']>;
  itineraries?: InputMaybe<ReadonlyArray<ItineraryInput>>;
};

export type MutationDeleteBudgetArgs = {
  id: Scalars['ID'];
};

export type MutationCreateServiceArgs = {
  departureDate: Scalars['String'];
  departureTime: Scalars['String'];
  presentationTime: Scalars['String'];
  arrivalDate: Scalars['String'];
  arrivalTime: Scalars['String'];
  type: Scalars['String'];
  clientId?: InputMaybe<Scalars['String']>;
  mainDriverId?: InputMaybe<Scalars['String']>;
  secondaryDriverId?: InputMaybe<Scalars['String']>;
  vehicleId?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  numOfPassengers?: Scalars['Int'];
  description: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  flightNumber?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
  departureAddress?: InputMaybe<Scalars['String']>;
  departureLat?: InputMaybe<Scalars['Float']>;
  departureLon?: InputMaybe<Scalars['Float']>;
  arrivalAddress?: InputMaybe<Scalars['String']>;
  arrivalLat?: InputMaybe<Scalars['Float']>;
  arrivalLon?: InputMaybe<Scalars['Float']>;
  groupName?: InputMaybe<Scalars['String']>;
  groupOwner?: InputMaybe<Scalars['String']>;
};

export type MutationEditServiceArgs = {
  id: Scalars['ID'];
  volcanoServiceId: Scalars['String'];
  departureDate?: InputMaybe<Scalars['String']>;
  departureTime?: InputMaybe<Scalars['String']>;
  presentationTime?: InputMaybe<Scalars['String']>;
  arrivalDate?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  mainDriverId?: InputMaybe<Scalars['String']>;
  secondaryDriverId?: InputMaybe<Scalars['String']>;
  vehicleId?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  numOfPassengers?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  departureAddress?: InputMaybe<Scalars['String']>;
  departureLat?: InputMaybe<Scalars['Float']>;
  departureLon?: InputMaybe<Scalars['Float']>;
  arrivalAddress?: InputMaybe<Scalars['String']>;
  arrivalLat?: InputMaybe<Scalars['Float']>;
  arrivalLon?: InputMaybe<Scalars['Float']>;
};

export type MutationCancelServiceArgs = {
  id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};

export type MutationCreateClientEmployeeArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type MutationUpdateClientEmployeeArgs = {
  id: Scalars['ID'];
  data: UpdateClientEmployeeInput;
};

export type MutationDeleteClientEmployeeArgs = {
  id: Scalars['ID'];
};

export type MutationCreateClientArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
};

export type MutationUpdateClientArgs = {
  id?: InputMaybe<Scalars['String']>;
  volcanoClientId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  loginEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type MutationDeleteClientArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type MutationSendPasswordResetEmailArgs = {
  id: Scalars['ID'];
};

export type MutationCreateAdminArgs = {
  name: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type MutationGiveDriverAccessToAppArgs = {
  id: Scalars['ID'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type MutationCreateDriverArgs = {
  name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  notificationsToken?: InputMaybe<Scalars['String']>;
  volcanoDriverId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profilePicURI?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  drivingCompanyId?: InputMaybe<Scalars['String']>;
  loginMethod?: InputMaybe<LoginMethod>;
};

export type MutationUpdateDriverArgs = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  loginMethod?: InputMaybe<LoginMethod>;
  disableLogin?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  drivingCompanyId?: InputMaybe<Scalars['String']>;
  notificationsToken?: InputMaybe<Scalars['String']>;
  volcanoDriverId?: InputMaybe<Scalars['String']>;
  profilePicURI?: InputMaybe<Scalars['String']>;
  communicationLocale?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};

export type MutationDeleteDriverArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type MutationUpdateUserArgs = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
};

export type MutationSendNotificationToServiceDriverArgs = {
  serviceId: Scalars['String'];
  notificationTitle: Scalars['String'];
  notificationBody: Scalars['String'];
  notificationData?: InputMaybe<Scalars['String']>;
  notificationOptions?: InputMaybe<Scalars['String']>;
};

export type MutationConnectMainDriverToServiceArgs = {
  serviceId: Scalars['String'];
  driverId: Scalars['String'];
};

export type MutationCreatePassengerArgs = {
  email: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type MutationUpdatePassengerArgs = {
  id: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type MutationRemovePassengerArgs = {
  email: Scalars['String'];
};

export type MutationCreateVehicleModelArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type MutationUpdateVehicleModelArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type MutationDeleteVehicleModelArgs = {
  id: Scalars['ID'];
};

export type MutationCreateVehicleBrandArgs = {
  name: Scalars['String'];
};

export type MutationUpdateVehicleBrandArgs = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type MutationDeleteVehicleBrandArgs = {
  id: Scalars['ID'];
};

export type MutationDeleteVehiclePriceVariableArgs = {
  id: Scalars['ID'];
};

export type MutationCreateVehiclePriceVariableArgs = {
  rateId: Scalars['ID'];
  vehicleBrandId?: InputMaybe<Scalars['String']>;
  vehicleModelId?: InputMaybe<Scalars['String']>;
  vehicleTypeId?: InputMaybe<Scalars['String']>;
  extraKmPrice?: InputMaybe<Scalars['Float']>;
  extraHourPrice?: InputMaybe<Scalars['Float']>;
  extraTollPrice?: InputMaybe<Scalars['Float']>;
  airportPrice?: InputMaybe<Scalars['Float']>;
  parkingMontserratPrice?: InputMaybe<Scalars['Float']>;
  numPassengers?: InputMaybe<Scalars['Int']>;
};

export type MutationUpdateVehiclePriceVariableArgs = {
  id: Scalars['ID'];
  vehicleBrandId?: InputMaybe<Scalars['String']>;
  vehicleModelId?: InputMaybe<Scalars['String']>;
  vehicleTypeId?: InputMaybe<Scalars['String']>;
  extraKmPrice?: InputMaybe<Scalars['Float']>;
  extraTollPrice?: InputMaybe<Scalars['Float']>;
  airportPrice?: InputMaybe<Scalars['Float']>;
  extraHourPrice?: InputMaybe<Scalars['Float']>;
  parkingMontserratPrice?: InputMaybe<Scalars['Float']>;
  numPassengers?: InputMaybe<Scalars['Int']>;
};

export type MutationUpdateServiceSubtypeArgs = {
  id: Scalars['ID'];
  rateId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  distanceInMeters?: InputMaybe<Scalars['Float']>;
};

export type MutationUpdateVehiclePriceConditionArgs = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  vehicleModelId?: InputMaybe<Scalars['String']>;
  vehicleBrandId?: InputMaybe<Scalars['String']>;
  vehicleTypeId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  numPassengers?: InputMaybe<Scalars['Int']>;
  extraHourPrice?: InputMaybe<Scalars['Float']>;
};

export type MutationCreateVehiclePriceConditionArgs = {
  rateId: Scalars['String'];
  serviceSubtypeId: Scalars['ID'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  vehicleModelId?: InputMaybe<Scalars['String']>;
  vehicleBrandId?: InputMaybe<Scalars['String']>;
  vehicleTypeId?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  numPassengers?: InputMaybe<Scalars['Int']>;
  extraHourPrice?: InputMaybe<Scalars['Float']>;
};

export type MutationDeleteVehiclePriceConditionArgs = {
  id: Scalars['ID'];
};

export type MutationAssignRateToClientsArgs = {
  clients: ReadonlyArray<Scalars['String']>;
  rateId: Scalars['ID'];
};

export type MutationDisassignRateFromClientsArgs = {
  clients: ReadonlyArray<Scalars['String']>;
  rateId: Scalars['ID'];
};

export type MutationCloneRateArgs = {
  rateToClone: Scalars['ID'];
  name: Scalars['String'];
};

export type MutationUpdateRateArgs = {
  rate: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type MutationDeleteRateArgs = {
  rate: Scalars['ID'];
};

export type MutationCreateServiceOfferArgs = {
  serviceIds: ReadonlyArray<Scalars['ID']>;
};

export type MutationDeleteServiceOfferArgs = {
  ids: ReadonlyArray<Scalars['ID']>;
};

export type MutationServiceOfferArgs = {
  id: Scalars['ID'];
};

export type MutationDrivingCompanyArgs = {
  id: Scalars['ID'];
};

export type MutationCreateTemplateArgs = {
  name: Scalars['String'];
  heading: Scalars['JSONObject'];
  body: Scalars['JSONObject'];
};

export type MutationDuplicateTemplateArgs = {
  id: Scalars['Int'];
};

export type MutationUpdateTemplateArgs = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  heading?: InputMaybe<Scalars['JSONObject']>;
  body?: InputMaybe<Scalars['JSONObject']>;
};

export type MutationDeleteTemplateArgs = {
  id: Scalars['Int'];
};

export type MutationAssignTemplateToClientsArgs = {
  clients: ReadonlyArray<Scalars['String']>;
  templateId: Scalars['Int'];
};

export type MutationDisassociateTemplateFromClientsArgs = {
  clients: ReadonlyArray<Scalars['String']>;
  templateId: Scalars['Int'];
};

export type ItineraryInput = {
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly departureTime: Scalars['String'];
  readonly arrivalTime: Scalars['String'];
  readonly serviceTypeId: Scalars['String'];
  readonly presentationTime: Scalars['String'];
  readonly dinner?: InputMaybe<Scalars['Boolean']>;
  readonly reference?: InputMaybe<Scalars['String']>;
  readonly itineraryDescription?: InputMaybe<Scalars['String']>;
  readonly departureCity?: InputMaybe<Scalars['String']>;
  readonly departureGoogleMapsPlaceID?: InputMaybe<Scalars['String']>;
  readonly departureType?: InputMaybe<Scalars['String']>;
  readonly departureAddress?: InputMaybe<Scalars['String']>;
  readonly departureLat?: InputMaybe<Scalars['Float']>;
  readonly departureLon?: InputMaybe<Scalars['Float']>;
  readonly provisionCity?: InputMaybe<Scalars['String']>;
  readonly provisionGoogleMapsPlaceID?: InputMaybe<Scalars['String']>;
  readonly provisionType?: InputMaybe<Scalars['String']>;
  readonly provisionAddress?: InputMaybe<Scalars['String']>;
  readonly provisionLat?: InputMaybe<Scalars['Float']>;
  readonly provisionLon?: InputMaybe<Scalars['Float']>;
  readonly arrivalCity?: InputMaybe<Scalars['String']>;
  readonly arrivalGoogleMapsPlaceID?: InputMaybe<Scalars['String']>;
  readonly arrivalType?: InputMaybe<Scalars['String']>;
  readonly arrivalAddress?: InputMaybe<Scalars['String']>;
  readonly arrivalLat?: InputMaybe<Scalars['Float']>;
  readonly arrivalLon?: InputMaybe<Scalars['Float']>;
  readonly numVehicles?: InputMaybe<Scalars['Int']>;
  readonly numPassengers?: InputMaybe<Scalars['Int']>;
  readonly vehicleCategoryId?: InputMaybe<Scalars['String']>;
  readonly groupName?: InputMaybe<Scalars['String']>;
  readonly flightNumber?: InputMaybe<Scalars['String']>;
  readonly notes?: InputMaybe<Scalars['String']>;
  readonly amounts?: InputMaybe<ReadonlyArray<AmountInput>>;
  readonly driverFeatures?: InputMaybe<ReadonlyArray<ItineraryFeatureInput>>;
  readonly vehicleFeatures?: InputMaybe<ReadonlyArray<ItineraryFeatureInput>>;
};

export type AmountInput = {
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly concept?: InputMaybe<Scalars['String']>;
  readonly amount: Scalars['Float'];
  readonly vat: Scalars['Float'];
};

export type ItineraryFeatureInput = {
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly description: Scalars['String'];
  readonly required: Scalars['Boolean'];
};

export type DeleteResult = {
  readonly __typename?: 'DeleteResult';
  readonly deleted: Scalars['Boolean'];
  readonly reason?: Maybe<Scalars['String']>;
};

export type ActionResult = {
  readonly __typename?: 'ActionResult';
  readonly success: Scalars['Boolean'];
  readonly reason?: Maybe<Scalars['String']>;
};

export type UpdateClientEmployeeInput = {
  readonly email: Scalars['String'];
  readonly name: Scalars['String'];
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly disableLogin?: InputMaybe<Scalars['Boolean']>;
};

export type Admin = {
  readonly __typename?: 'Admin';
  readonly id: Scalars['ID'];
  readonly firebaseId: Scalars['String'];
  readonly isAdmin: Scalars['Boolean'];
};

export type NotificationSendStatus = {
  readonly __typename?: 'NotificationSendStatus';
  readonly sent: Scalars['Boolean'];
};

export type ServiceOfferNestedMutation = {
  readonly __typename?: 'ServiceOfferNestedMutation';
  readonly delete?: Maybe<DeleteResult>;
  readonly bid?: Maybe<ServiceOffer>;
  readonly unbid?: Maybe<ServiceOffer>;
  readonly acceptBid?: Maybe<ServiceOffer>;
  readonly rejectBid?: Maybe<ServiceOffer>;
  readonly ignoreBid?: Maybe<ServiceOffer>;
};

export type ServiceOfferNestedMutationAcceptBidArgs = {
  id: Scalars['ID'];
};

export type ServiceOfferNestedMutationRejectBidArgs = {
  id: Scalars['ID'];
};

export type ServiceOfferNestedMutationIgnoreBidArgs = {
  id: Scalars['ID'];
};

export type DrivingCompanyNestedMutation = {
  readonly __typename?: 'DrivingCompanyNestedMutation';
  readonly Membership: DrivingCompanyMembershipNestedMutation;
  readonly createTeamMembership: DrivingCompany;
};

export type DrivingCompanyNestedMutationMembershipArgs = {
  id: Scalars['ID'];
};

export type DrivingCompanyNestedMutationCreateTeamMembershipArgs = {
  email: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  role: DrivingCompanyTeamMemberShipRole;
};

export type DrivingCompanyMembershipNestedMutation = {
  readonly __typename?: 'DrivingCompanyMembershipNestedMutation';
  readonly update: DrivingCompany;
};

export type DrivingCompanyMembershipNestedMutationUpdateArgs = {
  role?: InputMaybe<DrivingCompanyTeamMemberShipRole>;
};

export enum DrivingCompanyTeamMemberShipRole {
  Admin = 'ADMIN',
  Employee = 'EMPLOYEE',
}

export type Subscription = {
  readonly __typename?: 'Subscription';
  readonly onUpdateMe: User;
  readonly onDriverLocationUpdate: Driver;
  readonly newBudget: Budget;
  readonly onUpdateBudget: Budget;
  readonly onNewService: Service;
  readonly onUpdateService: Service;
  readonly onNewClient: Client;
  readonly onNewPassenger: Passenger;
  readonly onUpdateClient: Client;
  readonly onNewDriver: Driver;
  readonly onAnyDriverLocationUpdate: Driver;
};

export type SubscriptionOnDriverLocationUpdateArgs = {
  id: Scalars['ID'];
};

export type CalculatedAmountValue = {
  readonly __typename?: 'CalculatedAmountValue';
  readonly amount: Scalars['Float'];
};

export type ContactInput = {
  readonly id?: InputMaybe<Scalars['ID']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
};

export type GetFrontendVersionQueryVariables = Exact<{ [key: string]: never }>;

export type GetFrontendVersionQuery = {
  readonly __typename?: 'Query';
  readonly getFrontendVersion: {
    readonly __typename?: 'FrontendVersion';
    readonly version: string;
  };
};

export type IsEmailUsedForAuthQueryVariables = Exact<{
  email: Scalars['String'];
}>;

export type IsEmailUsedForAuthQuery = {
  readonly __typename?: 'Query';
  readonly isEmailUsedForAuthentication: boolean;
};

export type IsPhoneUsedForAuthenticationQueryVariables = Exact<{
  phone: Scalars['String'];
}>;

export type IsPhoneUsedForAuthenticationQuery = {
  readonly __typename?: 'Query';
  readonly isPhoneUsedForAuthentication: boolean;
};

export type DeleteABudgetMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteABudgetMutation = {
  readonly __typename?: 'Mutation';
  readonly deleteBudget: {
    readonly __typename?: 'DeleteResult';
    readonly deleted: boolean;
  };
};

export type CreateBudgetMutationVariables = Exact<{
  validityPeriodStart: Scalars['String'];
  validityPeriodEnd: Scalars['String'];
  creationDate: Scalars['String'];
  client: Scalars['String'];
  status: Scalars['String'];
  company: Scalars['String'];
  contactId?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
  metThrough?: InputMaybe<Scalars['String']>;
  requestSource?: InputMaybe<Scalars['String']>;
  templateHeading?: InputMaybe<Scalars['String']>;
  templateBody?: InputMaybe<Scalars['String']>;
  itineraries?: InputMaybe<ReadonlyArray<ItineraryInput> | ItineraryInput>;
}>;

export type CreateBudgetMutation = {
  readonly __typename?: 'Mutation';
  readonly createBudget: {
    readonly __typename?: 'Budget';
    readonly id: string;
    readonly readableId: string;
    readonly validityPeriodStart: string;
    readonly validityPeriodEnd: string;
    readonly creationDate: string;
    readonly attendedBy?: string | null | undefined;
    readonly reference?: string | null | undefined;
    readonly templateHeading?: string | null | undefined;
    readonly templateBody?: string | null | undefined;
    readonly client: {
      readonly __typename?: 'Client';
      readonly id: string;
      readonly nif?: string | null | undefined;
      readonly name?: string | null | undefined;
      readonly phone?: string | null | undefined;
      readonly alternatePhone?: string | null | undefined;
      readonly volcanoClientId?: string | null | undefined;
      readonly volcanoEmail?: string | null | undefined;
      readonly email?: string | null | undefined;
      readonly communicationLocale?: string | null | undefined;
      readonly firebaseId?: string | null | undefined;
      readonly hasWebPanelAccount?: boolean | null | undefined;
      readonly loginEnabled?: boolean | null | undefined;
      readonly template?:
        | {
            readonly __typename?: 'RichTemplate';
            readonly id: number;
            readonly name: string;
            readonly heading: Record<string, unknown>;
            readonly body: Record<string, unknown>;
          }
        | null
        | undefined;
    };
    readonly status: {
      readonly __typename?: 'BudgetStatus';
      readonly code: string;
    };
    readonly company: {
      readonly __typename?: 'Company';
      readonly code: CompanyCode;
    };
    readonly contact?:
      | {
          readonly __typename?: 'Contact';
          readonly id: string;
          readonly name: string;
          readonly phone?: string | null | undefined;
          readonly email?: string | null | undefined;
        }
      | null
      | undefined;
    readonly metThrough?:
      | { readonly __typename?: 'BudgetMetThrough'; readonly code: string }
      | null
      | undefined;
    readonly requestSource?:
      | { readonly __typename?: 'BudgetRequestSource'; readonly code: string }
      | null
      | undefined;
    readonly itineraries: ReadonlyArray<{
      readonly __typename?: 'Itinerary';
      readonly id: string;
      readonly realized: boolean;
      readonly departureTime: string;
      readonly arrivalTime: string;
      readonly presentationTime: string;
      readonly serviceTypeId: string;
      readonly dinner: boolean;
      readonly reference?: string | null | undefined;
      readonly departureGoogleMapsPlaceID?: string | null | undefined;
      readonly departureType?: string | null | undefined;
      readonly departureCity?: string | null | undefined;
      readonly departureAddress?: string | null | undefined;
      readonly departureLat: number;
      readonly departureLon: number;
      readonly provisionGoogleMapsPlaceID?: string | null | undefined;
      readonly provisionType?: string | null | undefined;
      readonly provisionCity?: string | null | undefined;
      readonly provisionAddress?: string | null | undefined;
      readonly provisionLat?: number | null | undefined;
      readonly provisionLon?: number | null | undefined;
      readonly arrivalGoogleMapsPlaceID?: string | null | undefined;
      readonly arrivalType?: string | null | undefined;
      readonly arrivalCity?: string | null | undefined;
      readonly arrivalAddress?: string | null | undefined;
      readonly arrivalLat: number;
      readonly arrivalLon: number;
      readonly numVehicles?: number | null | undefined;
      readonly numPassengers?: number | null | undefined;
      readonly itineraryDescription: string;
      readonly groupName?: string | null | undefined;
      readonly flightNumber?: string | null | undefined;
      readonly notes?: string | null | undefined;
      readonly vehicleCategory?:
        | {
            readonly __typename?: 'VehicleCategory';
            readonly id: string;
            readonly vehicleCapacity?: number | null | undefined;
            readonly name: string;
            readonly description?: string | null | undefined;
            readonly vehicleModel?:
              | { readonly __typename?: 'VehicleModel'; readonly id: string }
              | null
              | undefined;
            readonly vehicleBrand?:
              | {
                  readonly __typename?: 'VehicleBrandModels';
                  readonly id: string;
                }
              | null
              | undefined;
            readonly vehicleType?:
              | { readonly __typename?: 'VehicleType'; readonly id: string }
              | null
              | undefined;
          }
        | null
        | undefined;
    }>;
  };
};

export type ComputeItineraryPriceQueryVariables = Exact<{
  departure?: InputMaybe<DepartureOrArrivalInput>;
  arrival?: InputMaybe<DepartureOrArrivalInput>;
  provision?: InputMaybe<DepartureOrArrivalInput>;
  serviceTypeId: Scalars['String'];
  clientId: Scalars['String'];
  vehicleTypeId: Scalars['String'];
  vehicleModelId?: InputMaybe<Scalars['String']>;
  vehicleBrandId?: InputMaybe<Scalars['String']>;
  hours?: InputMaybe<Scalars['Int']>;
  dinner?: InputMaybe<Scalars['Boolean']>;
  capacity?: InputMaybe<Scalars['Int']>;
}>;

export type ComputeItineraryPriceQuery = {
  readonly __typename?: 'Query';
  readonly computeItineraryPrice: {
    readonly __typename?: 'CandidateAmount';
    readonly consult: boolean;
    readonly amount: number;
    readonly concept?: string | null | undefined;
  };
};

export type OnNewBudgetSubscriptionCustomSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnNewBudgetSubscriptionCustomSubscription = {
  readonly __typename?: 'Subscription';
  readonly newBudget: {
    readonly __typename?: 'Budget';
    readonly id: string;
    readonly attendedBy?: string | null | undefined;
    readonly readableId: string;
    readonly validityPeriodStart: string;
    readonly validityPeriodEnd: string;
    readonly creationDate: string;
    readonly reference?: string | null | undefined;
    readonly templateHeading?: string | null | undefined;
    readonly templateBody?: string | null | undefined;
    readonly client: {
      readonly __typename?: 'Client';
      readonly id: string;
      readonly name?: string | null | undefined;
      readonly volcanoClientId?: string | null | undefined;
      readonly nif?: string | null | undefined;
      readonly phone?: string | null | undefined;
      readonly alternatePhone?: string | null | undefined;
      readonly email?: string | null | undefined;
      readonly volcanoEmail?: string | null | undefined;
      readonly template?:
        | {
            readonly __typename?: 'RichTemplate';
            readonly id: number;
            readonly name: string;
            readonly heading: Record<string, unknown>;
            readonly body: Record<string, unknown>;
          }
        | null
        | undefined;
    };
    readonly status: {
      readonly __typename?: 'BudgetStatus';
      readonly code: string;
      readonly locale: ReadonlyArray<{
        readonly __typename?: 'Locale';
        readonly code: CountryLocales;
        readonly value: string;
      }>;
    };
    readonly company: {
      readonly __typename?: 'Company';
      readonly code: CompanyCode;
      readonly data: {
        readonly __typename?: 'CompanyData';
        readonly zip: string;
        readonly address: string;
        readonly cif: string;
        readonly email: string;
        readonly fax: string;
        readonly location: string;
        readonly name: string;
        readonly phone: string;
        readonly region: string;
        readonly web: string;
        readonly country: {
          readonly __typename?: 'CompanyDataCountry';
          readonly enEN: string;
          readonly enUS: string;
          readonly esES: string;
        };
      };
    };
    readonly contact?:
      | {
          readonly __typename?: 'Contact';
          readonly id: string;
          readonly name: string;
          readonly phone?: string | null | undefined;
          readonly email?: string | null | undefined;
        }
      | null
      | undefined;
    readonly metThrough?:
      | { readonly __typename?: 'BudgetMetThrough'; readonly code: string }
      | null
      | undefined;
    readonly requestSource?:
      | { readonly __typename?: 'BudgetRequestSource'; readonly code: string }
      | null
      | undefined;
    readonly itineraries: ReadonlyArray<{
      readonly __typename?: 'Itinerary';
      readonly id: string;
      readonly realized: boolean;
      readonly provisionGoogleMapsPlaceID?: string | null | undefined;
      readonly provisionAddress?: string | null | undefined;
      readonly provisionCity?: string | null | undefined;
      readonly provisionType?: string | null | undefined;
      readonly provisionLat?: number | null | undefined;
      readonly provisionLon?: number | null | undefined;
      readonly departureGoogleMapsPlaceID?: string | null | undefined;
      readonly departureAddress?: string | null | undefined;
      readonly departureCity?: string | null | undefined;
      readonly departureType?: string | null | undefined;
      readonly departureTime: string;
      readonly departureLat: number;
      readonly departureLon: number;
      readonly arrivalGoogleMapsPlaceID?: string | null | undefined;
      readonly arrivalLat: number;
      readonly arrivalLon: number;
      readonly arrivalAddress?: string | null | undefined;
      readonly arrivalCity?: string | null | undefined;
      readonly arrivalType?: string | null | undefined;
      readonly arrivalTime: string;
      readonly presentationTime: string;
      readonly serviceTypeId: string;
      readonly reference?: string | null | undefined;
      readonly numVehicles?: number | null | undefined;
      readonly numPassengers?: number | null | undefined;
      readonly itineraryDescription: string;
      readonly groupName?: string | null | undefined;
      readonly flightNumber?: string | null | undefined;
      readonly notes?: string | null | undefined;
      readonly amounts: ReadonlyArray<{
        readonly __typename?: 'Amount';
        readonly id: string;
        readonly amount: number;
        readonly vat: number;
        readonly concept?: string | null | undefined;
      }>;
      readonly driverFeatures: ReadonlyArray<{
        readonly __typename?: 'ItineraryFeature';
        readonly id: string;
        readonly description: string;
        readonly required: boolean;
      }>;
      readonly vehicleFeatures: ReadonlyArray<{
        readonly __typename?: 'ItineraryFeature';
        readonly id: string;
        readonly description: string;
        readonly required: boolean;
      }>;
      readonly vehicleCategory?:
        | {
            readonly __typename?: 'VehicleCategory';
            readonly id: string;
            readonly vehicleCapacity?: number | null | undefined;
            readonly name: string;
            readonly description?: string | null | undefined;
            readonly vehicleModel?:
              | { readonly __typename?: 'VehicleModel'; readonly id: string }
              | null
              | undefined;
            readonly vehicleBrand?:
              | {
                  readonly __typename?: 'VehicleBrandModels';
                  readonly id: string;
                }
              | null
              | undefined;
            readonly vehicleType?:
              | { readonly __typename?: 'VehicleType'; readonly id: string }
              | null
              | undefined;
          }
        | null
        | undefined;
    }>;
  };
};

export type OnUpdateBudgetSubscriptionCustomSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnUpdateBudgetSubscriptionCustomSubscription = {
  readonly __typename?: 'Subscription';
  readonly onUpdateBudget: {
    readonly __typename?: 'Budget';
    readonly id: string;
    readonly attendedBy?: string | null | undefined;
    readonly readableId: string;
    readonly validityPeriodStart: string;
    readonly validityPeriodEnd: string;
    readonly creationDate: string;
    readonly reference?: string | null | undefined;
    readonly templateHeading?: string | null | undefined;
    readonly templateBody?: string | null | undefined;
    readonly client: {
      readonly __typename?: 'Client';
      readonly id: string;
      readonly name?: string | null | undefined;
      readonly volcanoClientId?: string | null | undefined;
      readonly nif?: string | null | undefined;
      readonly phone?: string | null | undefined;
      readonly alternatePhone?: string | null | undefined;
      readonly email?: string | null | undefined;
      readonly volcanoEmail?: string | null | undefined;
      readonly template?:
        | {
            readonly __typename?: 'RichTemplate';
            readonly id: number;
            readonly name: string;
            readonly heading: Record<string, unknown>;
            readonly body: Record<string, unknown>;
          }
        | null
        | undefined;
    };
    readonly status: {
      readonly __typename?: 'BudgetStatus';
      readonly code: string;
      readonly locale: ReadonlyArray<{
        readonly __typename?: 'Locale';
        readonly code: CountryLocales;
        readonly value: string;
      }>;
    };
    readonly company: {
      readonly __typename?: 'Company';
      readonly code: CompanyCode;
      readonly data: {
        readonly __typename?: 'CompanyData';
        readonly zip: string;
        readonly address: string;
        readonly cif: string;
        readonly email: string;
        readonly fax: string;
        readonly location: string;
        readonly name: string;
        readonly phone: string;
        readonly region: string;
        readonly web: string;
        readonly country: {
          readonly __typename?: 'CompanyDataCountry';
          readonly enEN: string;
          readonly enUS: string;
          readonly esES: string;
        };
      };
    };
    readonly contact?:
      | {
          readonly __typename?: 'Contact';
          readonly id: string;
          readonly name: string;
          readonly phone?: string | null | undefined;
          readonly email?: string | null | undefined;
        }
      | null
      | undefined;
    readonly metThrough?:
      | { readonly __typename?: 'BudgetMetThrough'; readonly code: string }
      | null
      | undefined;
    readonly requestSource?:
      | { readonly __typename?: 'BudgetRequestSource'; readonly code: string }
      | null
      | undefined;
    readonly itineraries: ReadonlyArray<{
      readonly __typename?: 'Itinerary';
      readonly id: string;
      readonly realized: boolean;
      readonly provisionGoogleMapsPlaceID?: string | null | undefined;
      readonly provisionType?: string | null | undefined;
      readonly provisionCity?: string | null | undefined;
      readonly provisionAddress?: string | null | undefined;
      readonly provisionLat?: number | null | undefined;
      readonly provisionLon?: number | null | undefined;
      readonly departureGoogleMapsPlaceID?: string | null | undefined;
      readonly arrivalGoogleMapsPlaceID?: string | null | undefined;
      readonly departureLat: number;
      readonly departureLon: number;
      readonly arrivalLat: number;
      readonly arrivalLon: number;
      readonly departureAddress?: string | null | undefined;
      readonly departureCity?: string | null | undefined;
      readonly departureType?: string | null | undefined;
      readonly departureTime: string;
      readonly arrivalAddress?: string | null | undefined;
      readonly arrivalCity?: string | null | undefined;
      readonly arrivalType?: string | null | undefined;
      readonly arrivalTime: string;
      readonly presentationTime: string;
      readonly serviceTypeId: string;
      readonly reference?: string | null | undefined;
      readonly numVehicles?: number | null | undefined;
      readonly numPassengers?: number | null | undefined;
      readonly itineraryDescription: string;
      readonly groupName?: string | null | undefined;
      readonly flightNumber?: string | null | undefined;
      readonly notes?: string | null | undefined;
      readonly amounts: ReadonlyArray<{
        readonly __typename?: 'Amount';
        readonly id: string;
        readonly amount: number;
        readonly vat: number;
        readonly concept?: string | null | undefined;
      }>;
      readonly driverFeatures: ReadonlyArray<{
        readonly __typename?: 'ItineraryFeature';
        readonly id: string;
        readonly description: string;
        readonly required: boolean;
      }>;
      readonly vehicleFeatures: ReadonlyArray<{
        readonly __typename?: 'ItineraryFeature';
        readonly id: string;
        readonly description: string;
        readonly required: boolean;
      }>;
      readonly vehicleCategory?:
        | {
            readonly __typename?: 'VehicleCategory';
            readonly id: string;
            readonly vehicleCapacity?: number | null | undefined;
            readonly name: string;
            readonly description?: string | null | undefined;
            readonly vehicleModel?:
              | { readonly __typename?: 'VehicleModel'; readonly id: string }
              | null
              | undefined;
            readonly vehicleBrand?:
              | {
                  readonly __typename?: 'VehicleBrandModels';
                  readonly id: string;
                }
              | null
              | undefined;
            readonly vehicleType?:
              | { readonly __typename?: 'VehicleType'; readonly id: string }
              | null
              | undefined;
          }
        | null
        | undefined;
    }>;
  };
};

export type UpdateBudgetCustomMutationVariables = Exact<{
  id: Scalars['ID'];
  creationDate: Scalars['String'];
  validityPeriodStart: Scalars['String'];
  validityPeriodEnd: Scalars['String'];
  client: Scalars['String'];
  status: Scalars['String'];
  company: Scalars['String'];
  contactId?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
  metThrough?: InputMaybe<Scalars['String']>;
  requestSource?: InputMaybe<Scalars['String']>;
  templateHeading?: InputMaybe<Scalars['String']>;
  templateBody?: InputMaybe<Scalars['String']>;
  itineraries?: InputMaybe<ReadonlyArray<ItineraryInput> | ItineraryInput>;
}>;

export type UpdateBudgetCustomMutation = {
  readonly __typename?: 'Mutation';
  readonly updateBudget: {
    readonly __typename?: 'Budget';
    readonly id: string;
    readonly attendedBy?: string | null | undefined;
    readonly readableId: string;
    readonly validityPeriodStart: string;
    readonly validityPeriodEnd: string;
    readonly creationDate: string;
    readonly reference?: string | null | undefined;
    readonly templateHeading?: string | null | undefined;
    readonly templateBody?: string | null | undefined;
    readonly client: {
      readonly __typename?: 'Client';
      readonly id: string;
      readonly name?: string | null | undefined;
      readonly volcanoClientId?: string | null | undefined;
      readonly nif?: string | null | undefined;
      readonly phone?: string | null | undefined;
      readonly alternatePhone?: string | null | undefined;
      readonly email?: string | null | undefined;
      readonly volcanoEmail?: string | null | undefined;
      readonly template?:
        | {
            readonly __typename?: 'RichTemplate';
            readonly id: number;
            readonly name: string;
            readonly heading: Record<string, unknown>;
            readonly body: Record<string, unknown>;
          }
        | null
        | undefined;
    };
    readonly status: {
      readonly __typename?: 'BudgetStatus';
      readonly code: string;
      readonly locale: ReadonlyArray<{
        readonly __typename?: 'Locale';
        readonly code: CountryLocales;
        readonly value: string;
      }>;
    };
    readonly company: {
      readonly __typename?: 'Company';
      readonly code: CompanyCode;
      readonly data: {
        readonly __typename?: 'CompanyData';
        readonly zip: string;
        readonly address: string;
        readonly cif: string;
        readonly email: string;
        readonly fax: string;
        readonly location: string;
        readonly name: string;
        readonly phone: string;
        readonly region: string;
        readonly web: string;
        readonly country: {
          readonly __typename?: 'CompanyDataCountry';
          readonly enEN: string;
          readonly enUS: string;
          readonly esES: string;
        };
      };
    };
    readonly contact?:
      | {
          readonly __typename?: 'Contact';
          readonly id: string;
          readonly name: string;
          readonly phone?: string | null | undefined;
          readonly email?: string | null | undefined;
        }
      | null
      | undefined;
    readonly metThrough?:
      | { readonly __typename?: 'BudgetMetThrough'; readonly code: string }
      | null
      | undefined;
    readonly requestSource?:
      | { readonly __typename?: 'BudgetRequestSource'; readonly code: string }
      | null
      | undefined;
    readonly itineraries: ReadonlyArray<{
      readonly __typename?: 'Itinerary';
      readonly id: string;
      readonly realized: boolean;
      readonly dinner: boolean;
      readonly provisionGoogleMapsPlaceID?: string | null | undefined;
      readonly provisionType?: string | null | undefined;
      readonly provisionCity?: string | null | undefined;
      readonly provisionAddress?: string | null | undefined;
      readonly provisionLat?: number | null | undefined;
      readonly provisionLon?: number | null | undefined;
      readonly departureGoogleMapsPlaceID?: string | null | undefined;
      readonly arrivalGoogleMapsPlaceID?: string | null | undefined;
      readonly departureLat: number;
      readonly departureLon: number;
      readonly arrivalLat: number;
      readonly arrivalLon: number;
      readonly departureAddress?: string | null | undefined;
      readonly departureCity?: string | null | undefined;
      readonly departureType?: string | null | undefined;
      readonly departureTime: string;
      readonly arrivalAddress?: string | null | undefined;
      readonly arrivalCity?: string | null | undefined;
      readonly arrivalType?: string | null | undefined;
      readonly arrivalTime: string;
      readonly presentationTime: string;
      readonly serviceTypeId: string;
      readonly reference?: string | null | undefined;
      readonly numVehicles?: number | null | undefined;
      readonly numPassengers?: number | null | undefined;
      readonly itineraryDescription: string;
      readonly groupName?: string | null | undefined;
      readonly flightNumber?: string | null | undefined;
      readonly notes?: string | null | undefined;
      readonly amounts: ReadonlyArray<{
        readonly __typename?: 'Amount';
        readonly id: string;
        readonly amount: number;
        readonly vat: number;
        readonly concept?: string | null | undefined;
      }>;
      readonly driverFeatures: ReadonlyArray<{
        readonly __typename?: 'ItineraryFeature';
        readonly id: string;
        readonly description: string;
        readonly required: boolean;
      }>;
      readonly vehicleFeatures: ReadonlyArray<{
        readonly __typename?: 'ItineraryFeature';
        readonly id: string;
        readonly description: string;
        readonly required: boolean;
      }>;
      readonly vehicleCategory?:
        | {
            readonly __typename?: 'VehicleCategory';
            readonly id: string;
            readonly vehicleCapacity?: number | null | undefined;
            readonly name: string;
            readonly description?: string | null | undefined;
            readonly vehicleModel?:
              | { readonly __typename?: 'VehicleModel'; readonly id: string }
              | null
              | undefined;
            readonly vehicleBrand?:
              | {
                  readonly __typename?: 'VehicleBrandModels';
                  readonly id: string;
                }
              | null
              | undefined;
            readonly vehicleType?:
              | { readonly __typename?: 'VehicleType'; readonly id: string }
              | null
              | undefined;
          }
        | null
        | undefined;
    }>;
  };
};

export type GetBudgetQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetBudgetQuery = {
  readonly __typename?: 'Query';
  readonly budget: {
    readonly __typename?: 'Budget';
    readonly id: string;
    readonly attendedBy?: string | null | undefined;
    readonly readableId: string;
    readonly validityPeriodStart: string;
    readonly validityPeriodEnd: string;
    readonly creationDate: string;
    readonly reference?: string | null | undefined;
    readonly templateHeading?: string | null | undefined;
    readonly templateBody?: string | null | undefined;
    readonly client: {
      readonly __typename?: 'Client';
      readonly id: string;
      readonly name?: string | null | undefined;
      readonly volcanoClientId?: string | null | undefined;
      readonly nif?: string | null | undefined;
      readonly phone?: string | null | undefined;
      readonly alternatePhone?: string | null | undefined;
      readonly email?: string | null | undefined;
      readonly volcanoEmail?: string | null | undefined;
      readonly template?:
        | {
            readonly __typename?: 'RichTemplate';
            readonly id: number;
            readonly name: string;
            readonly heading: Record<string, unknown>;
            readonly body: Record<string, unknown>;
          }
        | null
        | undefined;
    };
    readonly status: {
      readonly __typename?: 'BudgetStatus';
      readonly code: string;
      readonly locale: ReadonlyArray<{
        readonly __typename?: 'Locale';
        readonly code: CountryLocales;
        readonly value: string;
      }>;
    };
    readonly company: {
      readonly __typename?: 'Company';
      readonly code: CompanyCode;
      readonly data: {
        readonly __typename?: 'CompanyData';
        readonly zip: string;
        readonly address: string;
        readonly cif: string;
        readonly email: string;
        readonly fax: string;
        readonly location: string;
        readonly name: string;
        readonly phone: string;
        readonly region: string;
        readonly web: string;
        readonly country: {
          readonly __typename?: 'CompanyDataCountry';
          readonly enEN: string;
          readonly enUS: string;
          readonly esES: string;
        };
      };
    };
    readonly contact?:
      | {
          readonly __typename?: 'Contact';
          readonly id: string;
          readonly name: string;
          readonly phone?: string | null | undefined;
          readonly email?: string | null | undefined;
        }
      | null
      | undefined;
    readonly metThrough?:
      | { readonly __typename?: 'BudgetMetThrough'; readonly code: string }
      | null
      | undefined;
    readonly requestSource?:
      | { readonly __typename?: 'BudgetRequestSource'; readonly code: string }
      | null
      | undefined;
    readonly itineraries: ReadonlyArray<{
      readonly __typename?: 'Itinerary';
      readonly id: string;
      readonly realized: boolean;
      readonly dinner: boolean;
      readonly departureGoogleMapsPlaceID?: string | null | undefined;
      readonly arrivalGoogleMapsPlaceID?: string | null | undefined;
      readonly provisionGoogleMapsPlaceID?: string | null | undefined;
      readonly provisionType?: string | null | undefined;
      readonly provisionCity?: string | null | undefined;
      readonly provisionAddress?: string | null | undefined;
      readonly provisionLat?: number | null | undefined;
      readonly provisionLon?: number | null | undefined;
      readonly departureLat: number;
      readonly departureLon: number;
      readonly arrivalLat: number;
      readonly arrivalLon: number;
      readonly departureAddress?: string | null | undefined;
      readonly departureCity?: string | null | undefined;
      readonly departureType?: string | null | undefined;
      readonly departureTime: string;
      readonly arrivalAddress?: string | null | undefined;
      readonly arrivalCity?: string | null | undefined;
      readonly arrivalType?: string | null | undefined;
      readonly arrivalTime: string;
      readonly presentationTime: string;
      readonly serviceTypeId: string;
      readonly reference?: string | null | undefined;
      readonly numVehicles?: number | null | undefined;
      readonly numPassengers?: number | null | undefined;
      readonly itineraryDescription: string;
      readonly groupName?: string | null | undefined;
      readonly flightNumber?: string | null | undefined;
      readonly notes?: string | null | undefined;
      readonly amounts: ReadonlyArray<{
        readonly __typename?: 'Amount';
        readonly id: string;
        readonly amount: number;
        readonly vat: number;
        readonly concept?: string | null | undefined;
      }>;
      readonly driverFeatures: ReadonlyArray<{
        readonly __typename?: 'ItineraryFeature';
        readonly id: string;
        readonly description: string;
        readonly required: boolean;
      }>;
      readonly vehicleFeatures: ReadonlyArray<{
        readonly __typename?: 'ItineraryFeature';
        readonly id: string;
        readonly description: string;
        readonly required: boolean;
      }>;
      readonly vehicleCategory?:
        | {
            readonly __typename?: 'VehicleCategory';
            readonly id: string;
            readonly vehicleCapacity?: number | null | undefined;
            readonly name: string;
            readonly description?: string | null | undefined;
            readonly vehicleModel?:
              | { readonly __typename?: 'VehicleModel'; readonly id: string }
              | null
              | undefined;
            readonly vehicleBrand?:
              | {
                  readonly __typename?: 'VehicleBrandModels';
                  readonly id: string;
                }
              | null
              | undefined;
            readonly vehicleType?:
              | { readonly __typename?: 'VehicleType'; readonly id: string }
              | null
              | undefined;
          }
        | null
        | undefined;
    }>;
  };
};

export type GetBudgetsQueryVariables = Exact<{ [key: string]: never }>;

export type GetBudgetsQuery = {
  readonly __typename?: 'Query';
  readonly budgets: ReadonlyArray<{
    readonly __typename?: 'Budget';
    readonly id: string;
    readonly attendedBy?: string | null | undefined;
    readonly readableId: string;
    readonly validityPeriodStart: string;
    readonly validityPeriodEnd: string;
    readonly creationDate: string;
    readonly reference?: string | null | undefined;
    readonly templateHeading?: string | null | undefined;
    readonly templateBody?: string | null | undefined;
    readonly client: {
      readonly __typename?: 'Client';
      readonly id: string;
      readonly name?: string | null | undefined;
      readonly template?:
        | {
            readonly __typename?: 'RichTemplate';
            readonly id: number;
            readonly name: string;
            readonly heading: Record<string, unknown>;
            readonly body: Record<string, unknown>;
          }
        | null
        | undefined;
    };
    readonly status: {
      readonly __typename?: 'BudgetStatus';
      readonly code: string;
      readonly locale: ReadonlyArray<{
        readonly __typename?: 'Locale';
        readonly code: CountryLocales;
        readonly value: string;
      }>;
    };
    readonly company: {
      readonly __typename?: 'Company';
      readonly code: CompanyCode;
      readonly data: {
        readonly __typename?: 'CompanyData';
        readonly zip: string;
        readonly address: string;
        readonly cif: string;
        readonly email: string;
        readonly fax: string;
        readonly location: string;
        readonly name: string;
        readonly phone: string;
        readonly region: string;
        readonly web: string;
        readonly country: {
          readonly __typename?: 'CompanyDataCountry';
          readonly enEN: string;
          readonly enUS: string;
          readonly esES: string;
        };
      };
    };
    readonly contact?:
      | {
          readonly __typename?: 'Contact';
          readonly id: string;
          readonly name: string;
          readonly phone?: string | null | undefined;
          readonly email?: string | null | undefined;
        }
      | null
      | undefined;
    readonly metThrough?:
      | { readonly __typename?: 'BudgetMetThrough'; readonly code: string }
      | null
      | undefined;
    readonly requestSource?:
      | { readonly __typename?: 'BudgetRequestSource'; readonly code: string }
      | null
      | undefined;
    readonly itineraries: ReadonlyArray<{
      readonly __typename?: 'Itinerary';
      readonly id: string;
      readonly realized: boolean;
      readonly dinner: boolean;
      readonly provisionGoogleMapsPlaceID?: string | null | undefined;
      readonly provisionType?: string | null | undefined;
      readonly provisionCity?: string | null | undefined;
      readonly provisionAddress?: string | null | undefined;
      readonly provisionLat?: number | null | undefined;
      readonly provisionLon?: number | null | undefined;
      readonly departureGoogleMapsPlaceID?: string | null | undefined;
      readonly arrivalGoogleMapsPlaceID?: string | null | undefined;
      readonly departureLat: number;
      readonly departureLon: number;
      readonly arrivalLat: number;
      readonly arrivalLon: number;
      readonly departureAddress?: string | null | undefined;
      readonly departureCity?: string | null | undefined;
      readonly departureType?: string | null | undefined;
      readonly departureTime: string;
      readonly arrivalAddress?: string | null | undefined;
      readonly arrivalCity?: string | null | undefined;
      readonly arrivalType?: string | null | undefined;
      readonly arrivalTime: string;
      readonly presentationTime: string;
      readonly serviceTypeId: string;
      readonly reference?: string | null | undefined;
      readonly numVehicles?: number | null | undefined;
      readonly numPassengers?: number | null | undefined;
      readonly itineraryDescription: string;
      readonly groupName?: string | null | undefined;
      readonly flightNumber?: string | null | undefined;
      readonly notes?: string | null | undefined;
      readonly amounts: ReadonlyArray<{
        readonly __typename?: 'Amount';
        readonly id: string;
        readonly amount: number;
        readonly vat: number;
        readonly concept?: string | null | undefined;
      }>;
      readonly driverFeatures: ReadonlyArray<{
        readonly __typename?: 'ItineraryFeature';
        readonly id: string;
        readonly description: string;
        readonly required: boolean;
      }>;
      readonly vehicleFeatures: ReadonlyArray<{
        readonly __typename?: 'ItineraryFeature';
        readonly id: string;
        readonly description: string;
        readonly required: boolean;
      }>;
      readonly vehicleCategory?:
        | {
            readonly __typename?: 'VehicleCategory';
            readonly id: string;
            readonly vehicleCapacity?: number | null | undefined;
            readonly name: string;
            readonly description?: string | null | undefined;
            readonly vehicleModel?:
              | { readonly __typename?: 'VehicleModel'; readonly id: string }
              | null
              | undefined;
            readonly vehicleBrand?:
              | {
                  readonly __typename?: 'VehicleBrandModels';
                  readonly id: string;
                }
              | null
              | undefined;
            readonly vehicleType?:
              | { readonly __typename?: 'VehicleType'; readonly id: string }
              | null
              | undefined;
          }
        | null
        | undefined;
    }>;
  }>;
};

export type GetBudgetConfigQueryVariables = Exact<{ [key: string]: never }>;

export type GetBudgetConfigQuery = {
  readonly __typename?: 'Query';
  readonly budgetConfig: {
    readonly __typename?: 'BudgetConfig';
    readonly vatTypes: ReadonlyArray<{
      readonly __typename?: 'VAT';
      readonly code: string;
      readonly translation: string;
      readonly value: number;
    }>;
    readonly companies: ReadonlyArray<{
      readonly __typename?: 'Company';
      readonly code: CompanyCode;
      readonly data: {
        readonly __typename?: 'CompanyData';
        readonly zip: string;
        readonly address: string;
        readonly cif: string;
        readonly email: string;
        readonly fax: string;
        readonly location: string;
        readonly name: string;
        readonly phone: string;
        readonly region: string;
        readonly web: string;
        readonly country: {
          readonly __typename?: 'CompanyDataCountry';
          readonly enEN: string;
          readonly enUS: string;
          readonly esES: string;
        };
      };
    }>;
    readonly templates: ReadonlyArray<{
      readonly __typename?: 'BudgetTemplate';
      readonly code: string;
      readonly translation: string;
      readonly template: {
        readonly __typename?: 'Template';
        readonly heading: string;
        readonly body: string;
      };
    }>;
    readonly status: ReadonlyArray<{
      readonly __typename?: 'BudgetStatus';
      readonly code: string;
      readonly locale: ReadonlyArray<{
        readonly __typename?: 'Locale';
        readonly code: CountryLocales;
        readonly value: string;
      }>;
    }>;
    readonly metThrough: ReadonlyArray<{
      readonly __typename?: 'BudgetMetThrough';
      readonly code: string;
      readonly locale: ReadonlyArray<{
        readonly __typename?: 'Locale';
        readonly code: CountryLocales;
        readonly value: string;
      }>;
    }>;
    readonly requestSource: ReadonlyArray<{
      readonly __typename?: 'BudgetRequestSource';
      readonly code: string;
      readonly locale: ReadonlyArray<{
        readonly __typename?: 'Locale';
        readonly code: CountryLocales;
        readonly value: string;
      }>;
    }>;
  };
};

export type DeleteClientMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteClientMutation = {
  readonly __typename?: 'Mutation';
  readonly deleteClient: {
    readonly __typename?: 'DeleteResult';
    readonly deleted: boolean;
    readonly reason?: string | null | undefined;
  };
};

export type UpdateClientMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  volcanoClientId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  loginEnabled?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateClientMutation = {
  readonly __typename?: 'Mutation';
  readonly updateClient: {
    readonly __typename?: 'Client';
    readonly id: string;
    readonly nif?: string | null | undefined;
    readonly name?: string | null | undefined;
    readonly phone?: string | null | undefined;
    readonly alternatePhone?: string | null | undefined;
    readonly volcanoClientId?: string | null | undefined;
    readonly volcanoEmail?: string | null | undefined;
    readonly email?: string | null | undefined;
    readonly communicationLocale?: string | null | undefined;
    readonly firebaseId?: string | null | undefined;
    readonly hasWebPanelAccount?: boolean | null | undefined;
  };
};

export type GetAllClientsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllClientsQuery = {
  readonly __typename?: 'Query';
  readonly clients?:
    | ReadonlyArray<{
        readonly __typename?: 'Client';
        readonly id: string;
        readonly nif?: string | null | undefined;
        readonly name?: string | null | undefined;
        readonly phone?: string | null | undefined;
        readonly alternatePhone?: string | null | undefined;
        readonly volcanoClientId?: string | null | undefined;
        readonly volcanoEmail?: string | null | undefined;
        readonly email?: string | null | undefined;
        readonly communicationLocale?: string | null | undefined;
        readonly firebaseId?: string | null | undefined;
        readonly hasWebPanelAccount?: boolean | null | undefined;
        readonly rate?:
          | {
              readonly __typename?: 'Rate';
              readonly id: string;
              readonly name: string;
            }
          | null
          | undefined;
      }>
    | null
    | undefined;
};

export type GetClientBasicInfoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetClientBasicInfoQuery = {
  readonly __typename?: 'Query';
  readonly client?:
    | {
        readonly __typename?: 'Client';
        readonly id: string;
        readonly nif?: string | null | undefined;
        readonly name?: string | null | undefined;
        readonly phone?: string | null | undefined;
        readonly alternatePhone?: string | null | undefined;
        readonly volcanoClientId?: string | null | undefined;
        readonly volcanoEmail?: string | null | undefined;
        readonly email?: string | null | undefined;
        readonly communicationLocale?: string | null | undefined;
        readonly hasWebPanelAccount?: boolean | null | undefined;
        readonly loginEnabled?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type GetClientTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetClientTemplateQuery = {
  readonly __typename?: 'Query';
  readonly client?:
    | {
        readonly __typename?: 'Client';
        readonly id: string;
        readonly template?:
          | {
              readonly __typename?: 'RichTemplate';
              readonly id: number;
              readonly name: string;
              readonly body: Record<string, unknown>;
              readonly heading: Record<string, unknown>;
              readonly createdAt: Date;
              readonly updatedAt: Date;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type OnNewClientSubscriptionVariables = Exact<{ [key: string]: never }>;

export type OnNewClientSubscription = {
  readonly __typename?: 'Subscription';
  readonly onNewClient: {
    readonly __typename?: 'Client';
    readonly id: string;
    readonly nif?: string | null | undefined;
    readonly name?: string | null | undefined;
    readonly phone?: string | null | undefined;
    readonly alternatePhone?: string | null | undefined;
    readonly volcanoClientId?: string | null | undefined;
    readonly volcanoEmail?: string | null | undefined;
    readonly email?: string | null | undefined;
    readonly communicationLocale?: string | null | undefined;
  };
};

export type OnUpdateClientSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnUpdateClientSubscription = {
  readonly __typename?: 'Subscription';
  readonly onUpdateClient: {
    readonly __typename?: 'Client';
    readonly id: string;
    readonly nif?: string | null | undefined;
    readonly name?: string | null | undefined;
    readonly phone?: string | null | undefined;
    readonly alternatePhone?: string | null | undefined;
    readonly volcanoClientId?: string | null | undefined;
    readonly volcanoEmail?: string | null | undefined;
    readonly email?: string | null | undefined;
    readonly communicationLocale?: string | null | undefined;
  };
};

export type CreateClientEmployeeMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
}>;

export type CreateClientEmployeeMutation = {
  readonly __typename?: 'Mutation';
  readonly createClientEmployee: {
    readonly __typename?: 'ClientEmployee';
    readonly id: string;
    readonly createdAt: string;
    readonly email?: string | null | undefined;
    readonly name: string;
    readonly phone?: string | null | undefined;
    readonly loginEnabled: boolean;
    readonly hasWebPanelAccount: boolean;
  };
};

export type UpdateClientEmployeeMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateClientEmployeeInput;
}>;

export type UpdateClientEmployeeMutation = {
  readonly __typename?: 'Mutation';
  readonly updateClientEmployee: {
    readonly __typename?: 'ClientEmployee';
    readonly id: string;
    readonly createdAt: string;
    readonly email?: string | null | undefined;
    readonly name: string;
    readonly phone?: string | null | undefined;
    readonly loginEnabled: boolean;
    readonly hasWebPanelAccount: boolean;
  };
};

export type DeleteClientEmployeeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteClientEmployeeMutation = {
  readonly __typename?: 'Mutation';
  readonly deleteClientEmployee: {
    readonly __typename?: 'DeleteResult';
    readonly deleted: boolean;
    readonly reason?: string | null | undefined;
  };
};

export type ClientEmployeesQueryVariables = Exact<{ [key: string]: never }>;

export type ClientEmployeesQuery = {
  readonly __typename?: 'Query';
  readonly clientEmployees: ReadonlyArray<{
    readonly __typename?: 'ClientEmployee';
    readonly id: string;
    readonly createdAt: string;
    readonly email?: string | null | undefined;
    readonly name: string;
    readonly phone?: string | null | undefined;
    readonly loginEnabled: boolean;
    readonly hasWebPanelAccount: boolean;
  }>;
};

export type ClientEmployeeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ClientEmployeeQuery = {
  readonly __typename?: 'Query';
  readonly clientEmployee: {
    readonly __typename?: 'ClientEmployee';
    readonly id: string;
    readonly createdAt: string;
    readonly email?: string | null | undefined;
    readonly name: string;
    readonly phone?: string | null | undefined;
    readonly loginEnabled: boolean;
    readonly hasWebPanelAccount: boolean;
  };
};

export type CreateContactMutationVariables = Exact<{
  name: Scalars['String'];
  email: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
}>;

export type CreateContactMutation = {
  readonly __typename?: 'Mutation';
  readonly createContact: {
    readonly __typename?: 'Contact';
    readonly id: string;
    readonly name: string;
    readonly phone?: string | null | undefined;
    readonly email?: string | null | undefined;
  };
};

export type ContactFragmentFragment = {
  readonly __typename?: 'Contact';
  readonly id: string;
  readonly name: string;
  readonly phone?: string | null | undefined;
  readonly email?: string | null | undefined;
};

export type ContactsQueryVariables = Exact<{ [key: string]: never }>;

export type ContactsQuery = {
  readonly __typename?: 'Query';
  readonly contacts: ReadonlyArray<{
    readonly __typename?: 'Contact';
    readonly id: string;
    readonly name: string;
    readonly phone?: string | null | undefined;
    readonly email?: string | null | undefined;
  }>;
};

export type DriverBasicInfoFragmentFragment = {
  readonly __typename?: 'Driver';
  readonly id: string;
  readonly type?: string | null | undefined;
  readonly status?: string | null | undefined;
  readonly notificationsToken?: string | null | undefined;
  readonly volcanoEmail?: string | null | undefined;
  readonly volcanoDriverId?: string | null | undefined;
  readonly hasLoginCredentials?: boolean | null | undefined;
  readonly inPrisma?: boolean | null | undefined;
  readonly inVolcano?: boolean | null | undefined;
  readonly profilePicURI?: string | null | undefined;
  readonly providerId?: string | null | undefined;
  readonly communicationLocale?: string | null | undefined;
  readonly received?: boolean | null | undefined;
  readonly name?: string | null | undefined;
  readonly phone?: string | null | undefined;
  readonly email?: string | null | undefined;
  readonly alternatePhone?: string | null | undefined;
  readonly loginMethod?: LoginMethod | null | undefined;
  readonly loginEnabled: boolean;
};

export type GetDriverQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;

export type GetDriverQuery = {
  readonly __typename?: 'Query';
  readonly driver?:
    | {
        readonly __typename?: 'Driver';
        readonly id: string;
        readonly type?: string | null | undefined;
        readonly status?: string | null | undefined;
        readonly notificationsToken?: string | null | undefined;
        readonly volcanoEmail?: string | null | undefined;
        readonly volcanoDriverId?: string | null | undefined;
        readonly hasLoginCredentials?: boolean | null | undefined;
        readonly inPrisma?: boolean | null | undefined;
        readonly inVolcano?: boolean | null | undefined;
        readonly profilePicURI?: string | null | undefined;
        readonly providerId?: string | null | undefined;
        readonly communicationLocale?: string | null | undefined;
        readonly received?: boolean | null | undefined;
        readonly name?: string | null | undefined;
        readonly phone?: string | null | undefined;
        readonly email?: string | null | undefined;
        readonly alternatePhone?: string | null | undefined;
        readonly loginMethod?: LoginMethod | null | undefined;
        readonly loginEnabled: boolean;
      }
    | null
    | undefined;
};

export type GetDriverDrivingCompanyQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetDriverDrivingCompanyQuery = {
  readonly __typename?: 'Query';
  readonly driver?:
    | {
        readonly __typename?: 'Driver';
        readonly id: string;
        readonly type?: string | null | undefined;
        readonly status?: string | null | undefined;
        readonly notificationsToken?: string | null | undefined;
        readonly volcanoEmail?: string | null | undefined;
        readonly volcanoDriverId?: string | null | undefined;
        readonly hasLoginCredentials?: boolean | null | undefined;
        readonly inPrisma?: boolean | null | undefined;
        readonly inVolcano?: boolean | null | undefined;
        readonly profilePicURI?: string | null | undefined;
        readonly providerId?: string | null | undefined;
        readonly communicationLocale?: string | null | undefined;
        readonly received?: boolean | null | undefined;
        readonly name?: string | null | undefined;
        readonly phone?: string | null | undefined;
        readonly email?: string | null | undefined;
        readonly alternatePhone?: string | null | undefined;
        readonly loginMethod?: LoginMethod | null | undefined;
        readonly loginEnabled: boolean;
        readonly drivingCompany?:
          | {
              readonly __typename?: 'DrivingCompany';
              readonly volcanoId?: string | null | undefined;
              readonly phone?: string | null | undefined;
              readonly email?: string | null | undefined;
              readonly name?: string | null | undefined;
              readonly id: string;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetAllDriversLocationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAllDriversLocationQuery = {
  readonly __typename?: 'Query';
  readonly drivers?:
    | ReadonlyArray<{
        readonly __typename?: 'Driver';
        readonly id: string;
        readonly name?: string | null | undefined;
        readonly location?:
          | {
              readonly __typename?: 'Location';
              readonly latitude?: string | null | undefined;
              readonly longitude?: string | null | undefined;
            }
          | null
          | undefined;
      }>
    | null
    | undefined;
};

export type OnNewDriverSubscriptionVariables = Exact<{ [key: string]: never }>;

export type OnNewDriverSubscription = {
  readonly __typename?: 'Subscription';
  readonly onNewDriver: {
    readonly __typename?: 'Driver';
    readonly id: string;
    readonly type?: string | null | undefined;
    readonly status?: string | null | undefined;
    readonly notificationsToken?: string | null | undefined;
    readonly volcanoEmail?: string | null | undefined;
    readonly volcanoDriverId?: string | null | undefined;
    readonly hasLoginCredentials?: boolean | null | undefined;
    readonly inPrisma?: boolean | null | undefined;
    readonly inVolcano?: boolean | null | undefined;
    readonly profilePicURI?: string | null | undefined;
    readonly providerId?: string | null | undefined;
    readonly communicationLocale?: string | null | undefined;
    readonly received?: boolean | null | undefined;
    readonly name?: string | null | undefined;
    readonly phone?: string | null | undefined;
    readonly email?: string | null | undefined;
    readonly alternatePhone?: string | null | undefined;
    readonly loginMethod?: LoginMethod | null | undefined;
    readonly loginEnabled: boolean;
  };
};

export type OnAnyDriverLocationUpdateSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnAnyDriverLocationUpdateSubscription = {
  readonly __typename?: 'Subscription';
  readonly onAnyDriverLocationUpdate: {
    readonly __typename?: 'Driver';
    readonly id: string;
    readonly type?: string | null | undefined;
    readonly status?: string | null | undefined;
    readonly notificationsToken?: string | null | undefined;
    readonly volcanoEmail?: string | null | undefined;
    readonly volcanoDriverId?: string | null | undefined;
    readonly hasLoginCredentials?: boolean | null | undefined;
    readonly inPrisma?: boolean | null | undefined;
    readonly inVolcano?: boolean | null | undefined;
    readonly profilePicURI?: string | null | undefined;
    readonly providerId?: string | null | undefined;
    readonly communicationLocale?: string | null | undefined;
    readonly received?: boolean | null | undefined;
    readonly name?: string | null | undefined;
    readonly phone?: string | null | undefined;
    readonly email?: string | null | undefined;
    readonly alternatePhone?: string | null | undefined;
    readonly loginMethod?: LoginMethod | null | undefined;
    readonly loginEnabled: boolean;
    readonly location?:
      | {
          readonly __typename?: 'Location';
          readonly longitude?: string | null | undefined;
          readonly latitude?: string | null | undefined;
        }
      | null
      | undefined;
  };
};

export type DeleteDriverMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;

export type DeleteDriverMutation = {
  readonly __typename?: 'Mutation';
  readonly deleteDriver: {
    readonly __typename?: 'DeleteResult';
    readonly deleted: boolean;
    readonly reason?: string | null | undefined;
  };
};

export type GetAllDriversQueryVariables = Exact<{
  fetchDrivingCompany: Scalars['Boolean'];
}>;

export type GetAllDriversQuery = {
  readonly __typename?: 'Query';
  readonly drivers?:
    | ReadonlyArray<{
        readonly __typename?: 'Driver';
        readonly id: string;
        readonly type?: string | null | undefined;
        readonly status?: string | null | undefined;
        readonly notificationsToken?: string | null | undefined;
        readonly volcanoEmail?: string | null | undefined;
        readonly volcanoDriverId?: string | null | undefined;
        readonly hasLoginCredentials?: boolean | null | undefined;
        readonly inPrisma?: boolean | null | undefined;
        readonly inVolcano?: boolean | null | undefined;
        readonly profilePicURI?: string | null | undefined;
        readonly providerId?: string | null | undefined;
        readonly communicationLocale?: string | null | undefined;
        readonly received?: boolean | null | undefined;
        readonly name?: string | null | undefined;
        readonly phone?: string | null | undefined;
        readonly email?: string | null | undefined;
        readonly alternatePhone?: string | null | undefined;
        readonly loginMethod?: LoginMethod | null | undefined;
        readonly loginEnabled: boolean;
        readonly drivingCompany?:
          | {
              readonly __typename?: 'DrivingCompany';
              readonly id: string;
              readonly volcanoId?: string | null | undefined;
              readonly email?: string | null | undefined;
              readonly phone?: string | null | undefined;
            }
          | null
          | undefined;
      }>
    | null
    | undefined;
};

export type GiveDriverAccessToAppMutationVariables = Exact<{
  id: Scalars['ID'];
  email: Scalars['String'];
  password: Scalars['String'];
}>;

export type GiveDriverAccessToAppMutation = {
  readonly __typename?: 'Mutation';
  readonly giveDriverAccessToApp: {
    readonly __typename?: 'Driver';
    readonly id: string;
    readonly type?: string | null | undefined;
    readonly status?: string | null | undefined;
    readonly notificationsToken?: string | null | undefined;
    readonly volcanoEmail?: string | null | undefined;
    readonly volcanoDriverId?: string | null | undefined;
    readonly hasLoginCredentials?: boolean | null | undefined;
    readonly inPrisma?: boolean | null | undefined;
    readonly inVolcano?: boolean | null | undefined;
    readonly profilePicURI?: string | null | undefined;
    readonly providerId?: string | null | undefined;
    readonly communicationLocale?: string | null | undefined;
    readonly received?: boolean | null | undefined;
    readonly name?: string | null | undefined;
    readonly phone?: string | null | undefined;
    readonly email?: string | null | undefined;
    readonly alternatePhone?: string | null | undefined;
    readonly loginMethod?: LoginMethod | null | undefined;
    readonly loginEnabled: boolean;
  };
};

export type CreateDriverMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  notificationsToken?: InputMaybe<Scalars['String']>;
  volcanoDriverId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profilePicURI?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  drivingCompanyId?: InputMaybe<Scalars['String']>;
  loginMethod?: InputMaybe<LoginMethod>;
}>;

export type CreateDriverMutation = {
  readonly __typename?: 'Mutation';
  readonly createDriver?:
    | {
        readonly __typename?: 'Driver';
        readonly id: string;
        readonly firebaseId?: string | null | undefined;
        readonly volcanoDriverId?: string | null | undefined;
        readonly name?: string | null | undefined;
        readonly email?: string | null | undefined;
        readonly volcanoEmail?: string | null | undefined;
        readonly phone?: string | null | undefined;
        readonly loginMethod?: LoginMethod | null | undefined;
        readonly loginEnabled: boolean;
        readonly inVolcano?: boolean | null | undefined;
        readonly inPrisma?: boolean | null | undefined;
        readonly alternatePhone?: string | null | undefined;
        readonly communicationLocale?: string | null | undefined;
        readonly hasLoginCredentials?: boolean | null | undefined;
        readonly profilePicURI?: string | null | undefined;
        readonly providerId?: string | null | undefined;
        readonly received?: boolean | null | undefined;
        readonly status?: string | null | undefined;
        readonly type?: string | null | undefined;
        readonly drivingCompany?:
          | { readonly __typename?: 'DrivingCompany'; readonly id: string }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateDriverMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  loginMethod?: InputMaybe<LoginMethod>;
  disableLogin?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  drivingCompanyId?: InputMaybe<Scalars['String']>;
  profilePicURI?: InputMaybe<Scalars['String']>;
}>;

export type UpdateDriverMutation = {
  readonly __typename?: 'Mutation';
  readonly updateDriver: {
    readonly __typename?: 'Driver';
    readonly id: string;
    readonly firebaseId?: string | null | undefined;
    readonly volcanoDriverId?: string | null | undefined;
    readonly name?: string | null | undefined;
    readonly email?: string | null | undefined;
    readonly volcanoEmail?: string | null | undefined;
    readonly phone?: string | null | undefined;
    readonly loginMethod?: LoginMethod | null | undefined;
    readonly loginEnabled: boolean;
    readonly inVolcano?: boolean | null | undefined;
    readonly inPrisma?: boolean | null | undefined;
    readonly alternatePhone?: string | null | undefined;
    readonly communicationLocale?: string | null | undefined;
    readonly hasLoginCredentials?: boolean | null | undefined;
    readonly profilePicURI?: string | null | undefined;
    readonly providerId?: string | null | undefined;
    readonly received?: boolean | null | undefined;
    readonly status?: string | null | undefined;
    readonly type?: string | null | undefined;
    readonly drivingCompany?:
      | { readonly __typename?: 'DrivingCompany'; readonly id: string }
      | null
      | undefined;
  };
};

export type GetDriverByEmailQueryVariables = Exact<{
  email: Scalars['String'];
  includeDrivingCompany: Scalars['Boolean'];
}>;

export type GetDriverByEmailQuery = {
  readonly __typename?: 'Query';
  readonly driverByEmail?:
    | {
        readonly __typename?: 'Driver';
        readonly id: string;
        readonly type?: string | null | undefined;
        readonly status?: string | null | undefined;
        readonly notificationsToken?: string | null | undefined;
        readonly volcanoEmail?: string | null | undefined;
        readonly volcanoDriverId?: string | null | undefined;
        readonly hasLoginCredentials?: boolean | null | undefined;
        readonly inPrisma?: boolean | null | undefined;
        readonly inVolcano?: boolean | null | undefined;
        readonly profilePicURI?: string | null | undefined;
        readonly providerId?: string | null | undefined;
        readonly communicationLocale?: string | null | undefined;
        readonly received?: boolean | null | undefined;
        readonly name?: string | null | undefined;
        readonly phone?: string | null | undefined;
        readonly email?: string | null | undefined;
        readonly alternatePhone?: string | null | undefined;
        readonly loginMethod?: LoginMethod | null | undefined;
        readonly loginEnabled: boolean;
        readonly drivingCompany?:
          | {
              readonly __typename?: 'DrivingCompany';
              readonly id: string;
              readonly email?: string | null | undefined;
              readonly phone?: string | null | undefined;
              readonly emailHasWebPanelAccount: boolean;
              readonly volcanoId?: string | null | undefined;
              readonly name?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetAllDrivingCompaniesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAllDrivingCompaniesQuery = {
  readonly __typename?: 'Query';
  readonly drivingCompanies: ReadonlyArray<{
    readonly __typename?: 'DrivingCompany';
    readonly id: string;
    readonly volcanoId?: string | null | undefined;
    readonly name?: string | null | undefined;
    readonly phone?: string | null | undefined;
    readonly email?: string | null | undefined;
  }>;
};

export type GetAllDrivingCompaniesListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAllDrivingCompaniesListQuery = {
  readonly __typename?: 'Query';
  readonly drivingCompanies: ReadonlyArray<{
    readonly __typename?: 'DrivingCompany';
    readonly id: string;
    readonly volcanoId?: string | null | undefined;
    readonly name?: string | null | undefined;
    readonly phone?: string | null | undefined;
    readonly email?: string | null | undefined;
    readonly teamMemberships?:
      | ReadonlyArray<{
          readonly __typename?: 'DrivingCompanyTeamMembership';
          readonly role: string;
          readonly createdAt: string;
        }>
      | null
      | undefined;
  }>;
};

export type GetDrivingCompanyDriversQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetDrivingCompanyDriversQuery = {
  readonly __typename?: 'Query';
  readonly drivingCompany: {
    readonly __typename?: 'DrivingCompany';
    readonly id: string;
    readonly drivers: ReadonlyArray<{
      readonly __typename?: 'Driver';
      readonly id: string;
      readonly type?: string | null | undefined;
      readonly status?: string | null | undefined;
      readonly notificationsToken?: string | null | undefined;
      readonly volcanoEmail?: string | null | undefined;
      readonly volcanoDriverId?: string | null | undefined;
      readonly hasLoginCredentials?: boolean | null | undefined;
      readonly inPrisma?: boolean | null | undefined;
      readonly inVolcano?: boolean | null | undefined;
      readonly profilePicURI?: string | null | undefined;
      readonly providerId?: string | null | undefined;
      readonly communicationLocale?: string | null | undefined;
      readonly received?: boolean | null | undefined;
      readonly name?: string | null | undefined;
      readonly phone?: string | null | undefined;
      readonly email?: string | null | undefined;
      readonly alternatePhone?: string | null | undefined;
      readonly loginMethod?: LoginMethod | null | undefined;
      readonly loginEnabled: boolean;
    }>;
  };
};

export type DrivingCompanyQueryVariables = Exact<{
  id: Scalars['ID'];
  fetchDrivers: Scalars['Boolean'];
}>;

export type DrivingCompanyQuery = {
  readonly __typename?: 'Query';
  readonly drivingCompany: {
    readonly __typename?: 'DrivingCompany';
    readonly id: string;
    readonly volcanoId?: string | null | undefined;
    readonly name?: string | null | undefined;
    readonly email?: string | null | undefined;
    readonly phone?: string | null | undefined;
    readonly emailHasWebPanelAccount: boolean;
    readonly drivers?: ReadonlyArray<{
      readonly __typename?: 'Driver';
      readonly id: string;
      readonly type?: string | null | undefined;
      readonly status?: string | null | undefined;
      readonly notificationsToken?: string | null | undefined;
      readonly volcanoEmail?: string | null | undefined;
      readonly volcanoDriverId?: string | null | undefined;
      readonly hasLoginCredentials?: boolean | null | undefined;
      readonly inPrisma?: boolean | null | undefined;
      readonly inVolcano?: boolean | null | undefined;
      readonly profilePicURI?: string | null | undefined;
      readonly providerId?: string | null | undefined;
      readonly communicationLocale?: string | null | undefined;
      readonly received?: boolean | null | undefined;
      readonly name?: string | null | undefined;
      readonly phone?: string | null | undefined;
      readonly email?: string | null | undefined;
      readonly alternatePhone?: string | null | undefined;
      readonly loginMethod?: LoginMethod | null | undefined;
      readonly loginEnabled: boolean;
    }>;
  };
};

export type DrivingCompanyMembershipsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DrivingCompanyMembershipsQuery = {
  readonly __typename?: 'Query';
  readonly drivingCompany: {
    readonly __typename?: 'DrivingCompany';
    readonly id: string;
    readonly teamMemberships?:
      | ReadonlyArray<{
          readonly __typename?: 'DrivingCompanyTeamMembership';
          readonly id: string;
          readonly createdAt: string;
          readonly role: string;
          readonly member: {
            readonly __typename?: 'User';
            readonly id: string;
            readonly name?: string | null | undefined;
            readonly email?: string | null | undefined;
            readonly disabled?: boolean | null | undefined;
          };
        }>
      | null
      | undefined;
  };
};

export type CreateDrivingCompanyAdminMutationVariables = Exact<{
  id: Scalars['ID'];
  email: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
}>;

export type CreateDrivingCompanyAdminMutation = {
  readonly __typename?: 'Mutation';
  readonly DrivingCompany: {
    readonly __typename?: 'DrivingCompanyNestedMutation';
    readonly createTeamMembership: {
      readonly __typename?: 'DrivingCompany';
      readonly id: string;
      readonly volcanoId?: string | null | undefined;
      readonly name?: string | null | undefined;
      readonly email?: string | null | undefined;
      readonly phone?: string | null | undefined;
      readonly teamMemberships?:
        | ReadonlyArray<{
            readonly __typename?: 'DrivingCompanyTeamMembership';
            readonly createdAt: string;
            readonly role: string;
          }>
        | null
        | undefined;
    };
  };
};

export type UpdateMembershipMutationVariables = Exact<{
  drivingCompanyId: Scalars['ID'];
  membershipId: Scalars['ID'];
  userId: Scalars['ID'];
  userEmail?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<DrivingCompanyTeamMemberShipRole>;
}>;

export type UpdateMembershipMutation = {
  readonly __typename?: 'Mutation';
  readonly updateUser: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly name?: string | null | undefined;
    readonly email?: string | null | undefined;
  };
  readonly DrivingCompany: {
    readonly __typename?: 'DrivingCompanyNestedMutation';
    readonly Membership: {
      readonly __typename?: 'DrivingCompanyMembershipNestedMutation';
      readonly update: {
        readonly __typename?: 'DrivingCompany';
        readonly id: string;
        readonly teamMemberships?:
          | ReadonlyArray<{
              readonly __typename?: 'DrivingCompanyTeamMembership';
              readonly createdAt: string;
              readonly role: string;
            }>
          | null
          | undefined;
      };
    };
  };
};

export type ItineraryBasicFragmentFragment = {
  readonly __typename?: 'Itinerary';
  readonly id: string;
  readonly departureCity?: string | null | undefined;
  readonly departureType?: string | null | undefined;
  readonly departureAddress?: string | null | undefined;
  readonly departureLat: number;
  readonly departureLon: number;
  readonly provisionGoogleMapsPlaceID?: string | null | undefined;
  readonly provisionType?: string | null | undefined;
  readonly provisionCity?: string | null | undefined;
  readonly provisionAddress?: string | null | undefined;
  readonly provisionLat?: number | null | undefined;
  readonly realized: boolean;
  readonly departureGoogleMapsPlaceID?: string | null | undefined;
  readonly provisionLon?: number | null | undefined;
  readonly arrivalGoogleMapsPlaceID?: string | null | undefined;
  readonly arrivalType?: string | null | undefined;
  readonly arrivalCity?: string | null | undefined;
  readonly arrivalAddress?: string | null | undefined;
  readonly arrivalLat: number;
  readonly arrivalLon: number;
  readonly numVehicles?: number | null | undefined;
  readonly numPassengers?: number | null | undefined;
  readonly flightNumber?: string | null | undefined;
  readonly groupName?: string | null | undefined;
  readonly itineraryDescription: string;
  readonly notes?: string | null | undefined;
  readonly dinner: boolean;
  readonly vehicleCategory?:
    | {
        readonly __typename?: 'VehicleCategory';
        readonly id: string;
        readonly name: string;
        readonly vehicleCapacity?: number | null | undefined;
        readonly description?: string | null | undefined;
        readonly vehicleModel?:
          | {
              readonly __typename?: 'VehicleModel';
              readonly id: string;
              readonly name: string;
            }
          | null
          | undefined;
        readonly vehicleType?:
          | {
              readonly __typename?: 'VehicleType';
              readonly name: string;
              readonly id: string;
              readonly category: string;
            }
          | null
          | undefined;
        readonly vehicleBrand?:
          | {
              readonly __typename?: 'VehicleBrandModels';
              readonly id: string;
              readonly brand: string;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type ConfirmItineraryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ConfirmItineraryMutation = {
  readonly __typename?: 'Mutation';
  readonly confirmItinerary: {
    readonly __typename?: 'Itinerary';
    readonly id: string;
    readonly departureCity?: string | null | undefined;
    readonly departureType?: string | null | undefined;
    readonly departureAddress?: string | null | undefined;
    readonly departureLat: number;
    readonly departureLon: number;
    readonly provisionGoogleMapsPlaceID?: string | null | undefined;
    readonly provisionType?: string | null | undefined;
    readonly provisionCity?: string | null | undefined;
    readonly provisionAddress?: string | null | undefined;
    readonly provisionLat?: number | null | undefined;
    readonly realized: boolean;
    readonly departureGoogleMapsPlaceID?: string | null | undefined;
    readonly provisionLon?: number | null | undefined;
    readonly arrivalGoogleMapsPlaceID?: string | null | undefined;
    readonly arrivalType?: string | null | undefined;
    readonly arrivalCity?: string | null | undefined;
    readonly arrivalAddress?: string | null | undefined;
    readonly arrivalLat: number;
    readonly arrivalLon: number;
    readonly numVehicles?: number | null | undefined;
    readonly numPassengers?: number | null | undefined;
    readonly flightNumber?: string | null | undefined;
    readonly groupName?: string | null | undefined;
    readonly itineraryDescription: string;
    readonly notes?: string | null | undefined;
    readonly dinner: boolean;
    readonly vehicleCategory?:
      | {
          readonly __typename?: 'VehicleCategory';
          readonly id: string;
          readonly name: string;
          readonly vehicleCapacity?: number | null | undefined;
          readonly description?: string | null | undefined;
          readonly vehicleModel?:
            | {
                readonly __typename?: 'VehicleModel';
                readonly id: string;
                readonly name: string;
              }
            | null
            | undefined;
          readonly vehicleType?:
            | {
                readonly __typename?: 'VehicleType';
                readonly name: string;
                readonly id: string;
                readonly category: string;
              }
            | null
            | undefined;
          readonly vehicleBrand?:
            | {
                readonly __typename?: 'VehicleBrandModels';
                readonly id: string;
                readonly brand: string;
              }
            | null
            | undefined;
        }
      | null
      | undefined;
  };
};

export type PassengerInfoFragment = {
  readonly __typename?: 'Passenger';
  readonly id: string;
  readonly phone?: string | null | undefined;
  readonly email: string;
  readonly name?: string | null | undefined;
};

export type CreatePassengerMutationVariables = Exact<{
  email: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
}>;

export type CreatePassengerMutation = {
  readonly __typename?: 'Mutation';
  readonly createPassenger?:
    | {
        readonly __typename?: 'Passenger';
        readonly id: string;
        readonly email: string;
        readonly phone?: string | null | undefined;
        readonly name?: string | null | undefined;
      }
    | null
    | undefined;
};

export type GetPassengerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetPassengerQuery = {
  readonly __typename?: 'Query';
  readonly passenger: {
    readonly __typename?: 'Passenger';
    readonly id: string;
    readonly phone?: string | null | undefined;
    readonly email: string;
    readonly name?: string | null | undefined;
  };
};

export type GetPassengersQueryVariables = Exact<{ [key: string]: never }>;

export type GetPassengersQuery = {
  readonly __typename?: 'Query';
  readonly passengers: ReadonlyArray<{
    readonly __typename?: 'Passenger';
    readonly id: string;
    readonly phone?: string | null | undefined;
    readonly email: string;
    readonly name?: string | null | undefined;
  }>;
};

export type GetRatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetRatesQuery = {
  readonly __typename?: 'Query';
  readonly rates: ReadonlyArray<{
    readonly __typename?: 'Rate';
    readonly id: string;
    readonly isGlobal: boolean;
    readonly name: string;
    readonly createdAt: string;
    readonly updatedAt: string;
    readonly clients: ReadonlyArray<{
      readonly __typename?: 'Client';
      readonly id: string;
      readonly volcanoClientId?: string | null | undefined;
    }>;
  }>;
};

export type GetARateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetARateQuery = {
  readonly __typename?: 'Query';
  readonly rate?:
    | {
        readonly __typename?: 'Rate';
        readonly id: string;
        readonly isGlobal: boolean;
        readonly name: string;
        readonly createdAt: string;
        readonly updatedAt: string;
        readonly clients: ReadonlyArray<{
          readonly __typename?: 'Client';
          readonly id: string;
          readonly volcanoClientId?: string | null | undefined;
          readonly name?: string | null | undefined;
        }>;
        readonly serviceTypes: ReadonlyArray<{
          readonly __typename?: 'RateServiceType';
          readonly id: string;
          readonly name: string;
          readonly description?: string | null | undefined;
          readonly subtypes: ReadonlyArray<{
            readonly __typename?: 'ServiceSubtype';
            readonly id: string;
            readonly name: string;
            readonly hours: number;
            readonly dinner: boolean;
            readonly description?: string | null | undefined;
            readonly priceConditions?:
              | {
                  readonly __typename?: 'PriceCondition';
                  readonly vehicle: ReadonlyArray<{
                    readonly __typename?: 'VehiclePriceCondition';
                    readonly basePrice: number;
                    readonly extraHourPrice?: number | null | undefined;
                    readonly numPassengers?: number | null | undefined;
                    readonly description?: string | null | undefined;
                    readonly id: string;
                    readonly name: string;
                    readonly vehicleBrandId?: string | null | undefined;
                    readonly vehicleModelId?: string | null | undefined;
                    readonly vehicleTypeId?: string | null | undefined;
                  }>;
                }
              | null
              | undefined;
            readonly fulfillingCondition?:
              | {
                  readonly __typename?: 'FulfillingCondition';
                  readonly conditionType: string;
                  readonly conditionActivation?: string | null | undefined;
                  readonly description?: string | null | undefined;
                  readonly id: string;
                  readonly name: string;
                  readonly threshold?: number | null | undefined;
                }
              | null
              | undefined;
          }>;
        }>;
        readonly vehicleCategories: ReadonlyArray<{
          readonly __typename?: 'VehicleCategory';
          readonly id: string;
          readonly name: string;
          readonly description?: string | null | undefined;
          readonly vehicleCapacity?: number | null | undefined;
          readonly vehicleBrand?:
            | {
                readonly __typename?: 'VehicleBrandModels';
                readonly id: string;
                readonly brand: string;
              }
            | null
            | undefined;
          readonly vehicleModel?:
            | {
                readonly __typename?: 'VehicleModel';
                readonly id: string;
                readonly name: string;
              }
            | null
            | undefined;
          readonly vehicleType?:
            | {
                readonly __typename?: 'VehicleType';
                readonly id: string;
                readonly name: string;
              }
            | null
            | undefined;
        }>;
        readonly vehiclePriceVariables: ReadonlyArray<{
          readonly __typename?: 'VehiclePriceVariable';
          readonly id: string;
          readonly extraHourPrice: number;
          readonly extraPricePerKm: number;
          readonly tollPricePerKm: number;
          readonly paxNumber: number;
          readonly airportPrice: number;
          readonly parkingMontserrat: number;
          readonly vehicleBrandId?: string | null | undefined;
          readonly vehicleModelId?: string | null | undefined;
          readonly vehicleTypeId?: string | null | undefined;
        }>;
      }
    | null
    | undefined;
};

export type CloneARateMutationVariables = Exact<{
  rateToClone: Scalars['ID'];
  name: Scalars['String'];
}>;

export type CloneARateMutation = {
  readonly __typename?: 'Mutation';
  readonly cloneRate: {
    readonly __typename?: 'Rate';
    readonly id: string;
    readonly isGlobal: boolean;
    readonly name: string;
    readonly createdAt: string;
    readonly updatedAt: string;
    readonly clients: ReadonlyArray<{
      readonly __typename?: 'Client';
      readonly id: string;
      readonly volcanoClientId?: string | null | undefined;
    }>;
  };
};

export type UpdateARateMutationVariables = Exact<{
  rate: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
}>;

export type UpdateARateMutation = {
  readonly __typename?: 'Mutation';
  readonly updateRate: {
    readonly __typename?: 'Rate';
    readonly id: string;
    readonly isGlobal: boolean;
    readonly name: string;
    readonly createdAt: string;
    readonly updatedAt: string;
    readonly clients: ReadonlyArray<{
      readonly __typename?: 'Client';
      readonly id: string;
      readonly volcanoClientId?: string | null | undefined;
    }>;
  };
};

export type DeleteARateMutationVariables = Exact<{
  rate: Scalars['ID'];
}>;

export type DeleteARateMutation = {
  readonly __typename?: 'Mutation';
  readonly deleteRate: boolean;
};

export type AssignClientsToRateMutationVariables = Exact<{
  clients: ReadonlyArray<Scalars['String']> | Scalars['String'];
  rateId: Scalars['ID'];
}>;

export type AssignClientsToRateMutation = {
  readonly __typename?: 'Mutation';
  readonly assignRateToClients: {
    readonly __typename?: 'Rate';
    readonly id: string;
    readonly isGlobal: boolean;
    readonly name: string;
    readonly createdAt: string;
    readonly updatedAt: string;
    readonly clients: ReadonlyArray<{
      readonly __typename?: 'Client';
      readonly id: string;
      readonly volcanoClientId?: string | null | undefined;
      readonly name?: string | null | undefined;
    }>;
  };
};

export type DisassignClientsFromRateMutationVariables = Exact<{
  clients: ReadonlyArray<Scalars['String']> | Scalars['String'];
  rateId: Scalars['ID'];
}>;

export type DisassignClientsFromRateMutation = {
  readonly __typename?: 'Mutation';
  readonly disassignRateFromClients: {
    readonly __typename?: 'Rate';
    readonly id: string;
    readonly isGlobal: boolean;
    readonly name: string;
    readonly createdAt: string;
    readonly updatedAt: string;
    readonly clients: ReadonlyArray<{
      readonly __typename?: 'Client';
      readonly id: string;
      readonly volcanoClientId?: string | null | undefined;
      readonly name?: string | null | undefined;
    }>;
  };
};

export type GetClientRateQueryVariables = Exact<{
  clientId: Scalars['ID'];
}>;

export type GetClientRateQuery = {
  readonly __typename?: 'Query';
  readonly client?:
    | {
        readonly __typename?: 'Client';
        readonly id: string;
        readonly rate?:
          | {
              readonly __typename?: 'Rate';
              readonly id: string;
              readonly isGlobal: boolean;
              readonly serviceTypes: ReadonlyArray<{
                readonly __typename?: 'RateServiceType';
                readonly id: string;
                readonly name: string;
                readonly description?: string | null | undefined;
                readonly subtypes: ReadonlyArray<{
                  readonly __typename?: 'ServiceSubtype';
                  readonly id: string;
                  readonly name: string;
                  readonly hours: number;
                  readonly dinner: boolean;
                  readonly description?: string | null | undefined;
                  readonly priceConditions?:
                    | {
                        readonly __typename?: 'PriceCondition';
                        readonly vehicle: ReadonlyArray<{
                          readonly __typename?: 'VehiclePriceCondition';
                          readonly basePrice: number;
                          readonly extraHourPrice?: number | null | undefined;
                          readonly numPassengers?: number | null | undefined;
                          readonly description?: string | null | undefined;
                          readonly id: string;
                          readonly name: string;
                          readonly vehicleBrandId?: string | null | undefined;
                          readonly vehicleModelId?: string | null | undefined;
                          readonly vehicleTypeId?: string | null | undefined;
                        }>;
                      }
                    | null
                    | undefined;
                  readonly fulfillingCondition?:
                    | {
                        readonly __typename?: 'FulfillingCondition';
                        readonly conditionType: string;
                        readonly conditionActivation?:
                          | string
                          | null
                          | undefined;
                        readonly description?: string | null | undefined;
                        readonly id: string;
                        readonly name: string;
                        readonly threshold?: number | null | undefined;
                      }
                    | null
                    | undefined;
                }>;
              }>;
              readonly vehicleCategories: ReadonlyArray<{
                readonly __typename?: 'VehicleCategory';
                readonly id: string;
                readonly name: string;
                readonly description?: string | null | undefined;
                readonly vehicleCapacity?: number | null | undefined;
                readonly vehicleBrand?:
                  | {
                      readonly __typename?: 'VehicleBrandModels';
                      readonly id: string;
                      readonly brand: string;
                    }
                  | null
                  | undefined;
                readonly vehicleModel?:
                  | {
                      readonly __typename?: 'VehicleModel';
                      readonly id: string;
                      readonly name: string;
                    }
                  | null
                  | undefined;
                readonly vehicleType?:
                  | {
                      readonly __typename?: 'VehicleType';
                      readonly id: string;
                      readonly name: string;
                    }
                  | null
                  | undefined;
              }>;
              readonly vehiclePriceVariables: ReadonlyArray<{
                readonly __typename?: 'VehiclePriceVariable';
                readonly id: string;
                readonly extraHourPrice: number;
                readonly extraPricePerKm: number;
                readonly tollPricePerKm: number;
                readonly paxNumber: number;
                readonly airportPrice: number;
                readonly parkingMontserrat: number;
                readonly vehicleBrandId?: string | null | undefined;
                readonly vehicleModelId?: string | null | undefined;
                readonly vehicleTypeId?: string | null | undefined;
              }>;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetGlobalRateQueryVariables = Exact<{ [key: string]: never }>;

export type GetGlobalRateQuery = {
  readonly __typename?: 'Query';
  readonly globalRate?:
    | {
        readonly __typename?: 'Rate';
        readonly id: string;
        readonly isGlobal: boolean;
        readonly serviceTypes: ReadonlyArray<{
          readonly __typename?: 'RateServiceType';
          readonly id: string;
          readonly name: string;
          readonly description?: string | null | undefined;
          readonly subtypes: ReadonlyArray<{
            readonly __typename?: 'ServiceSubtype';
            readonly id: string;
            readonly name: string;
            readonly hours: number;
            readonly dinner: boolean;
            readonly description?: string | null | undefined;
            readonly priceConditions?:
              | {
                  readonly __typename?: 'PriceCondition';
                  readonly vehicle: ReadonlyArray<{
                    readonly __typename?: 'VehiclePriceCondition';
                    readonly basePrice: number;
                    readonly extraHourPrice?: number | null | undefined;
                    readonly numPassengers?: number | null | undefined;
                    readonly description?: string | null | undefined;
                    readonly id: string;
                    readonly name: string;
                    readonly vehicleBrandId?: string | null | undefined;
                    readonly vehicleModelId?: string | null | undefined;
                    readonly vehicleTypeId?: string | null | undefined;
                  }>;
                }
              | null
              | undefined;
            readonly fulfillingCondition?:
              | {
                  readonly __typename?: 'FulfillingCondition';
                  readonly conditionType: string;
                  readonly conditionActivation?: string | null | undefined;
                  readonly description?: string | null | undefined;
                  readonly id: string;
                  readonly name: string;
                  readonly threshold?: number | null | undefined;
                }
              | null
              | undefined;
          }>;
        }>;
        readonly vehicleCategories: ReadonlyArray<{
          readonly __typename?: 'VehicleCategory';
          readonly id: string;
          readonly name: string;
          readonly description?: string | null | undefined;
          readonly vehicleCapacity?: number | null | undefined;
          readonly vehicleBrand?:
            | {
                readonly __typename?: 'VehicleBrandModels';
                readonly id: string;
                readonly brand: string;
              }
            | null
            | undefined;
          readonly vehicleModel?:
            | {
                readonly __typename?: 'VehicleModel';
                readonly id: string;
                readonly name: string;
              }
            | null
            | undefined;
          readonly vehicleType?:
            | {
                readonly __typename?: 'VehicleType';
                readonly id: string;
                readonly name: string;
              }
            | null
            | undefined;
        }>;
        readonly vehiclePriceVariables: ReadonlyArray<{
          readonly __typename?: 'VehiclePriceVariable';
          readonly id: string;
          readonly extraHourPrice: number;
          readonly extraPricePerKm: number;
          readonly tollPricePerKm: number;
          readonly paxNumber: number;
          readonly airportPrice: number;
          readonly parkingMontserrat: number;
          readonly vehicleBrandId?: string | null | undefined;
          readonly vehicleModelId?: string | null | undefined;
          readonly vehicleTypeId?: string | null | undefined;
        }>;
      }
    | null
    | undefined;
};

export type VehiclePriceConditionFragmentFragment = {
  readonly __typename?: 'VehiclePriceCondition';
  readonly id: string;
  readonly name: string;
  readonly description?: string | null | undefined;
  readonly basePrice: number;
  readonly extraHourPrice?: number | null | undefined;
  readonly numPassengers?: number | null | undefined;
  readonly vehicleTypeId?: string | null | undefined;
  readonly vehicleModelId?: string | null | undefined;
  readonly vehicleBrandId?: string | null | undefined;
};

export type CreateVehiclePriceConditionMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']>;
  extraHourPrice?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  numPassengers?: InputMaybe<Scalars['Int']>;
  price: Scalars['Float'];
  rateId: Scalars['String'];
  serviceSubtypeId: Scalars['ID'];
  vehicleBrandId?: InputMaybe<Scalars['String']>;
  vehicleModelId?: InputMaybe<Scalars['String']>;
  vehicleTypeId?: InputMaybe<Scalars['String']>;
}>;

export type CreateVehiclePriceConditionMutation = {
  readonly __typename?: 'Mutation';
  readonly createVehiclePriceCondition: {
    readonly __typename?: 'VehiclePriceCondition';
    readonly id: string;
    readonly name: string;
    readonly description?: string | null | undefined;
    readonly basePrice: number;
    readonly extraHourPrice?: number | null | undefined;
    readonly numPassengers?: number | null | undefined;
    readonly vehicleTypeId?: string | null | undefined;
    readonly vehicleModelId?: string | null | undefined;
    readonly vehicleBrandId?: string | null | undefined;
  };
};

export type UpdateVehiclePriceConditionMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']>;
  extraHourPrice?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  numPassengers?: InputMaybe<Scalars['Int']>;
  price: Scalars['Float'];
  vehicleBrandId?: InputMaybe<Scalars['String']>;
  vehicleModelId?: InputMaybe<Scalars['String']>;
  vehicleTypeId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
}>;

export type UpdateVehiclePriceConditionMutation = {
  readonly __typename?: 'Mutation';
  readonly updateVehiclePriceCondition: {
    readonly __typename?: 'VehiclePriceCondition';
    readonly id: string;
    readonly name: string;
    readonly description?: string | null | undefined;
    readonly basePrice: number;
    readonly extraHourPrice?: number | null | undefined;
    readonly numPassengers?: number | null | undefined;
    readonly vehicleTypeId?: string | null | undefined;
    readonly vehicleModelId?: string | null | undefined;
    readonly vehicleBrandId?: string | null | undefined;
  };
};

export type DeleteVehiclePriceConditionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteVehiclePriceConditionMutation = {
  readonly __typename?: 'Mutation';
  readonly deleteVehiclePriceCondition: {
    readonly __typename?: 'DeleteResult';
    readonly deleted: boolean;
    readonly reason?: string | null | undefined;
  };
};

export type VehiclePriceVariableFragmentFragment = {
  readonly __typename?: 'VehiclePriceVariable';
  readonly id: string;
  readonly extraPricePerKm: number;
  readonly tollPricePerKm: number;
  readonly airportPrice: number;
  readonly parkingMontserrat: number;
  readonly paxNumber: number;
  readonly extraHourPrice: number;
  readonly vehicleTypeId?: string | null | undefined;
  readonly vehicleModelId?: string | null | undefined;
  readonly vehicleBrandId?: string | null | undefined;
};

export type CreateVehiclePriceVariableMutationVariables = Exact<{
  extraHourPrice?: InputMaybe<Scalars['Float']>;
  numPassengers?: InputMaybe<Scalars['Int']>;
  vehicleBrandId?: InputMaybe<Scalars['String']>;
  vehicleModelId?: InputMaybe<Scalars['String']>;
  vehicleTypeId?: InputMaybe<Scalars['String']>;
  rateID: Scalars['ID'];
  airportPrice?: InputMaybe<Scalars['Float']>;
  extraKmPrice?: InputMaybe<Scalars['Float']>;
  extraTollPrice?: InputMaybe<Scalars['Float']>;
  parkingMontserratPrice?: InputMaybe<Scalars['Float']>;
}>;

export type CreateVehiclePriceVariableMutation = {
  readonly __typename?: 'Mutation';
  readonly createVehiclePriceVariable: {
    readonly __typename?: 'VehiclePriceVariable';
    readonly id: string;
    readonly extraPricePerKm: number;
    readonly tollPricePerKm: number;
    readonly airportPrice: number;
    readonly parkingMontserrat: number;
    readonly paxNumber: number;
    readonly extraHourPrice: number;
    readonly vehicleTypeId?: string | null | undefined;
    readonly vehicleModelId?: string | null | undefined;
    readonly vehicleBrandId?: string | null | undefined;
  };
};

export type UpdateVehiclePriceVariableMutationVariables = Exact<{
  extraHourPrice?: InputMaybe<Scalars['Float']>;
  numPassengers?: InputMaybe<Scalars['Int']>;
  vehicleBrandId?: InputMaybe<Scalars['String']>;
  vehicleModelId?: InputMaybe<Scalars['String']>;
  vehicleTypeId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  airportPrice?: InputMaybe<Scalars['Float']>;
  extraKmPrice?: InputMaybe<Scalars['Float']>;
  parkingMontserratPrice?: InputMaybe<Scalars['Float']>;
  extraTollPrice?: InputMaybe<Scalars['Float']>;
}>;

export type UpdateVehiclePriceVariableMutation = {
  readonly __typename?: 'Mutation';
  readonly updateVehiclePriceVariable: {
    readonly __typename?: 'VehiclePriceVariable';
    readonly id: string;
    readonly extraPricePerKm: number;
    readonly tollPricePerKm: number;
    readonly airportPrice: number;
    readonly parkingMontserrat: number;
    readonly paxNumber: number;
    readonly extraHourPrice: number;
    readonly vehicleTypeId?: string | null | undefined;
    readonly vehicleModelId?: string | null | undefined;
    readonly vehicleBrandId?: string | null | undefined;
  };
};

export type DeleteVehiclePriceVariableMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteVehiclePriceVariableMutation = {
  readonly __typename?: 'Mutation';
  readonly deleteVehiclePriceVariable: {
    readonly __typename?: 'DeleteResult';
    readonly deleted: boolean;
    readonly reason?: string | null | undefined;
  };
};

export type UpdateServiceSubtypeMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']>;
  distanceInMeters?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  rateId: Scalars['String'];
}>;

export type UpdateServiceSubtypeMutation = {
  readonly __typename?: 'Mutation';
  readonly updateServiceSubtype: {
    readonly __typename?: 'ServiceSubtype';
    readonly id: string;
    readonly name: string;
    readonly description?: string | null | undefined;
    readonly dinner: boolean;
    readonly hours: number;
  };
};

export type BasicServiceFragmentFragment = {
  readonly __typename?: 'Service';
  readonly id: string;
  readonly budgetReadableId?: string | null | undefined;
  readonly typeId?: string | null | undefined;
  readonly volcanoServiceId?: string | null | undefined;
  readonly status?: string | null | undefined;
  readonly reference?: string | null | undefined;
  readonly serieFact?: string | null | undefined;
  readonly itineraryDescription?: string | null | undefined;
  readonly numOfPassengers?: number | null | undefined;
  readonly presentationTime?: string | null | undefined;
  readonly notes?: string | null | undefined;
  readonly description?: string | null | undefined;
  readonly requestedVehicleDescription?: string | null | undefined;
};

export type FullServiceFragmentFragment = {
  readonly __typename?: 'Service';
  readonly id: string;
  readonly budgetReadableId?: string | null | undefined;
  readonly typeId?: string | null | undefined;
  readonly volcanoServiceId?: string | null | undefined;
  readonly status?: string | null | undefined;
  readonly reference?: string | null | undefined;
  readonly serieFact?: string | null | undefined;
  readonly itineraryDescription?: string | null | undefined;
  readonly numOfPassengers?: number | null | undefined;
  readonly presentationTime?: string | null | undefined;
  readonly notes?: string | null | undefined;
  readonly description?: string | null | undefined;
  readonly requestedVehicleDescription?: string | null | undefined;
  readonly passengers: ReadonlyArray<{
    readonly __typename?: 'Passenger';
    readonly id: string;
    readonly name?: string | null | undefined;
    readonly phone?: string | null | undefined;
    readonly email: string;
  }>;
  readonly departure?:
    | {
        readonly __typename?: 'DepartureOrArrival';
        readonly date?: string | null | undefined;
        readonly time?: string | null | undefined;
        readonly address?: string | null | undefined;
        readonly lat?: number | null | undefined;
        readonly lon?: number | null | undefined;
      }
    | null
    | undefined;
  readonly arrival?:
    | {
        readonly __typename?: 'DepartureOrArrival';
        readonly date?: string | null | undefined;
        readonly time?: string | null | undefined;
        readonly address?: string | null | undefined;
        readonly lat?: number | null | undefined;
        readonly lon?: number | null | undefined;
      }
    | null
    | undefined;
  readonly client?:
    | {
        readonly __typename?: 'Client';
        readonly name?: string | null | undefined;
        readonly id: string;
      }
    | null
    | undefined;
  readonly driver?:
    | {
        readonly __typename?: 'Driver';
        readonly id: string;
        readonly received?: boolean | null | undefined;
        readonly name?: string | null | undefined;
        readonly phone?: string | null | undefined;
        readonly alternatePhone?: string | null | undefined;
        readonly email?: string | null | undefined;
        readonly type?: string | null | undefined;
        readonly status?: string | null | undefined;
        readonly inPrisma?: boolean | null | undefined;
        readonly inVolcano?: boolean | null | undefined;
        readonly profilePicURI?: string | null | undefined;
        readonly location?:
          | {
              readonly __typename?: 'Location';
              readonly latitude?: string | null | undefined;
              readonly longitude?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
  readonly alternateDriver?:
    | {
        readonly __typename?: 'Driver';
        readonly id: string;
        readonly received?: boolean | null | undefined;
        readonly name?: string | null | undefined;
        readonly phone?: string | null | undefined;
        readonly alternatePhone?: string | null | undefined;
        readonly email?: string | null | undefined;
        readonly type?: string | null | undefined;
        readonly status?: string | null | undefined;
        readonly inPrisma?: boolean | null | undefined;
        readonly inVolcano?: boolean | null | undefined;
        readonly location?:
          | {
              readonly __typename?: 'Location';
              readonly latitude?: string | null | undefined;
              readonly longitude?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
  readonly drivers: ReadonlyArray<{
    readonly __typename?: 'Driver';
    readonly id: string;
    readonly received?: boolean | null | undefined;
    readonly name?: string | null | undefined;
    readonly phone?: string | null | undefined;
    readonly alternatePhone?: string | null | undefined;
    readonly email?: string | null | undefined;
    readonly type?: string | null | undefined;
    readonly status?: string | null | undefined;
    readonly inPrisma?: boolean | null | undefined;
    readonly inVolcano?: boolean | null | undefined;
    readonly location?:
      | {
          readonly __typename?: 'Location';
          readonly latitude?: string | null | undefined;
          readonly longitude?: string | null | undefined;
        }
      | null
      | undefined;
  }>;
  readonly drivingCompany?:
    | {
        readonly __typename?: 'DrivingCompany';
        readonly id: string;
        readonly email?: string | null | undefined;
        readonly volcanoId?: string | null | undefined;
        readonly name?: string | null | undefined;
        readonly phone?: string | null | undefined;
      }
    | null
    | undefined;
  readonly vehicle?:
    | {
        readonly __typename?: 'Vehicle';
        readonly id: string;
        readonly origin?: string | null | undefined;
        readonly type?: string | null | undefined;
        readonly typeID?: number | null | undefined;
        readonly typeDescription?: string | null | undefined;
        readonly status?: string | null | undefined;
        readonly licensePlate?: string | null | undefined;
        readonly brand?: string | null | undefined;
        readonly model?: string | null | undefined;
        readonly location?:
          | {
              readonly __typename?: 'Location';
              readonly latitude?: string | null | undefined;
              readonly longitude?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CancelServiceMutationVariables = Exact<{
  id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
}>;

export type CancelServiceMutation = {
  readonly __typename?: 'Mutation';
  readonly cancelService: {
    readonly __typename?: 'ActionResult';
    readonly success: boolean;
    readonly reason?: string | null | undefined;
  };
};

export type OnNewServiceSubscriptionSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnNewServiceSubscriptionSubscription = {
  readonly __typename?: 'Subscription';
  readonly onNewService: {
    readonly __typename?: 'Service';
    readonly id: string;
    readonly budgetReadableId?: string | null | undefined;
    readonly typeId?: string | null | undefined;
    readonly volcanoServiceId?: string | null | undefined;
    readonly status?: string | null | undefined;
    readonly reference?: string | null | undefined;
    readonly serieFact?: string | null | undefined;
    readonly itineraryDescription?: string | null | undefined;
    readonly numOfPassengers?: number | null | undefined;
    readonly presentationTime?: string | null | undefined;
    readonly notes?: string | null | undefined;
    readonly description?: string | null | undefined;
    readonly requestedVehicleDescription?: string | null | undefined;
    readonly passengers: ReadonlyArray<{
      readonly __typename?: 'Passenger';
      readonly id: string;
      readonly name?: string | null | undefined;
      readonly phone?: string | null | undefined;
      readonly email: string;
    }>;
    readonly departure?:
      | {
          readonly __typename?: 'DepartureOrArrival';
          readonly date?: string | null | undefined;
          readonly time?: string | null | undefined;
          readonly address?: string | null | undefined;
          readonly lat?: number | null | undefined;
          readonly lon?: number | null | undefined;
        }
      | null
      | undefined;
    readonly arrival?:
      | {
          readonly __typename?: 'DepartureOrArrival';
          readonly date?: string | null | undefined;
          readonly time?: string | null | undefined;
          readonly address?: string | null | undefined;
          readonly lat?: number | null | undefined;
          readonly lon?: number | null | undefined;
        }
      | null
      | undefined;
    readonly client?:
      | {
          readonly __typename?: 'Client';
          readonly name?: string | null | undefined;
          readonly id: string;
        }
      | null
      | undefined;
    readonly driver?:
      | {
          readonly __typename?: 'Driver';
          readonly id: string;
          readonly received?: boolean | null | undefined;
          readonly name?: string | null | undefined;
          readonly phone?: string | null | undefined;
          readonly alternatePhone?: string | null | undefined;
          readonly email?: string | null | undefined;
          readonly type?: string | null | undefined;
          readonly status?: string | null | undefined;
          readonly inPrisma?: boolean | null | undefined;
          readonly inVolcano?: boolean | null | undefined;
          readonly profilePicURI?: string | null | undefined;
          readonly location?:
            | {
                readonly __typename?: 'Location';
                readonly latitude?: string | null | undefined;
                readonly longitude?: string | null | undefined;
              }
            | null
            | undefined;
        }
      | null
      | undefined;
    readonly alternateDriver?:
      | {
          readonly __typename?: 'Driver';
          readonly id: string;
          readonly received?: boolean | null | undefined;
          readonly name?: string | null | undefined;
          readonly phone?: string | null | undefined;
          readonly alternatePhone?: string | null | undefined;
          readonly email?: string | null | undefined;
          readonly type?: string | null | undefined;
          readonly status?: string | null | undefined;
          readonly inPrisma?: boolean | null | undefined;
          readonly inVolcano?: boolean | null | undefined;
          readonly location?:
            | {
                readonly __typename?: 'Location';
                readonly latitude?: string | null | undefined;
                readonly longitude?: string | null | undefined;
              }
            | null
            | undefined;
        }
      | null
      | undefined;
    readonly drivers: ReadonlyArray<{
      readonly __typename?: 'Driver';
      readonly id: string;
      readonly received?: boolean | null | undefined;
      readonly name?: string | null | undefined;
      readonly phone?: string | null | undefined;
      readonly alternatePhone?: string | null | undefined;
      readonly email?: string | null | undefined;
      readonly type?: string | null | undefined;
      readonly status?: string | null | undefined;
      readonly inPrisma?: boolean | null | undefined;
      readonly inVolcano?: boolean | null | undefined;
      readonly location?:
        | {
            readonly __typename?: 'Location';
            readonly latitude?: string | null | undefined;
            readonly longitude?: string | null | undefined;
          }
        | null
        | undefined;
    }>;
    readonly drivingCompany?:
      | {
          readonly __typename?: 'DrivingCompany';
          readonly id: string;
          readonly email?: string | null | undefined;
          readonly volcanoId?: string | null | undefined;
          readonly name?: string | null | undefined;
          readonly phone?: string | null | undefined;
        }
      | null
      | undefined;
    readonly vehicle?:
      | {
          readonly __typename?: 'Vehicle';
          readonly id: string;
          readonly origin?: string | null | undefined;
          readonly type?: string | null | undefined;
          readonly typeID?: number | null | undefined;
          readonly typeDescription?: string | null | undefined;
          readonly status?: string | null | undefined;
          readonly licensePlate?: string | null | undefined;
          readonly brand?: string | null | undefined;
          readonly model?: string | null | undefined;
          readonly location?:
            | {
                readonly __typename?: 'Location';
                readonly latitude?: string | null | undefined;
                readonly longitude?: string | null | undefined;
              }
            | null
            | undefined;
        }
      | null
      | undefined;
  };
};

export type OnUpdateServiceSubscriptionSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type OnUpdateServiceSubscriptionSubscription = {
  readonly __typename?: 'Subscription';
  readonly onUpdateService: {
    readonly __typename?: 'Service';
    readonly id: string;
    readonly budgetReadableId?: string | null | undefined;
    readonly typeId?: string | null | undefined;
    readonly volcanoServiceId?: string | null | undefined;
    readonly status?: string | null | undefined;
    readonly reference?: string | null | undefined;
    readonly serieFact?: string | null | undefined;
    readonly itineraryDescription?: string | null | undefined;
    readonly numOfPassengers?: number | null | undefined;
    readonly presentationTime?: string | null | undefined;
    readonly notes?: string | null | undefined;
    readonly description?: string | null | undefined;
    readonly requestedVehicleDescription?: string | null | undefined;
    readonly passengers: ReadonlyArray<{
      readonly __typename?: 'Passenger';
      readonly id: string;
      readonly name?: string | null | undefined;
      readonly phone?: string | null | undefined;
      readonly email: string;
    }>;
    readonly departure?:
      | {
          readonly __typename?: 'DepartureOrArrival';
          readonly date?: string | null | undefined;
          readonly time?: string | null | undefined;
          readonly address?: string | null | undefined;
          readonly lat?: number | null | undefined;
          readonly lon?: number | null | undefined;
        }
      | null
      | undefined;
    readonly arrival?:
      | {
          readonly __typename?: 'DepartureOrArrival';
          readonly date?: string | null | undefined;
          readonly time?: string | null | undefined;
          readonly address?: string | null | undefined;
          readonly lat?: number | null | undefined;
          readonly lon?: number | null | undefined;
        }
      | null
      | undefined;
    readonly client?:
      | {
          readonly __typename?: 'Client';
          readonly name?: string | null | undefined;
          readonly id: string;
        }
      | null
      | undefined;
    readonly driver?:
      | {
          readonly __typename?: 'Driver';
          readonly id: string;
          readonly received?: boolean | null | undefined;
          readonly name?: string | null | undefined;
          readonly phone?: string | null | undefined;
          readonly alternatePhone?: string | null | undefined;
          readonly email?: string | null | undefined;
          readonly type?: string | null | undefined;
          readonly status?: string | null | undefined;
          readonly inPrisma?: boolean | null | undefined;
          readonly inVolcano?: boolean | null | undefined;
          readonly profilePicURI?: string | null | undefined;
          readonly location?:
            | {
                readonly __typename?: 'Location';
                readonly latitude?: string | null | undefined;
                readonly longitude?: string | null | undefined;
              }
            | null
            | undefined;
        }
      | null
      | undefined;
    readonly alternateDriver?:
      | {
          readonly __typename?: 'Driver';
          readonly id: string;
          readonly received?: boolean | null | undefined;
          readonly name?: string | null | undefined;
          readonly phone?: string | null | undefined;
          readonly alternatePhone?: string | null | undefined;
          readonly email?: string | null | undefined;
          readonly type?: string | null | undefined;
          readonly status?: string | null | undefined;
          readonly inPrisma?: boolean | null | undefined;
          readonly inVolcano?: boolean | null | undefined;
          readonly location?:
            | {
                readonly __typename?: 'Location';
                readonly latitude?: string | null | undefined;
                readonly longitude?: string | null | undefined;
              }
            | null
            | undefined;
        }
      | null
      | undefined;
    readonly drivers: ReadonlyArray<{
      readonly __typename?: 'Driver';
      readonly id: string;
      readonly received?: boolean | null | undefined;
      readonly name?: string | null | undefined;
      readonly phone?: string | null | undefined;
      readonly alternatePhone?: string | null | undefined;
      readonly email?: string | null | undefined;
      readonly type?: string | null | undefined;
      readonly status?: string | null | undefined;
      readonly inPrisma?: boolean | null | undefined;
      readonly inVolcano?: boolean | null | undefined;
      readonly location?:
        | {
            readonly __typename?: 'Location';
            readonly latitude?: string | null | undefined;
            readonly longitude?: string | null | undefined;
          }
        | null
        | undefined;
    }>;
    readonly drivingCompany?:
      | {
          readonly __typename?: 'DrivingCompany';
          readonly id: string;
          readonly email?: string | null | undefined;
          readonly volcanoId?: string | null | undefined;
          readonly name?: string | null | undefined;
          readonly phone?: string | null | undefined;
        }
      | null
      | undefined;
    readonly vehicle?:
      | {
          readonly __typename?: 'Vehicle';
          readonly id: string;
          readonly origin?: string | null | undefined;
          readonly type?: string | null | undefined;
          readonly typeID?: number | null | undefined;
          readonly typeDescription?: string | null | undefined;
          readonly status?: string | null | undefined;
          readonly licensePlate?: string | null | undefined;
          readonly brand?: string | null | undefined;
          readonly model?: string | null | undefined;
          readonly location?:
            | {
                readonly __typename?: 'Location';
                readonly latitude?: string | null | undefined;
                readonly longitude?: string | null | undefined;
              }
            | null
            | undefined;
        }
      | null
      | undefined;
  };
};

export type GetServiceDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetServiceDetailsQuery = {
  readonly __typename?: 'Query';
  readonly service?:
    | {
        readonly __typename?: 'Service';
        readonly id: string;
        readonly budgetReadableId?: string | null | undefined;
        readonly typeId?: string | null | undefined;
        readonly volcanoServiceId?: string | null | undefined;
        readonly status?: string | null | undefined;
        readonly reference?: string | null | undefined;
        readonly serieFact?: string | null | undefined;
        readonly itineraryDescription?: string | null | undefined;
        readonly numOfPassengers?: number | null | undefined;
        readonly presentationTime?: string | null | undefined;
        readonly notes?: string | null | undefined;
        readonly description?: string | null | undefined;
        readonly requestedVehicleDescription?: string | null | undefined;
        readonly passengers: ReadonlyArray<{
          readonly __typename?: 'Passenger';
          readonly id: string;
          readonly name?: string | null | undefined;
          readonly phone?: string | null | undefined;
          readonly email: string;
        }>;
        readonly departure?:
          | {
              readonly __typename?: 'DepartureOrArrival';
              readonly date?: string | null | undefined;
              readonly time?: string | null | undefined;
              readonly address?: string | null | undefined;
              readonly lat?: number | null | undefined;
              readonly lon?: number | null | undefined;
            }
          | null
          | undefined;
        readonly arrival?:
          | {
              readonly __typename?: 'DepartureOrArrival';
              readonly date?: string | null | undefined;
              readonly time?: string | null | undefined;
              readonly address?: string | null | undefined;
              readonly lat?: number | null | undefined;
              readonly lon?: number | null | undefined;
            }
          | null
          | undefined;
        readonly client?:
          | {
              readonly __typename?: 'Client';
              readonly name?: string | null | undefined;
              readonly id: string;
            }
          | null
          | undefined;
        readonly driver?:
          | {
              readonly __typename?: 'Driver';
              readonly id: string;
              readonly received?: boolean | null | undefined;
              readonly name?: string | null | undefined;
              readonly phone?: string | null | undefined;
              readonly alternatePhone?: string | null | undefined;
              readonly email?: string | null | undefined;
              readonly type?: string | null | undefined;
              readonly status?: string | null | undefined;
              readonly inPrisma?: boolean | null | undefined;
              readonly inVolcano?: boolean | null | undefined;
              readonly profilePicURI?: string | null | undefined;
              readonly location?:
                | {
                    readonly __typename?: 'Location';
                    readonly latitude?: string | null | undefined;
                    readonly longitude?: string | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
        readonly alternateDriver?:
          | {
              readonly __typename?: 'Driver';
              readonly id: string;
              readonly received?: boolean | null | undefined;
              readonly name?: string | null | undefined;
              readonly phone?: string | null | undefined;
              readonly alternatePhone?: string | null | undefined;
              readonly email?: string | null | undefined;
              readonly type?: string | null | undefined;
              readonly status?: string | null | undefined;
              readonly inPrisma?: boolean | null | undefined;
              readonly inVolcano?: boolean | null | undefined;
              readonly location?:
                | {
                    readonly __typename?: 'Location';
                    readonly latitude?: string | null | undefined;
                    readonly longitude?: string | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
        readonly drivers: ReadonlyArray<{
          readonly __typename?: 'Driver';
          readonly id: string;
          readonly received?: boolean | null | undefined;
          readonly name?: string | null | undefined;
          readonly phone?: string | null | undefined;
          readonly alternatePhone?: string | null | undefined;
          readonly email?: string | null | undefined;
          readonly type?: string | null | undefined;
          readonly status?: string | null | undefined;
          readonly inPrisma?: boolean | null | undefined;
          readonly inVolcano?: boolean | null | undefined;
          readonly location?:
            | {
                readonly __typename?: 'Location';
                readonly latitude?: string | null | undefined;
                readonly longitude?: string | null | undefined;
              }
            | null
            | undefined;
        }>;
        readonly drivingCompany?:
          | {
              readonly __typename?: 'DrivingCompany';
              readonly id: string;
              readonly email?: string | null | undefined;
              readonly volcanoId?: string | null | undefined;
              readonly name?: string | null | undefined;
              readonly phone?: string | null | undefined;
            }
          | null
          | undefined;
        readonly vehicle?:
          | {
              readonly __typename?: 'Vehicle';
              readonly id: string;
              readonly origin?: string | null | undefined;
              readonly type?: string | null | undefined;
              readonly typeID?: number | null | undefined;
              readonly typeDescription?: string | null | undefined;
              readonly status?: string | null | undefined;
              readonly licensePlate?: string | null | undefined;
              readonly brand?: string | null | undefined;
              readonly model?: string | null | undefined;
              readonly location?:
                | {
                    readonly __typename?: 'Location';
                    readonly latitude?: string | null | undefined;
                    readonly longitude?: string | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type ServiceTypesQueryVariables = Exact<{ [key: string]: never }>;

export type ServiceTypesQuery = {
  readonly __typename?: 'Query';
  readonly serviceTypes: ReadonlyArray<{
    readonly __typename?: 'ServiceType';
    readonly id: string;
    readonly typeId: string;
    readonly description: string;
    readonly name: string;
  }>;
};

export type CreateServiceMutationVariables = Exact<{
  departureTime: Scalars['String'];
  departureDate: Scalars['String'];
  presentationTime: Scalars['String'];
  arrivalDate: Scalars['String'];
  arrivalTime: Scalars['String'];
  type: Scalars['String'];
  clientId?: InputMaybe<Scalars['String']>;
  mainDriverId?: InputMaybe<Scalars['String']>;
  secondaryDriverId?: InputMaybe<Scalars['String']>;
  vehicleId?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  numOfPassengers: Scalars['Int'];
  description: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  flightNumber?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
  departureAddress?: InputMaybe<Scalars['String']>;
  departureLat?: InputMaybe<Scalars['Float']>;
  departureLon?: InputMaybe<Scalars['Float']>;
  arrivalAddress?: InputMaybe<Scalars['String']>;
  arrivalLat?: InputMaybe<Scalars['Float']>;
  arrivalLon?: InputMaybe<Scalars['Float']>;
  groupName?: InputMaybe<Scalars['String']>;
  groupOwner?: InputMaybe<Scalars['String']>;
}>;

export type CreateServiceMutation = {
  readonly __typename?: 'Mutation';
  readonly createService?:
    | {
        readonly __typename?: 'Service';
        readonly id: string;
        readonly budgetReadableId?: string | null | undefined;
        readonly typeId?: string | null | undefined;
        readonly volcanoServiceId?: string | null | undefined;
        readonly status?: string | null | undefined;
        readonly reference?: string | null | undefined;
        readonly serieFact?: string | null | undefined;
        readonly itineraryDescription?: string | null | undefined;
        readonly numOfPassengers?: number | null | undefined;
        readonly presentationTime?: string | null | undefined;
        readonly notes?: string | null | undefined;
        readonly description?: string | null | undefined;
        readonly requestedVehicleDescription?: string | null | undefined;
        readonly passengers: ReadonlyArray<{
          readonly __typename?: 'Passenger';
          readonly id: string;
          readonly name?: string | null | undefined;
          readonly phone?: string | null | undefined;
          readonly email: string;
        }>;
        readonly departure?:
          | {
              readonly __typename?: 'DepartureOrArrival';
              readonly date?: string | null | undefined;
              readonly time?: string | null | undefined;
              readonly address?: string | null | undefined;
              readonly lat?: number | null | undefined;
              readonly lon?: number | null | undefined;
            }
          | null
          | undefined;
        readonly arrival?:
          | {
              readonly __typename?: 'DepartureOrArrival';
              readonly date?: string | null | undefined;
              readonly time?: string | null | undefined;
              readonly address?: string | null | undefined;
              readonly lat?: number | null | undefined;
              readonly lon?: number | null | undefined;
            }
          | null
          | undefined;
        readonly client?:
          | {
              readonly __typename?: 'Client';
              readonly name?: string | null | undefined;
              readonly id: string;
            }
          | null
          | undefined;
        readonly driver?:
          | {
              readonly __typename?: 'Driver';
              readonly id: string;
              readonly received?: boolean | null | undefined;
              readonly name?: string | null | undefined;
              readonly phone?: string | null | undefined;
              readonly alternatePhone?: string | null | undefined;
              readonly email?: string | null | undefined;
              readonly type?: string | null | undefined;
              readonly status?: string | null | undefined;
              readonly inPrisma?: boolean | null | undefined;
              readonly inVolcano?: boolean | null | undefined;
              readonly profilePicURI?: string | null | undefined;
              readonly location?:
                | {
                    readonly __typename?: 'Location';
                    readonly latitude?: string | null | undefined;
                    readonly longitude?: string | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
        readonly alternateDriver?:
          | {
              readonly __typename?: 'Driver';
              readonly id: string;
              readonly received?: boolean | null | undefined;
              readonly name?: string | null | undefined;
              readonly phone?: string | null | undefined;
              readonly alternatePhone?: string | null | undefined;
              readonly email?: string | null | undefined;
              readonly type?: string | null | undefined;
              readonly status?: string | null | undefined;
              readonly inPrisma?: boolean | null | undefined;
              readonly inVolcano?: boolean | null | undefined;
              readonly location?:
                | {
                    readonly __typename?: 'Location';
                    readonly latitude?: string | null | undefined;
                    readonly longitude?: string | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
        readonly drivers: ReadonlyArray<{
          readonly __typename?: 'Driver';
          readonly id: string;
          readonly received?: boolean | null | undefined;
          readonly name?: string | null | undefined;
          readonly phone?: string | null | undefined;
          readonly alternatePhone?: string | null | undefined;
          readonly email?: string | null | undefined;
          readonly type?: string | null | undefined;
          readonly status?: string | null | undefined;
          readonly inPrisma?: boolean | null | undefined;
          readonly inVolcano?: boolean | null | undefined;
          readonly location?:
            | {
                readonly __typename?: 'Location';
                readonly latitude?: string | null | undefined;
                readonly longitude?: string | null | undefined;
              }
            | null
            | undefined;
        }>;
        readonly drivingCompany?:
          | {
              readonly __typename?: 'DrivingCompany';
              readonly id: string;
              readonly email?: string | null | undefined;
              readonly volcanoId?: string | null | undefined;
              readonly name?: string | null | undefined;
              readonly phone?: string | null | undefined;
            }
          | null
          | undefined;
        readonly vehicle?:
          | {
              readonly __typename?: 'Vehicle';
              readonly id: string;
              readonly origin?: string | null | undefined;
              readonly type?: string | null | undefined;
              readonly typeID?: number | null | undefined;
              readonly typeDescription?: string | null | undefined;
              readonly status?: string | null | undefined;
              readonly licensePlate?: string | null | undefined;
              readonly brand?: string | null | undefined;
              readonly model?: string | null | undefined;
              readonly location?:
                | {
                    readonly __typename?: 'Location';
                    readonly latitude?: string | null | undefined;
                    readonly longitude?: string | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type EditServiceMutationVariables = Exact<{
  id: Scalars['ID'];
  volcanoServiceId: Scalars['String'];
  departureTime: Scalars['String'];
  departureDate: Scalars['String'];
  presentationTime: Scalars['String'];
  arrivalDate: Scalars['String'];
  arrivalTime: Scalars['String'];
  mainDriverId?: InputMaybe<Scalars['String']>;
  secondaryDriverId?: InputMaybe<Scalars['String']>;
  vehicleId?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  numOfPassengers: Scalars['Int'];
  description: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  departureAddress?: InputMaybe<Scalars['String']>;
  departureLat?: InputMaybe<Scalars['Float']>;
  departureLon?: InputMaybe<Scalars['Float']>;
  arrivalAddress?: InputMaybe<Scalars['String']>;
  arrivalLat?: InputMaybe<Scalars['Float']>;
  arrivalLon?: InputMaybe<Scalars['Float']>;
}>;

export type EditServiceMutation = {
  readonly __typename?: 'Mutation';
  readonly editService: {
    readonly __typename?: 'Service';
    readonly id: string;
    readonly budgetReadableId?: string | null | undefined;
    readonly typeId?: string | null | undefined;
    readonly volcanoServiceId?: string | null | undefined;
    readonly status?: string | null | undefined;
    readonly reference?: string | null | undefined;
    readonly serieFact?: string | null | undefined;
    readonly itineraryDescription?: string | null | undefined;
    readonly numOfPassengers?: number | null | undefined;
    readonly presentationTime?: string | null | undefined;
    readonly notes?: string | null | undefined;
    readonly description?: string | null | undefined;
    readonly requestedVehicleDescription?: string | null | undefined;
    readonly passengers: ReadonlyArray<{
      readonly __typename?: 'Passenger';
      readonly id: string;
      readonly name?: string | null | undefined;
      readonly phone?: string | null | undefined;
      readonly email: string;
    }>;
    readonly departure?:
      | {
          readonly __typename?: 'DepartureOrArrival';
          readonly date?: string | null | undefined;
          readonly time?: string | null | undefined;
          readonly address?: string | null | undefined;
          readonly lat?: number | null | undefined;
          readonly lon?: number | null | undefined;
        }
      | null
      | undefined;
    readonly arrival?:
      | {
          readonly __typename?: 'DepartureOrArrival';
          readonly date?: string | null | undefined;
          readonly time?: string | null | undefined;
          readonly address?: string | null | undefined;
          readonly lat?: number | null | undefined;
          readonly lon?: number | null | undefined;
        }
      | null
      | undefined;
    readonly client?:
      | {
          readonly __typename?: 'Client';
          readonly name?: string | null | undefined;
          readonly id: string;
        }
      | null
      | undefined;
    readonly driver?:
      | {
          readonly __typename?: 'Driver';
          readonly id: string;
          readonly received?: boolean | null | undefined;
          readonly name?: string | null | undefined;
          readonly phone?: string | null | undefined;
          readonly alternatePhone?: string | null | undefined;
          readonly email?: string | null | undefined;
          readonly type?: string | null | undefined;
          readonly status?: string | null | undefined;
          readonly inPrisma?: boolean | null | undefined;
          readonly inVolcano?: boolean | null | undefined;
          readonly profilePicURI?: string | null | undefined;
          readonly location?:
            | {
                readonly __typename?: 'Location';
                readonly latitude?: string | null | undefined;
                readonly longitude?: string | null | undefined;
              }
            | null
            | undefined;
        }
      | null
      | undefined;
    readonly alternateDriver?:
      | {
          readonly __typename?: 'Driver';
          readonly id: string;
          readonly received?: boolean | null | undefined;
          readonly name?: string | null | undefined;
          readonly phone?: string | null | undefined;
          readonly alternatePhone?: string | null | undefined;
          readonly email?: string | null | undefined;
          readonly type?: string | null | undefined;
          readonly status?: string | null | undefined;
          readonly inPrisma?: boolean | null | undefined;
          readonly inVolcano?: boolean | null | undefined;
          readonly location?:
            | {
                readonly __typename?: 'Location';
                readonly latitude?: string | null | undefined;
                readonly longitude?: string | null | undefined;
              }
            | null
            | undefined;
        }
      | null
      | undefined;
    readonly drivers: ReadonlyArray<{
      readonly __typename?: 'Driver';
      readonly id: string;
      readonly received?: boolean | null | undefined;
      readonly name?: string | null | undefined;
      readonly phone?: string | null | undefined;
      readonly alternatePhone?: string | null | undefined;
      readonly email?: string | null | undefined;
      readonly type?: string | null | undefined;
      readonly status?: string | null | undefined;
      readonly inPrisma?: boolean | null | undefined;
      readonly inVolcano?: boolean | null | undefined;
      readonly location?:
        | {
            readonly __typename?: 'Location';
            readonly latitude?: string | null | undefined;
            readonly longitude?: string | null | undefined;
          }
        | null
        | undefined;
    }>;
    readonly drivingCompany?:
      | {
          readonly __typename?: 'DrivingCompany';
          readonly id: string;
          readonly email?: string | null | undefined;
          readonly volcanoId?: string | null | undefined;
          readonly name?: string | null | undefined;
          readonly phone?: string | null | undefined;
        }
      | null
      | undefined;
    readonly vehicle?:
      | {
          readonly __typename?: 'Vehicle';
          readonly id: string;
          readonly origin?: string | null | undefined;
          readonly type?: string | null | undefined;
          readonly typeID?: number | null | undefined;
          readonly typeDescription?: string | null | undefined;
          readonly status?: string | null | undefined;
          readonly licensePlate?: string | null | undefined;
          readonly brand?: string | null | undefined;
          readonly model?: string | null | undefined;
          readonly location?:
            | {
                readonly __typename?: 'Location';
                readonly latitude?: string | null | undefined;
                readonly longitude?: string | null | undefined;
              }
            | null
            | undefined;
        }
      | null
      | undefined;
  };
};

export type ServiceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ServiceQuery = {
  readonly __typename?: 'Query';
  readonly service?:
    | {
        readonly __typename?: 'Service';
        readonly id: string;
        readonly budgetReadableId?: string | null | undefined;
        readonly typeId?: string | null | undefined;
        readonly volcanoServiceId?: string | null | undefined;
        readonly status?: string | null | undefined;
        readonly reference?: string | null | undefined;
        readonly serieFact?: string | null | undefined;
        readonly itineraryDescription?: string | null | undefined;
        readonly numOfPassengers?: number | null | undefined;
        readonly presentationTime?: string | null | undefined;
        readonly notes?: string | null | undefined;
        readonly description?: string | null | undefined;
        readonly requestedVehicleDescription?: string | null | undefined;
        readonly passengers: ReadonlyArray<{
          readonly __typename?: 'Passenger';
          readonly id: string;
          readonly name?: string | null | undefined;
          readonly phone?: string | null | undefined;
          readonly email: string;
        }>;
        readonly departure?:
          | {
              readonly __typename?: 'DepartureOrArrival';
              readonly date?: string | null | undefined;
              readonly time?: string | null | undefined;
              readonly address?: string | null | undefined;
              readonly lat?: number | null | undefined;
              readonly lon?: number | null | undefined;
            }
          | null
          | undefined;
        readonly arrival?:
          | {
              readonly __typename?: 'DepartureOrArrival';
              readonly date?: string | null | undefined;
              readonly time?: string | null | undefined;
              readonly address?: string | null | undefined;
              readonly lat?: number | null | undefined;
              readonly lon?: number | null | undefined;
            }
          | null
          | undefined;
        readonly client?:
          | {
              readonly __typename?: 'Client';
              readonly name?: string | null | undefined;
              readonly id: string;
            }
          | null
          | undefined;
        readonly driver?:
          | {
              readonly __typename?: 'Driver';
              readonly id: string;
              readonly received?: boolean | null | undefined;
              readonly name?: string | null | undefined;
              readonly phone?: string | null | undefined;
              readonly alternatePhone?: string | null | undefined;
              readonly email?: string | null | undefined;
              readonly type?: string | null | undefined;
              readonly status?: string | null | undefined;
              readonly inPrisma?: boolean | null | undefined;
              readonly inVolcano?: boolean | null | undefined;
              readonly profilePicURI?: string | null | undefined;
              readonly location?:
                | {
                    readonly __typename?: 'Location';
                    readonly latitude?: string | null | undefined;
                    readonly longitude?: string | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
        readonly alternateDriver?:
          | {
              readonly __typename?: 'Driver';
              readonly id: string;
              readonly received?: boolean | null | undefined;
              readonly name?: string | null | undefined;
              readonly phone?: string | null | undefined;
              readonly alternatePhone?: string | null | undefined;
              readonly email?: string | null | undefined;
              readonly type?: string | null | undefined;
              readonly status?: string | null | undefined;
              readonly inPrisma?: boolean | null | undefined;
              readonly inVolcano?: boolean | null | undefined;
              readonly location?:
                | {
                    readonly __typename?: 'Location';
                    readonly latitude?: string | null | undefined;
                    readonly longitude?: string | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
        readonly drivers: ReadonlyArray<{
          readonly __typename?: 'Driver';
          readonly id: string;
          readonly received?: boolean | null | undefined;
          readonly name?: string | null | undefined;
          readonly phone?: string | null | undefined;
          readonly alternatePhone?: string | null | undefined;
          readonly email?: string | null | undefined;
          readonly type?: string | null | undefined;
          readonly status?: string | null | undefined;
          readonly inPrisma?: boolean | null | undefined;
          readonly inVolcano?: boolean | null | undefined;
          readonly location?:
            | {
                readonly __typename?: 'Location';
                readonly latitude?: string | null | undefined;
                readonly longitude?: string | null | undefined;
              }
            | null
            | undefined;
        }>;
        readonly drivingCompany?:
          | {
              readonly __typename?: 'DrivingCompany';
              readonly id: string;
              readonly email?: string | null | undefined;
              readonly volcanoId?: string | null | undefined;
              readonly name?: string | null | undefined;
              readonly phone?: string | null | undefined;
            }
          | null
          | undefined;
        readonly vehicle?:
          | {
              readonly __typename?: 'Vehicle';
              readonly id: string;
              readonly origin?: string | null | undefined;
              readonly type?: string | null | undefined;
              readonly typeID?: number | null | undefined;
              readonly typeDescription?: string | null | undefined;
              readonly status?: string | null | undefined;
              readonly licensePlate?: string | null | undefined;
              readonly brand?: string | null | undefined;
              readonly model?: string | null | undefined;
              readonly location?:
                | {
                    readonly __typename?: 'Location';
                    readonly latitude?: string | null | undefined;
                    readonly longitude?: string | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type SearchServicesQueryVariables = Exact<{
  text: Scalars['String'];
}>;

export type SearchServicesQuery = {
  readonly __typename?: 'Query';
  readonly searchServices: ReadonlyArray<{
    readonly __typename?: 'Service';
    readonly id: string;
    readonly budgetReadableId?: string | null | undefined;
    readonly typeId?: string | null | undefined;
    readonly volcanoServiceId?: string | null | undefined;
    readonly status?: string | null | undefined;
    readonly reference?: string | null | undefined;
    readonly serieFact?: string | null | undefined;
    readonly itineraryDescription?: string | null | undefined;
    readonly numOfPassengers?: number | null | undefined;
    readonly presentationTime?: string | null | undefined;
    readonly notes?: string | null | undefined;
    readonly description?: string | null | undefined;
    readonly requestedVehicleDescription?: string | null | undefined;
  }>;
};

export type OfferServiceMutationVariables = Exact<{
  serviceIds: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
}>;

export type OfferServiceMutation = {
  readonly __typename?: 'Mutation';
  readonly createServiceOffer: ReadonlyArray<{
    readonly __typename?: 'ServiceOffer';
    readonly id: string;
    readonly createdAt: string;
    readonly updatedAt: string;
  }>;
};

export type ServiceOffersQueryVariables = Exact<{ [key: string]: never }>;

export type ServiceOffersQuery = {
  readonly __typename?: 'Query';
  readonly serviceOffers: ReadonlyArray<{
    readonly __typename?: 'ServiceOffer';
    readonly id: string;
    readonly createdAt: string;
    readonly updatedAt: string;
    readonly service?:
      | {
          readonly __typename?: 'Service';
          readonly id: string;
          readonly volcanoServiceId?: string | null | undefined;
          readonly description?: string | null | undefined;
          readonly numOfPassengers?: number | null | undefined;
          readonly reference?: string | null | undefined;
          readonly requestedVehicleDescription?: string | null | undefined;
          readonly departure?:
            | {
                readonly __typename?: 'DepartureOrArrival';
                readonly address?: string | null | undefined;
                readonly date?: string | null | undefined;
                readonly time?: string | null | undefined;
              }
            | null
            | undefined;
          readonly arrival?:
            | {
                readonly __typename?: 'DepartureOrArrival';
                readonly address?: string | null | undefined;
                readonly date?: string | null | undefined;
                readonly time?: string | null | undefined;
              }
            | null
            | undefined;
          readonly client?:
            | {
                readonly __typename?: 'Client';
                readonly name?: string | null | undefined;
              }
            | null
            | undefined;
          readonly vehicle?:
            | {
                readonly __typename?: 'Vehicle';
                readonly id: string;
                readonly type?: string | null | undefined;
                readonly origin?: string | null | undefined;
                readonly typeID?: number | null | undefined;
                readonly typeDescription?: string | null | undefined;
                readonly brand?: string | null | undefined;
                readonly model?: string | null | undefined;
              }
            | null
            | undefined;
        }
      | null
      | undefined;
    readonly bids: ReadonlyArray<{
      readonly __typename?: 'ServiceOfferBid';
      readonly id: string;
      readonly createdAt: string;
      readonly updatedAt: string;
      readonly status: ServiceOfferUpdateStatus;
      readonly drivingCompany: {
        readonly __typename?: 'DrivingCompany';
        readonly id: string;
        readonly volcanoId?: string | null | undefined;
        readonly name?: string | null | undefined;
      };
    }>;
  }>;
};

export type DeleteServiceOfferMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteServiceOfferMutation = {
  readonly __typename?: 'Mutation';
  readonly ServiceOffer: {
    readonly __typename?: 'ServiceOfferNestedMutation';
    readonly delete?:
      | {
          readonly __typename?: 'DeleteResult';
          readonly deleted: boolean;
          readonly reason?: string | null | undefined;
        }
      | null
      | undefined;
  };
};

export type DeleteServiceOffersMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
}>;

export type DeleteServiceOffersMutation = {
  readonly __typename?: 'Mutation';
  readonly deleteServiceOffer: boolean;
};

export type AcceptServiceOfferBidMutationVariables = Exact<{
  serviceOfferId: Scalars['ID'];
  bidId: Scalars['ID'];
}>;

export type AcceptServiceOfferBidMutation = {
  readonly __typename?: 'Mutation';
  readonly ServiceOffer: {
    readonly __typename?: 'ServiceOfferNestedMutation';
    readonly acceptBid?:
      | {
          readonly __typename?: 'ServiceOffer';
          readonly id: string;
          readonly updatedAt: string;
          readonly createdAt: string;
          readonly bids: ReadonlyArray<{
            readonly __typename?: 'ServiceOfferBid';
            readonly updatedAt: string;
            readonly id: string;
            readonly status: ServiceOfferUpdateStatus;
          }>;
        }
      | null
      | undefined;
  };
};

export type RejectServiceOfferBidMutationVariables = Exact<{
  serviceOfferId: Scalars['ID'];
  bidId: Scalars['ID'];
}>;

export type RejectServiceOfferBidMutation = {
  readonly __typename?: 'Mutation';
  readonly ServiceOffer: {
    readonly __typename?: 'ServiceOfferNestedMutation';
    readonly rejectBid?:
      | {
          readonly __typename?: 'ServiceOffer';
          readonly id: string;
          readonly updatedAt: string;
          readonly createdAt: string;
          readonly bids: ReadonlyArray<{
            readonly __typename?: 'ServiceOfferBid';
            readonly updatedAt: string;
            readonly id: string;
            readonly status: ServiceOfferUpdateStatus;
          }>;
        }
      | null
      | undefined;
  };
};

export type IgnoreServiceOfferBidMutationVariables = Exact<{
  serviceOfferId: Scalars['ID'];
  bidId: Scalars['ID'];
}>;

export type IgnoreServiceOfferBidMutation = {
  readonly __typename?: 'Mutation';
  readonly ServiceOffer: {
    readonly __typename?: 'ServiceOfferNestedMutation';
    readonly ignoreBid?:
      | {
          readonly __typename?: 'ServiceOffer';
          readonly id: string;
          readonly updatedAt: string;
          readonly createdAt: string;
          readonly bids: ReadonlyArray<{
            readonly __typename?: 'ServiceOfferBid';
            readonly updatedAt: string;
            readonly id: string;
            readonly status: ServiceOfferUpdateStatus;
          }>;
        }
      | null
      | undefined;
  };
};

export type BidServiceOfferMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type BidServiceOfferMutation = {
  readonly __typename?: 'Mutation';
  readonly ServiceOffer: {
    readonly __typename?: 'ServiceOfferNestedMutation';
    readonly bid?:
      | {
          readonly __typename?: 'ServiceOffer';
          readonly id: string;
          readonly bids: ReadonlyArray<{
            readonly __typename?: 'ServiceOfferBid';
            readonly id: string;
            readonly createdAt: string;
            readonly updatedAt: string;
            readonly drivingCompany: {
              readonly __typename?: 'DrivingCompany';
              readonly id: string;
            };
          }>;
        }
      | null
      | undefined;
  };
};

export type UnbidServiceOfferMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type UnbidServiceOfferMutation = {
  readonly __typename?: 'Mutation';
  readonly ServiceOffer: {
    readonly __typename?: 'ServiceOfferNestedMutation';
    readonly unbid?:
      | {
          readonly __typename?: 'ServiceOffer';
          readonly id: string;
          readonly bids: ReadonlyArray<{
            readonly __typename?: 'ServiceOfferBid';
            readonly id: string;
            readonly createdAt: string;
            readonly updatedAt: string;
            readonly drivingCompany: {
              readonly __typename?: 'DrivingCompany';
              readonly id: string;
            };
          }>;
        }
      | null
      | undefined;
  };
};

export type ServicesQueryVariables = Exact<{
  departureDateMin?: InputMaybe<Scalars['String']>;
  departureDateMax?: InputMaybe<Scalars['String']>;
  includeOffers: Scalars['Boolean'];
  includeDrivingCompany: Scalars['Boolean'];
}>;

export type ServicesQuery = {
  readonly __typename?: 'Query';
  readonly services?:
    | ReadonlyArray<{
        readonly __typename?: 'Service';
        readonly id: string;
        readonly volcanoServiceId?: string | null | undefined;
        readonly budgetReadableId?: string | null | undefined;
        readonly description?: string | null | undefined;
        readonly requestedVehicleDescription?: string | null | undefined;
        readonly status?: string | null | undefined;
        readonly reference?: string | null | undefined;
        readonly itineraryDescription?: string | null | undefined;
        readonly numOfPassengers?: number | null | undefined;
        readonly client?:
          | {
              readonly __typename?: 'Client';
              readonly id: string;
              readonly email?: string | null | undefined;
              readonly name?: string | null | undefined;
              readonly volcanoClientId?: string | null | undefined;
            }
          | null
          | undefined;
        readonly departure?:
          | {
              readonly __typename?: 'DepartureOrArrival';
              readonly date?: string | null | undefined;
              readonly time?: string | null | undefined;
              readonly address?: string | null | undefined;
            }
          | null
          | undefined;
        readonly drivingCompany?:
          | {
              readonly __typename?: 'DrivingCompany';
              readonly id: string;
              readonly name?: string | null | undefined;
              readonly email?: string | null | undefined;
              readonly phone?: string | null | undefined;
              readonly volcanoId?: string | null | undefined;
            }
          | null
          | undefined;
        readonly offers?: ReadonlyArray<{
          readonly __typename?: 'ServiceOffer';
          readonly id: string;
          readonly createdAt: string;
          readonly updatedAt: string;
        }>;
        readonly arrival?:
          | {
              readonly __typename?: 'DepartureOrArrival';
              readonly date?: string | null | undefined;
              readonly time?: string | null | undefined;
              readonly address?: string | null | undefined;
            }
          | null
          | undefined;
      }>
    | null
    | undefined;
};

export type ListTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type ListTemplatesQuery = {
  readonly __typename?: 'Query';
  readonly templates: ReadonlyArray<{
    readonly __typename?: 'RichTemplate';
    readonly id: number;
    readonly name: string;
    readonly heading: Record<string, unknown>;
    readonly body: Record<string, unknown>;
    readonly createdAt: Date;
    readonly updatedAt: Date;
    readonly numClients: number;
  }>;
};

export type CreateTemplateMutationVariables = Exact<{
  name: Scalars['String'];
  heading: Scalars['JSONObject'];
  body: Scalars['JSONObject'];
}>;

export type CreateTemplateMutation = {
  readonly __typename?: 'Mutation';
  readonly createTemplate: {
    readonly __typename?: 'RichTemplate';
    readonly id: number;
    readonly name: string;
    readonly heading: Record<string, unknown>;
    readonly body: Record<string, unknown>;
    readonly createdAt: Date;
    readonly updatedAt: Date;
  };
};

export type DeleteTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type DeleteTemplateMutation = {
  readonly __typename?: 'Mutation';
  readonly deleteTemplate: boolean;
};

export type UpdateTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  heading?: InputMaybe<Scalars['JSONObject']>;
  body?: InputMaybe<Scalars['JSONObject']>;
}>;

export type UpdateTemplateMutation = {
  readonly __typename?: 'Mutation';
  readonly updateTemplate: {
    readonly __typename?: 'RichTemplate';
    readonly id: number;
    readonly name: string;
    readonly heading: Record<string, unknown>;
    readonly body: Record<string, unknown>;
    readonly createdAt: Date;
    readonly updatedAt: Date;
  };
};

export type DuplicateTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type DuplicateTemplateMutation = {
  readonly __typename?: 'Mutation';
  readonly duplicateTemplate: {
    readonly __typename?: 'RichTemplate';
    readonly id: number;
    readonly name: string;
    readonly heading: Record<string, unknown>;
    readonly body: Record<string, unknown>;
    readonly createdAt: Date;
    readonly updatedAt: Date;
  };
};

export type GetTemplateClientsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetTemplateClientsQuery = {
  readonly __typename?: 'Query';
  readonly template?:
    | {
        readonly __typename?: 'RichTemplate';
        readonly id: number;
        readonly name: string;
        readonly heading: Record<string, unknown>;
        readonly body: Record<string, unknown>;
        readonly createdAt: Date;
        readonly updatedAt: Date;
        readonly numClients: number;
        readonly clients: ReadonlyArray<{
          readonly __typename?: 'User';
          readonly id: string;
          readonly volcanoClientId?: string | null | undefined;
          readonly name?: string | null | undefined;
        }>;
      }
    | null
    | undefined;
};

export type AssignTemplateToClientsMutationVariables = Exact<{
  clients: ReadonlyArray<Scalars['String']> | Scalars['String'];
  templateId: Scalars['Int'];
}>;

export type AssignTemplateToClientsMutation = {
  readonly __typename?: 'Mutation';
  readonly assignTemplateToClients: {
    readonly __typename?: 'RichTemplate';
    readonly id: number;
    readonly name: string;
    readonly heading: Record<string, unknown>;
    readonly body: Record<string, unknown>;
    readonly createdAt: Date;
    readonly updatedAt: Date;
    readonly numClients: number;
    readonly clients: ReadonlyArray<{
      readonly __typename?: 'User';
      readonly id: string;
      readonly volcanoClientId?: string | null | undefined;
      readonly name?: string | null | undefined;
    }>;
  };
};

export type DisassociateTemplateFromClientsMutationVariables = Exact<{
  clients: ReadonlyArray<Scalars['String']> | Scalars['String'];
  templateId: Scalars['Int'];
}>;

export type DisassociateTemplateFromClientsMutation = {
  readonly __typename?: 'Mutation';
  readonly disassociateTemplateFromClients: {
    readonly __typename?: 'RichTemplate';
    readonly id: number;
    readonly name: string;
    readonly heading: Record<string, unknown>;
    readonly body: Record<string, unknown>;
    readonly createdAt: Date;
    readonly updatedAt: Date;
    readonly numClients: number;
    readonly clients: ReadonlyArray<{
      readonly __typename?: 'User';
      readonly id: string;
      readonly volcanoClientId?: string | null | undefined;
      readonly name?: string | null | undefined;
    }>;
  };
};

export type UserBasicFragmentFragment = {
  readonly __typename?: 'User';
  readonly id: string;
  readonly name?: string | null | undefined;
  readonly volcanoClientId?: string | null | undefined;
  readonly email?: string | null | undefined;
  readonly isAdmin: boolean;
  readonly isClient: boolean;
  readonly clientRole?: string | null | undefined;
  readonly disabled?: boolean | null | undefined;
  readonly hasWebPanelAccount: boolean;
  readonly client?:
    | { readonly __typename?: 'Client'; readonly id: string }
    | null
    | undefined;
};

export type DriverBasicFragmentFragment = {
  readonly __typename?: 'Driver';
  readonly id: string;
  readonly name?: string | null | undefined;
  readonly phone?: string | null | undefined;
  readonly email?: string | null | undefined;
  readonly status?: string | null | undefined;
  readonly alternatePhone?: string | null | undefined;
  readonly communicationLocale?: string | null | undefined;
  readonly firebaseId?: string | null | undefined;
  readonly hasLoginCredentials?: boolean | null | undefined;
  readonly loginEnabled: boolean;
  readonly notificationsToken?: string | null | undefined;
  readonly loginMethod?: LoginMethod | null | undefined;
  readonly volcanoDriverId?: string | null | undefined;
  readonly volcanoEmail?: string | null | undefined;
  readonly inPrisma?: boolean | null | undefined;
  readonly inVolcano?: boolean | null | undefined;
  readonly profilePicURI?: string | null | undefined;
  readonly drivingCompany?:
    | {
        readonly __typename?: 'DrivingCompany';
        readonly name?: string | null | undefined;
        readonly email?: string | null | undefined;
        readonly phone?: string | null | undefined;
        readonly volcanoId?: string | null | undefined;
        readonly id: string;
      }
    | null
    | undefined;
};

export type Get_Matching_Prisma_User_Or_DriverQueryVariables = Exact<{
  [key: string]: never;
}>;

export type Get_Matching_Prisma_User_Or_DriverQuery = {
  readonly __typename?: 'Query';
  readonly userOrDriver:
    | {
        readonly __typename: 'User';
        readonly id: string;
        readonly name?: string | null | undefined;
        readonly volcanoClientId?: string | null | undefined;
        readonly email?: string | null | undefined;
        readonly isAdmin: boolean;
        readonly isClient: boolean;
        readonly clientRole?: string | null | undefined;
        readonly disabled?: boolean | null | undefined;
        readonly hasWebPanelAccount: boolean;
        readonly client?:
          | { readonly __typename?: 'Client'; readonly id: string }
          | null
          | undefined;
      }
    | {
        readonly __typename: 'Driver';
        readonly id: string;
        readonly name?: string | null | undefined;
        readonly phone?: string | null | undefined;
        readonly email?: string | null | undefined;
        readonly status?: string | null | undefined;
        readonly alternatePhone?: string | null | undefined;
        readonly communicationLocale?: string | null | undefined;
        readonly firebaseId?: string | null | undefined;
        readonly hasLoginCredentials?: boolean | null | undefined;
        readonly loginEnabled: boolean;
        readonly notificationsToken?: string | null | undefined;
        readonly loginMethod?: LoginMethod | null | undefined;
        readonly volcanoDriverId?: string | null | undefined;
        readonly volcanoEmail?: string | null | undefined;
        readonly inPrisma?: boolean | null | undefined;
        readonly inVolcano?: boolean | null | undefined;
        readonly profilePicURI?: string | null | undefined;
        readonly drivingCompany?:
          | {
              readonly __typename?: 'DrivingCompany';
              readonly name?: string | null | undefined;
              readonly email?: string | null | undefined;
              readonly phone?: string | null | undefined;
              readonly volcanoId?: string | null | undefined;
              readonly id: string;
            }
          | null
          | undefined;
      };
};

export type GetMeQueryVariables = Exact<{ [key: string]: never }>;

export type GetMeQuery = {
  readonly __typename?: 'Query';
  readonly user: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly name?: string | null | undefined;
    readonly volcanoClientId?: string | null | undefined;
    readonly email?: string | null | undefined;
    readonly isAdmin: boolean;
    readonly isClient: boolean;
    readonly clientRole?: string | null | undefined;
    readonly disabled?: boolean | null | undefined;
    readonly hasWebPanelAccount: boolean;
    readonly client?:
      | { readonly __typename?: 'Client'; readonly id: string }
      | null
      | undefined;
  };
};

export type GetUserByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;

export type GetUserByEmailQuery = {
  readonly __typename?: 'Query';
  readonly userByEmail?:
    | {
        readonly __typename?: 'User';
        readonly id: string;
        readonly name?: string | null | undefined;
        readonly volcanoClientId?: string | null | undefined;
        readonly email?: string | null | undefined;
        readonly isAdmin: boolean;
        readonly isClient: boolean;
        readonly clientRole?: string | null | undefined;
        readonly disabled?: boolean | null | undefined;
        readonly hasWebPanelAccount: boolean;
        readonly client?:
          | { readonly __typename?: 'Client'; readonly id: string }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type OnUpdateMeSubscriptionVariables = Exact<{ [key: string]: never }>;

export type OnUpdateMeSubscription = {
  readonly __typename?: 'Subscription';
  readonly onUpdateMe: {
    readonly __typename?: 'User';
    readonly id: string;
    readonly name?: string | null | undefined;
    readonly volcanoClientId?: string | null | undefined;
    readonly email?: string | null | undefined;
    readonly isAdmin: boolean;
    readonly isClient: boolean;
    readonly clientRole?: string | null | undefined;
    readonly disabled?: boolean | null | undefined;
    readonly hasWebPanelAccount: boolean;
    readonly client?:
      | { readonly __typename?: 'Client'; readonly id: string }
      | null
      | undefined;
  };
};

export type DeleteVehicleBrandMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteVehicleBrandMutation = {
  readonly __typename?: 'Mutation';
  readonly deleteVehicleBrand: {
    readonly __typename?: 'DeleteResult';
    readonly deleted: boolean;
    readonly reason?: string | null | undefined;
  };
};

export type UpdateVehicleBrandMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
}>;

export type UpdateVehicleBrandMutation = {
  readonly __typename?: 'Mutation';
  readonly updateVehicleBrand: {
    readonly __typename?: 'VehicleBrandModels';
    readonly id: string;
    readonly brand: string;
  };
};

export type DeleteVehicleModelMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteVehicleModelMutation = {
  readonly __typename?: 'Mutation';
  readonly deleteVehicleModel: {
    readonly __typename?: 'DeleteResult';
    readonly deleted: boolean;
    readonly reason?: string | null | undefined;
  };
};

export type GetVehicleBrandModelsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetVehicleBrandModelsQuery = {
  readonly __typename?: 'Query';
  readonly vehicleBrandModels: ReadonlyArray<{
    readonly __typename?: 'VehicleBrandModels';
    readonly id: string;
    readonly brand: string;
    readonly models: ReadonlyArray<{
      readonly __typename?: 'VehicleModel';
      readonly id: string;
      readonly name: string;
    }>;
  }>;
};

export type GetVehicleBrandQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetVehicleBrandQuery = {
  readonly __typename?: 'Query';
  readonly vehicleBrand: {
    readonly __typename?: 'VehicleBrandModels';
    readonly id: string;
    readonly brand: string;
    readonly models: ReadonlyArray<{
      readonly __typename?: 'VehicleModel';
      readonly id: string;
      readonly name: string;
    }>;
  };
};

export type GetVehicleModelQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetVehicleModelQuery = {
  readonly __typename?: 'Query';
  readonly vehicleModel: {
    readonly __typename?: 'VehicleModel';
    readonly id: string;
    readonly name: string;
  };
};

export type UpdateVehicleModelMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
}>;

export type UpdateVehicleModelMutation = {
  readonly __typename?: 'Mutation';
  readonly updateVehicleModel: {
    readonly __typename?: 'VehicleModel';
    readonly id: string;
    readonly name: string;
  };
};

export type GetAllVehiclesLocationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAllVehiclesLocationQuery = {
  readonly __typename?: 'Query';
  readonly vehicles: ReadonlyArray<{
    readonly __typename?: 'Vehicle';
    readonly id: string;
    readonly brand?: string | null | undefined;
    readonly licensePlate?: string | null | undefined;
    readonly model?: string | null | undefined;
    readonly volcanoVehicleId?: string | null | undefined;
    readonly location?:
      | {
          readonly __typename?: 'Location';
          readonly latitude?: string | null | undefined;
          readonly longitude?: string | null | undefined;
        }
      | null
      | undefined;
  }>;
};

export type GetAllVehiclesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllVehiclesQuery = {
  readonly __typename?: 'Query';
  readonly vehicles: ReadonlyArray<{
    readonly __typename?: 'Vehicle';
    readonly id: string;
    readonly volcanoVehicleId?: string | null | undefined;
    readonly origin?: string | null | undefined;
    readonly type?: string | null | undefined;
    readonly typeID?: number | null | undefined;
    readonly typeDescription?: string | null | undefined;
    readonly status?: string | null | undefined;
    readonly licensePlate?: string | null | undefined;
    readonly brand?: string | null | undefined;
    readonly model?: string | null | undefined;
  }>;
};

export type VehicleTypesQueryVariables = Exact<{ [key: string]: never }>;

export type VehicleTypesQuery = {
  readonly __typename?: 'Query';
  readonly vehicleTypes: ReadonlyArray<{
    readonly __typename?: 'VehicleType';
    readonly id: string;
    readonly name: string;
    readonly category: string;
  }>;
};

export type CreateVehicleBrandMutationVariables = Exact<{
  name: Scalars['String'];
}>;

export type CreateVehicleBrandMutation = {
  readonly __typename?: 'Mutation';
  readonly createVehicleBrand: {
    readonly __typename?: 'VehicleBrandModels';
    readonly id: string;
    readonly brand: string;
  };
};

export type CreateVehicleModelMutationVariables = Exact<{
  name: Scalars['String'];
  id: Scalars['ID'];
}>;

export type CreateVehicleModelMutation = {
  readonly __typename?: 'Mutation';
  readonly createVehicleModel: {
    readonly __typename?: 'VehicleModel';
    readonly id: string;
    readonly name: string;
  };
};

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    UserOrDriver: ['User', 'Driver'],
  },
};
export default result;

export const ContactFragmentFragmentDoc = gql`
  fragment ContactFragment on Contact {
    id
    name
    phone
    email
  }
`;
export const DriverBasicInfoFragmentFragmentDoc = gql`
  fragment DriverBasicInfoFragment on Driver {
    id
    type
    status
    notificationsToken
    volcanoEmail
    volcanoDriverId
    hasLoginCredentials
    inPrisma
    inVolcano
    profilePicURI
    providerId
    communicationLocale
    received
    name
    phone
    email
    alternatePhone
    loginMethod
    loginEnabled
  }
`;
export const ItineraryBasicFragmentFragmentDoc = gql`
  fragment ItineraryBasicFragment on Itinerary {
    id
    departureCity
    departureType
    departureAddress
    departureLat
    departureLon
    provisionGoogleMapsPlaceID
    provisionType
    provisionCity
    provisionAddress
    provisionLat
    realized
    departureGoogleMapsPlaceID
    provisionLon
    arrivalGoogleMapsPlaceID
    arrivalType
    arrivalCity
    arrivalAddress
    arrivalLat
    arrivalLon
    numVehicles
    numPassengers
    flightNumber
    groupName
    itineraryDescription
    vehicleCategory {
      id
      name
      vehicleModel {
        id
        name
      }
      vehicleType {
        name
        id
        category
      }
      vehicleBrand {
        id
        brand
      }
      vehicleCapacity
      description
    }
    notes
    dinner
  }
`;
export const PassengerInfoFragmentDoc = gql`
  fragment PassengerInfo on Passenger {
    id
    phone
    email
    name
  }
`;
export const VehiclePriceConditionFragmentFragmentDoc = gql`
  fragment VehiclePriceConditionFragment on VehiclePriceCondition {
    id
    name
    description
    basePrice
    extraHourPrice
    numPassengers
    vehicleTypeId
    vehicleModelId
    vehicleBrandId
  }
`;
export const VehiclePriceVariableFragmentFragmentDoc = gql`
  fragment VehiclePriceVariableFragment on VehiclePriceVariable {
    id
    extraPricePerKm
    tollPricePerKm
    airportPrice
    parkingMontserrat
    paxNumber
    extraHourPrice
    vehicleTypeId
    vehicleModelId
    vehicleBrandId
  }
`;
export const BasicServiceFragmentFragmentDoc = gql`
  fragment BasicServiceFragment on Service {
    id
    budgetReadableId
    typeId
    volcanoServiceId
    status
    reference
    serieFact
    itineraryDescription
    numOfPassengers
    presentationTime
    notes
    description
    requestedVehicleDescription
  }
`;
export const FullServiceFragmentFragmentDoc = gql`
  fragment FullServiceFragment on Service {
    id
    budgetReadableId
    typeId
    volcanoServiceId
    status
    reference
    serieFact
    itineraryDescription
    numOfPassengers
    presentationTime
    notes
    description
    passengers {
      id
      name
      phone
      email
    }
    departure {
      date
      time
      address
      lat
      lon
    }
    arrival {
      date
      time
      address
      lat
      lon
    }
    client {
      name
      id
    }
    driver {
      id
      received
      name
      phone
      alternatePhone
      email
      type
      status
      inPrisma
      inVolcano
      profilePicURI
      location {
        latitude
        longitude
      }
    }
    alternateDriver {
      id
      received
      name
      phone
      alternatePhone
      email
      type
      status
      inPrisma
      inVolcano
      location {
        latitude
        longitude
      }
    }
    drivers {
      id
      received
      name
      phone
      alternatePhone
      email
      type
      status
      inPrisma
      inVolcano
      location {
        latitude
        longitude
      }
    }
    drivingCompany {
      id
      email
      volcanoId
      name
      phone
    }
    requestedVehicleDescription
    vehicle {
      id
      location {
        latitude
        longitude
      }
      origin
      type
      typeID
      typeDescription
      status
      licensePlate
      brand
      model
    }
  }
`;
export const UserBasicFragmentFragmentDoc = gql`
  fragment UserBasicFragment on User {
    id
    name
    volcanoClientId
    email
    isAdmin
    isClient
    clientRole
    disabled
    hasWebPanelAccount
    client {
      id
    }
  }
`;
export const DriverBasicFragmentFragmentDoc = gql`
  fragment DriverBasicFragment on Driver {
    id
    name
    phone
    email
    status
    alternatePhone
    communicationLocale
    firebaseId
    hasLoginCredentials
    loginEnabled
    notificationsToken
    loginMethod
    volcanoDriverId
    volcanoEmail
    inPrisma
    inVolcano
    profilePicURI
    drivingCompany {
      name
      email
      phone
      volcanoId
      id
    }
  }
`;
export const GetFrontendVersionDocument = gql`
  query GetFrontendVersion {
    getFrontendVersion {
      version
    }
  }
`;

/**
 * __useGetFrontendVersionQuery__
 *
 * To run a query within a React component, call `useGetFrontendVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFrontendVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrontendVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFrontendVersionQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetFrontendVersionQuery,
    GetFrontendVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetFrontendVersionQuery,
    GetFrontendVersionQueryVariables
  >(GetFrontendVersionDocument, options);
}
export function useGetFrontendVersionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetFrontendVersionQuery,
    GetFrontendVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetFrontendVersionQuery,
    GetFrontendVersionQueryVariables
  >(GetFrontendVersionDocument, options);
}
export type GetFrontendVersionQueryHookResult = ReturnType<
  typeof useGetFrontendVersionQuery
>;
export type GetFrontendVersionLazyQueryHookResult = ReturnType<
  typeof useGetFrontendVersionLazyQuery
>;
export type GetFrontendVersionQueryResult = ApolloReactCommon.QueryResult<
  GetFrontendVersionQuery,
  GetFrontendVersionQueryVariables
>;
export const IsEmailUsedForAuthDocument = gql`
  query isEmailUsedForAuth($email: String!) {
    isEmailUsedForAuthentication(email: $email)
  }
`;

/**
 * __useIsEmailUsedForAuthQuery__
 *
 * To run a query within a React component, call `useIsEmailUsedForAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsEmailUsedForAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsEmailUsedForAuthQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useIsEmailUsedForAuthQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    IsEmailUsedForAuthQuery,
    IsEmailUsedForAuthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    IsEmailUsedForAuthQuery,
    IsEmailUsedForAuthQueryVariables
  >(IsEmailUsedForAuthDocument, options);
}
export function useIsEmailUsedForAuthLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    IsEmailUsedForAuthQuery,
    IsEmailUsedForAuthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    IsEmailUsedForAuthQuery,
    IsEmailUsedForAuthQueryVariables
  >(IsEmailUsedForAuthDocument, options);
}
export type IsEmailUsedForAuthQueryHookResult = ReturnType<
  typeof useIsEmailUsedForAuthQuery
>;
export type IsEmailUsedForAuthLazyQueryHookResult = ReturnType<
  typeof useIsEmailUsedForAuthLazyQuery
>;
export type IsEmailUsedForAuthQueryResult = ApolloReactCommon.QueryResult<
  IsEmailUsedForAuthQuery,
  IsEmailUsedForAuthQueryVariables
>;
export const IsPhoneUsedForAuthenticationDocument = gql`
  query isPhoneUsedForAuthentication($phone: String!) {
    isPhoneUsedForAuthentication(phone: $phone)
  }
`;

/**
 * __useIsPhoneUsedForAuthenticationQuery__
 *
 * To run a query within a React component, call `useIsPhoneUsedForAuthenticationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsPhoneUsedForAuthenticationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsPhoneUsedForAuthenticationQuery({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useIsPhoneUsedForAuthenticationQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    IsPhoneUsedForAuthenticationQuery,
    IsPhoneUsedForAuthenticationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    IsPhoneUsedForAuthenticationQuery,
    IsPhoneUsedForAuthenticationQueryVariables
  >(IsPhoneUsedForAuthenticationDocument, options);
}
export function useIsPhoneUsedForAuthenticationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    IsPhoneUsedForAuthenticationQuery,
    IsPhoneUsedForAuthenticationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    IsPhoneUsedForAuthenticationQuery,
    IsPhoneUsedForAuthenticationQueryVariables
  >(IsPhoneUsedForAuthenticationDocument, options);
}
export type IsPhoneUsedForAuthenticationQueryHookResult = ReturnType<
  typeof useIsPhoneUsedForAuthenticationQuery
>;
export type IsPhoneUsedForAuthenticationLazyQueryHookResult = ReturnType<
  typeof useIsPhoneUsedForAuthenticationLazyQuery
>;
export type IsPhoneUsedForAuthenticationQueryResult =
  ApolloReactCommon.QueryResult<
    IsPhoneUsedForAuthenticationQuery,
    IsPhoneUsedForAuthenticationQueryVariables
  >;
export const DeleteABudgetDocument = gql`
  mutation DeleteABudget($id: ID!) {
    deleteBudget(id: $id) {
      deleted
    }
  }
`;
export type DeleteABudgetMutationFn = ApolloReactCommon.MutationFunction<
  DeleteABudgetMutation,
  DeleteABudgetMutationVariables
>;

/**
 * __useDeleteABudgetMutation__
 *
 * To run a mutation, you first call `useDeleteABudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteABudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteABudgetMutation, { data, loading, error }] = useDeleteABudgetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteABudgetMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteABudgetMutation,
    DeleteABudgetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DeleteABudgetMutation,
    DeleteABudgetMutationVariables
  >(DeleteABudgetDocument, options);
}
export type DeleteABudgetMutationHookResult = ReturnType<
  typeof useDeleteABudgetMutation
>;
export type DeleteABudgetMutationResult =
  ApolloReactCommon.MutationResult<DeleteABudgetMutation>;
export type DeleteABudgetMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteABudgetMutation,
    DeleteABudgetMutationVariables
  >;
export const CreateBudgetDocument = gql`
  mutation createBudget(
    $validityPeriodStart: String!
    $validityPeriodEnd: String!
    $creationDate: String!
    $client: String!
    $status: String!
    $company: String!
    $contactId: String
    $reference: String
    $metThrough: String
    $requestSource: String
    $templateHeading: String
    $templateBody: String
    $itineraries: [ItineraryInput!]
  ) {
    createBudget(
      validityPeriodStart: $validityPeriodStart
      validityPeriodEnd: $validityPeriodEnd
      creationDate: $creationDate
      client: $client
      status: $status
      company: $company
      contactId: $contactId
      reference: $reference
      metThrough: $metThrough
      requestSource: $requestSource
      templateHeading: $templateHeading
      templateBody: $templateBody
      itineraries: $itineraries
    ) {
      id
      readableId
      validityPeriodStart
      validityPeriodEnd
      creationDate
      attendedBy
      client {
        id
        nif
        name
        phone
        alternatePhone
        volcanoClientId
        volcanoEmail
        email
        communicationLocale
        firebaseId
        hasWebPanelAccount
        loginEnabled
        template {
          id
          name
          heading
          body
        }
      }
      status {
        code
      }
      company {
        code
      }
      reference
      contact {
        id
        name
        phone
        email
      }
      metThrough {
        code
      }
      requestSource {
        code
      }
      templateHeading
      templateBody
      itineraries {
        id
        realized
        departureTime
        arrivalTime
        presentationTime
        serviceTypeId
        dinner
        reference
        departureGoogleMapsPlaceID
        departureType
        departureCity
        departureAddress
        departureLat
        departureLon
        provisionGoogleMapsPlaceID
        provisionType
        provisionCity
        provisionAddress
        provisionLat
        provisionLon
        arrivalGoogleMapsPlaceID
        arrivalType
        arrivalCity
        arrivalAddress
        arrivalLat
        arrivalLon
        numVehicles
        numPassengers
        itineraryDescription
        groupName
        flightNumber
        notes
        vehicleCategory {
          id
          vehicleModel {
            id
          }
          vehicleBrand {
            id
          }
          vehicleType {
            id
          }
          vehicleCapacity
          name
          description
        }
      }
    }
  }
`;
export type CreateBudgetMutationFn = ApolloReactCommon.MutationFunction<
  CreateBudgetMutation,
  CreateBudgetMutationVariables
>;

/**
 * __useCreateBudgetMutation__
 *
 * To run a mutation, you first call `useCreateBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBudgetMutation, { data, loading, error }] = useCreateBudgetMutation({
 *   variables: {
 *      validityPeriodStart: // value for 'validityPeriodStart'
 *      validityPeriodEnd: // value for 'validityPeriodEnd'
 *      creationDate: // value for 'creationDate'
 *      client: // value for 'client'
 *      status: // value for 'status'
 *      company: // value for 'company'
 *      contactId: // value for 'contactId'
 *      reference: // value for 'reference'
 *      metThrough: // value for 'metThrough'
 *      requestSource: // value for 'requestSource'
 *      templateHeading: // value for 'templateHeading'
 *      templateBody: // value for 'templateBody'
 *      itineraries: // value for 'itineraries'
 *   },
 * });
 */
export function useCreateBudgetMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateBudgetMutation,
    CreateBudgetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreateBudgetMutation,
    CreateBudgetMutationVariables
  >(CreateBudgetDocument, options);
}
export type CreateBudgetMutationHookResult = ReturnType<
  typeof useCreateBudgetMutation
>;
export type CreateBudgetMutationResult =
  ApolloReactCommon.MutationResult<CreateBudgetMutation>;
export type CreateBudgetMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateBudgetMutation,
  CreateBudgetMutationVariables
>;
export const ComputeItineraryPriceDocument = gql`
  query computeItineraryPrice(
    $departure: DepartureOrArrivalInput
    $arrival: DepartureOrArrivalInput
    $provision: DepartureOrArrivalInput
    $serviceTypeId: String!
    $clientId: String!
    $vehicleTypeId: String!
    $vehicleModelId: String
    $vehicleBrandId: String
    $hours: Int
    $dinner: Boolean
    $capacity: Int
  ) {
    computeItineraryPrice(
      departure: $departure
      arrival: $arrival
      provision: $provision
      serviceTypeId: $serviceTypeId
      clientId: $clientId
      vehicleTypeId: $vehicleTypeId
      vehicleModelId: $vehicleModelId
      vehicleBrandId: $vehicleBrandId
      hours: $hours
      dinner: $dinner
      capacity: $capacity
    ) {
      consult
      amount
      concept
    }
  }
`;

/**
 * __useComputeItineraryPriceQuery__
 *
 * To run a query within a React component, call `useComputeItineraryPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useComputeItineraryPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComputeItineraryPriceQuery({
 *   variables: {
 *      departure: // value for 'departure'
 *      arrival: // value for 'arrival'
 *      provision: // value for 'provision'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      clientId: // value for 'clientId'
 *      vehicleTypeId: // value for 'vehicleTypeId'
 *      vehicleModelId: // value for 'vehicleModelId'
 *      vehicleBrandId: // value for 'vehicleBrandId'
 *      hours: // value for 'hours'
 *      dinner: // value for 'dinner'
 *      capacity: // value for 'capacity'
 *   },
 * });
 */
export function useComputeItineraryPriceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ComputeItineraryPriceQuery,
    ComputeItineraryPriceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    ComputeItineraryPriceQuery,
    ComputeItineraryPriceQueryVariables
  >(ComputeItineraryPriceDocument, options);
}
export function useComputeItineraryPriceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ComputeItineraryPriceQuery,
    ComputeItineraryPriceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    ComputeItineraryPriceQuery,
    ComputeItineraryPriceQueryVariables
  >(ComputeItineraryPriceDocument, options);
}
export type ComputeItineraryPriceQueryHookResult = ReturnType<
  typeof useComputeItineraryPriceQuery
>;
export type ComputeItineraryPriceLazyQueryHookResult = ReturnType<
  typeof useComputeItineraryPriceLazyQuery
>;
export type ComputeItineraryPriceQueryResult = ApolloReactCommon.QueryResult<
  ComputeItineraryPriceQuery,
  ComputeItineraryPriceQueryVariables
>;
export const OnNewBudgetSubscriptionCustomDocument = gql`
  subscription OnNewBudgetSubscriptionCustom {
    newBudget {
      id
      attendedBy
      readableId
      validityPeriodStart
      validityPeriodEnd
      creationDate
      reference
      templateHeading
      templateBody
      client {
        id
        name
        volcanoClientId
        nif
        phone
        alternatePhone
        email
        volcanoEmail
        template {
          id
          name
          heading
          body
        }
      }
      status {
        code
        locale {
          code
          value
        }
      }
      company {
        code
        data {
          zip
          address
          cif
          country {
            enEN
            enUS
            esES
          }
          email
          fax
          location
          name
          phone
          region
          web
        }
      }
      contact {
        id
        name
        phone
        email
      }
      metThrough {
        code
      }
      requestSource {
        code
      }
      itineraries {
        id
        realized
        amounts {
          id
          amount
          vat
          concept
        }
        driverFeatures {
          id
          description
          required
        }
        vehicleFeatures {
          id
          description
          required
        }
        provisionGoogleMapsPlaceID
        provisionAddress
        provisionCity
        provisionType
        provisionLat
        provisionLon
        departureGoogleMapsPlaceID
        departureAddress
        departureCity
        departureType
        departureTime
        departureLat
        departureLon
        arrivalGoogleMapsPlaceID
        arrivalLat
        arrivalLon
        arrivalAddress
        arrivalCity
        arrivalType
        arrivalTime
        presentationTime
        serviceTypeId
        reference
        departureAddress
        arrivalAddress
        numVehicles
        numPassengers
        itineraryDescription
        groupName
        flightNumber
        notes
        vehicleCategory {
          id
          vehicleModel {
            id
          }
          vehicleBrand {
            id
          }
          vehicleType {
            id
          }
          vehicleCapacity
          name
          description
        }
      }
    }
  }
`;

/**
 * __useOnNewBudgetSubscriptionCustomSubscription__
 *
 * To run a query within a React component, call `useOnNewBudgetSubscriptionCustomSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNewBudgetSubscriptionCustomSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNewBudgetSubscriptionCustomSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnNewBudgetSubscriptionCustomSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    OnNewBudgetSubscriptionCustomSubscription,
    OnNewBudgetSubscriptionCustomSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSubscription<
    OnNewBudgetSubscriptionCustomSubscription,
    OnNewBudgetSubscriptionCustomSubscriptionVariables
  >(OnNewBudgetSubscriptionCustomDocument, options);
}
export type OnNewBudgetSubscriptionCustomSubscriptionHookResult = ReturnType<
  typeof useOnNewBudgetSubscriptionCustomSubscription
>;
export type OnNewBudgetSubscriptionCustomSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<OnNewBudgetSubscriptionCustomSubscription>;
export const OnUpdateBudgetSubscriptionCustomDocument = gql`
  subscription OnUpdateBudgetSubscriptionCustom {
    onUpdateBudget {
      id
      attendedBy
      readableId
      validityPeriodStart
      validityPeriodEnd
      creationDate
      reference
      templateHeading
      templateBody
      client {
        id
        name
        volcanoClientId
        nif
        phone
        alternatePhone
        email
        volcanoEmail
        template {
          id
          name
          heading
          body
        }
      }
      status {
        code
        locale {
          code
          value
        }
      }
      company {
        code
        data {
          zip
          address
          cif
          country {
            enEN
            enUS
            esES
          }
          email
          fax
          location
          name
          phone
          region
          web
        }
      }
      contact {
        id
        name
        phone
        email
      }
      metThrough {
        code
      }
      requestSource {
        code
      }
      itineraries {
        id
        realized
        amounts {
          id
          amount
          vat
          concept
        }
        driverFeatures {
          id
          description
          required
        }
        vehicleFeatures {
          id
          description
          required
        }
        provisionGoogleMapsPlaceID
        provisionType
        provisionCity
        provisionAddress
        provisionLat
        provisionLon
        departureGoogleMapsPlaceID
        arrivalGoogleMapsPlaceID
        departureLat
        departureLon
        arrivalLat
        arrivalLon
        departureAddress
        departureCity
        departureType
        departureTime
        arrivalAddress
        arrivalCity
        arrivalType
        arrivalTime
        presentationTime
        serviceTypeId
        reference
        departureAddress
        arrivalAddress
        numVehicles
        numPassengers
        itineraryDescription
        groupName
        flightNumber
        notes
        vehicleCategory {
          id
          vehicleModel {
            id
          }
          vehicleBrand {
            id
          }
          vehicleType {
            id
          }
          vehicleCapacity
          name
          description
        }
      }
    }
  }
`;

/**
 * __useOnUpdateBudgetSubscriptionCustomSubscription__
 *
 * To run a query within a React component, call `useOnUpdateBudgetSubscriptionCustomSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateBudgetSubscriptionCustomSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateBudgetSubscriptionCustomSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnUpdateBudgetSubscriptionCustomSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    OnUpdateBudgetSubscriptionCustomSubscription,
    OnUpdateBudgetSubscriptionCustomSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSubscription<
    OnUpdateBudgetSubscriptionCustomSubscription,
    OnUpdateBudgetSubscriptionCustomSubscriptionVariables
  >(OnUpdateBudgetSubscriptionCustomDocument, options);
}
export type OnUpdateBudgetSubscriptionCustomSubscriptionHookResult = ReturnType<
  typeof useOnUpdateBudgetSubscriptionCustomSubscription
>;
export type OnUpdateBudgetSubscriptionCustomSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<OnUpdateBudgetSubscriptionCustomSubscription>;
export const UpdateBudgetCustomDocument = gql`
  mutation UpdateBudgetCustom(
    $id: ID!
    $creationDate: String!
    $validityPeriodStart: String!
    $validityPeriodEnd: String!
    $client: String!
    $status: String!
    $company: String!
    $contactId: String
    $reference: String
    $metThrough: String
    $requestSource: String
    $templateHeading: String
    $templateBody: String
    $itineraries: [ItineraryInput!]
  ) {
    updateBudget(
      id: $id
      creationDate: $creationDate
      validityPeriodStart: $validityPeriodStart
      validityPeriodEnd: $validityPeriodEnd
      client: $client
      status: $status
      company: $company
      contactId: $contactId
      reference: $reference
      metThrough: $metThrough
      requestSource: $requestSource
      templateHeading: $templateHeading
      templateBody: $templateBody
      itineraries: $itineraries
    ) {
      id
      attendedBy
      readableId
      validityPeriodStart
      validityPeriodEnd
      creationDate
      reference
      templateHeading
      templateBody
      client {
        id
        name
        volcanoClientId
        nif
        phone
        alternatePhone
        email
        volcanoEmail
        template {
          id
          name
          heading
          body
        }
      }
      status {
        code
        locale {
          code
          value
        }
      }
      company {
        code
        data {
          zip
          address
          cif
          country {
            enEN
            enUS
            esES
          }
          email
          fax
          location
          name
          phone
          region
          web
        }
      }
      contact {
        id
        name
        phone
        email
      }
      metThrough {
        code
      }
      requestSource {
        code
      }
      itineraries {
        id
        realized
        dinner
        amounts {
          id
          amount
          vat
          concept
        }
        driverFeatures {
          id
          description
          required
        }
        vehicleFeatures {
          id
          description
          required
        }
        provisionGoogleMapsPlaceID
        provisionType
        provisionCity
        provisionAddress
        provisionLat
        provisionLon
        departureGoogleMapsPlaceID
        arrivalGoogleMapsPlaceID
        departureLat
        departureLon
        arrivalLat
        arrivalLon
        departureAddress
        departureCity
        departureType
        departureTime
        arrivalAddress
        arrivalCity
        arrivalType
        arrivalTime
        presentationTime
        serviceTypeId
        reference
        departureAddress
        arrivalAddress
        numVehicles
        numPassengers
        itineraryDescription
        groupName
        flightNumber
        notes
        vehicleCategory {
          id
          vehicleModel {
            id
          }
          vehicleBrand {
            id
          }
          vehicleType {
            id
          }
          vehicleCapacity
          name
          description
        }
      }
    }
  }
`;
export type UpdateBudgetCustomMutationFn = ApolloReactCommon.MutationFunction<
  UpdateBudgetCustomMutation,
  UpdateBudgetCustomMutationVariables
>;

/**
 * __useUpdateBudgetCustomMutation__
 *
 * To run a mutation, you first call `useUpdateBudgetCustomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBudgetCustomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBudgetCustomMutation, { data, loading, error }] = useUpdateBudgetCustomMutation({
 *   variables: {
 *      id: // value for 'id'
 *      creationDate: // value for 'creationDate'
 *      validityPeriodStart: // value for 'validityPeriodStart'
 *      validityPeriodEnd: // value for 'validityPeriodEnd'
 *      client: // value for 'client'
 *      status: // value for 'status'
 *      company: // value for 'company'
 *      contactId: // value for 'contactId'
 *      reference: // value for 'reference'
 *      metThrough: // value for 'metThrough'
 *      requestSource: // value for 'requestSource'
 *      templateHeading: // value for 'templateHeading'
 *      templateBody: // value for 'templateBody'
 *      itineraries: // value for 'itineraries'
 *   },
 * });
 */
export function useUpdateBudgetCustomMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateBudgetCustomMutation,
    UpdateBudgetCustomMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateBudgetCustomMutation,
    UpdateBudgetCustomMutationVariables
  >(UpdateBudgetCustomDocument, options);
}
export type UpdateBudgetCustomMutationHookResult = ReturnType<
  typeof useUpdateBudgetCustomMutation
>;
export type UpdateBudgetCustomMutationResult =
  ApolloReactCommon.MutationResult<UpdateBudgetCustomMutation>;
export type UpdateBudgetCustomMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateBudgetCustomMutation,
    UpdateBudgetCustomMutationVariables
  >;
export const GetBudgetDocument = gql`
  query GetBudget($id: ID!) {
    budget(id: $id) {
      id
      attendedBy
      readableId
      validityPeriodStart
      validityPeriodEnd
      creationDate
      reference
      templateHeading
      templateBody
      client {
        id
        name
        volcanoClientId
        nif
        phone
        alternatePhone
        email
        volcanoEmail
        template {
          id
          name
          heading
          body
        }
      }
      status {
        code
        locale {
          code
          value
        }
      }
      company {
        code
        data {
          zip
          address
          cif
          country {
            enEN
            enUS
            esES
          }
          email
          fax
          location
          name
          phone
          region
          web
        }
      }
      contact {
        id
        name
        phone
        email
      }
      metThrough {
        code
      }
      requestSource {
        code
      }
      itineraries {
        id
        realized
        dinner
        departureGoogleMapsPlaceID
        arrivalGoogleMapsPlaceID
        amounts {
          id
          amount
          vat
          concept
        }
        driverFeatures {
          id
          description
          required
        }
        vehicleFeatures {
          id
          description
          required
        }
        provisionGoogleMapsPlaceID
        provisionType
        provisionCity
        provisionAddress
        provisionLat
        provisionLon
        departureLat
        departureLon
        arrivalLat
        arrivalLon
        departureAddress
        departureCity
        departureType
        departureTime
        arrivalAddress
        arrivalCity
        arrivalType
        arrivalTime
        presentationTime
        serviceTypeId
        reference
        departureAddress
        arrivalAddress
        numVehicles
        numPassengers
        itineraryDescription
        groupName
        flightNumber
        notes
        vehicleCategory {
          id
          vehicleModel {
            id
          }
          vehicleBrand {
            id
          }
          vehicleType {
            id
          }
          vehicleCapacity
          name
          description
        }
      }
    }
  }
`;

/**
 * __useGetBudgetQuery__
 *
 * To run a query within a React component, call `useGetBudgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBudgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBudgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBudgetQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetBudgetQuery,
    GetBudgetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetBudgetQuery, GetBudgetQueryVariables>(
    GetBudgetDocument,
    options,
  );
}
export function useGetBudgetLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetBudgetQuery,
    GetBudgetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetBudgetQuery, GetBudgetQueryVariables>(
    GetBudgetDocument,
    options,
  );
}
export type GetBudgetQueryHookResult = ReturnType<typeof useGetBudgetQuery>;
export type GetBudgetLazyQueryHookResult = ReturnType<
  typeof useGetBudgetLazyQuery
>;
export type GetBudgetQueryResult = ApolloReactCommon.QueryResult<
  GetBudgetQuery,
  GetBudgetQueryVariables
>;
export const GetBudgetsDocument = gql`
  query GetBudgets {
    budgets {
      id
      attendedBy
      readableId
      validityPeriodStart
      validityPeriodEnd
      creationDate
      reference
      templateHeading
      templateBody
      client {
        id
        name
        template {
          id
          name
          heading
          body
        }
      }
      status {
        code
        locale {
          code
          value
        }
      }
      company {
        code
        data {
          zip
          address
          cif
          country {
            enEN
            enUS
            esES
          }
          email
          fax
          location
          name
          phone
          region
          web
        }
      }
      contact {
        id
        name
        phone
        email
      }
      metThrough {
        code
      }
      requestSource {
        code
      }
      itineraries {
        id
        realized
        dinner
        amounts {
          id
          amount
          vat
          concept
        }
        driverFeatures {
          id
          description
          required
        }
        vehicleFeatures {
          id
          description
          required
        }
        provisionGoogleMapsPlaceID
        provisionType
        provisionCity
        provisionAddress
        provisionLat
        provisionLon
        departureGoogleMapsPlaceID
        arrivalGoogleMapsPlaceID
        departureLat
        departureLon
        arrivalLat
        arrivalLon
        departureAddress
        departureCity
        departureType
        departureTime
        arrivalAddress
        arrivalCity
        arrivalType
        arrivalTime
        presentationTime
        serviceTypeId
        reference
        departureAddress
        arrivalAddress
        numVehicles
        numPassengers
        itineraryDescription
        groupName
        flightNumber
        notes
        vehicleCategory {
          id
          vehicleModel {
            id
          }
          vehicleBrand {
            id
          }
          vehicleType {
            id
          }
          vehicleCapacity
          name
          description
        }
      }
    }
  }
`;

/**
 * __useGetBudgetsQuery__
 *
 * To run a query within a React component, call `useGetBudgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBudgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBudgetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBudgetsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetBudgetsQuery,
    GetBudgetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetBudgetsQuery, GetBudgetsQueryVariables>(
    GetBudgetsDocument,
    options,
  );
}
export function useGetBudgetsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetBudgetsQuery,
    GetBudgetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetBudgetsQuery,
    GetBudgetsQueryVariables
  >(GetBudgetsDocument, options);
}
export type GetBudgetsQueryHookResult = ReturnType<typeof useGetBudgetsQuery>;
export type GetBudgetsLazyQueryHookResult = ReturnType<
  typeof useGetBudgetsLazyQuery
>;
export type GetBudgetsQueryResult = ApolloReactCommon.QueryResult<
  GetBudgetsQuery,
  GetBudgetsQueryVariables
>;
export const GetBudgetConfigDocument = gql`
  query GetBudgetConfig {
    budgetConfig {
      vatTypes {
        code
        translation
        value
      }
      companies {
        code
        data {
          zip
          address
          cif
          country {
            enEN
            enUS
            esES
          }
          email
          fax
          location
          name
          phone
          region
          web
        }
      }
      templates {
        code
        translation
        template {
          heading
          body
        }
      }
      status {
        code
        locale {
          code
          value
        }
      }
      metThrough {
        code
        locale {
          code
          value
        }
      }
      requestSource {
        code
        locale {
          code
          value
        }
      }
    }
  }
`;

/**
 * __useGetBudgetConfigQuery__
 *
 * To run a query within a React component, call `useGetBudgetConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBudgetConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBudgetConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBudgetConfigQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetBudgetConfigQuery,
    GetBudgetConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetBudgetConfigQuery,
    GetBudgetConfigQueryVariables
  >(GetBudgetConfigDocument, options);
}
export function useGetBudgetConfigLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetBudgetConfigQuery,
    GetBudgetConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetBudgetConfigQuery,
    GetBudgetConfigQueryVariables
  >(GetBudgetConfigDocument, options);
}
export type GetBudgetConfigQueryHookResult = ReturnType<
  typeof useGetBudgetConfigQuery
>;
export type GetBudgetConfigLazyQueryHookResult = ReturnType<
  typeof useGetBudgetConfigLazyQuery
>;
export type GetBudgetConfigQueryResult = ApolloReactCommon.QueryResult<
  GetBudgetConfigQuery,
  GetBudgetConfigQueryVariables
>;
export const DeleteClientDocument = gql`
  mutation DeleteClient($id: ID!) {
    deleteClient(id: $id) {
      deleted
      reason
    }
  }
`;
export type DeleteClientMutationFn = ApolloReactCommon.MutationFunction<
  DeleteClientMutation,
  DeleteClientMutationVariables
>;

/**
 * __useDeleteClientMutation__
 *
 * To run a mutation, you first call `useDeleteClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientMutation, { data, loading, error }] = useDeleteClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteClientMutation,
    DeleteClientMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DeleteClientMutation,
    DeleteClientMutationVariables
  >(DeleteClientDocument, options);
}
export type DeleteClientMutationHookResult = ReturnType<
  typeof useDeleteClientMutation
>;
export type DeleteClientMutationResult =
  ApolloReactCommon.MutationResult<DeleteClientMutation>;
export type DeleteClientMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteClientMutation,
  DeleteClientMutationVariables
>;
export const UpdateClientDocument = gql`
  mutation UpdateClient(
    $id: String
    $volcanoClientId: String
    $email: String
    $password: String
    $loginEnabled: Boolean
  ) {
    updateClient(
      id: $id
      volcanoClientId: $volcanoClientId
      email: $email
      password: $password
      loginEnabled: $loginEnabled
    ) {
      id
      nif
      name
      phone
      alternatePhone
      volcanoClientId
      volcanoEmail
      email
      communicationLocale
      firebaseId
      hasWebPanelAccount
    }
  }
`;
export type UpdateClientMutationFn = ApolloReactCommon.MutationFunction<
  UpdateClientMutation,
  UpdateClientMutationVariables
>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      volcanoClientId: // value for 'volcanoClientId'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      loginEnabled: // value for 'loginEnabled'
 *   },
 * });
 */
export function useUpdateClientMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateClientMutation,
    UpdateClientMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateClientMutation,
    UpdateClientMutationVariables
  >(UpdateClientDocument, options);
}
export type UpdateClientMutationHookResult = ReturnType<
  typeof useUpdateClientMutation
>;
export type UpdateClientMutationResult =
  ApolloReactCommon.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateClientMutation,
  UpdateClientMutationVariables
>;
export const GetAllClientsDocument = gql`
  query GetAllClients {
    clients {
      id
      nif
      name
      phone
      alternatePhone
      volcanoClientId
      volcanoEmail
      email
      communicationLocale
      firebaseId
      hasWebPanelAccount
      rate {
        id
        name
      }
    }
  }
`;

/**
 * __useGetAllClientsQuery__
 *
 * To run a query within a React component, call `useGetAllClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllClientsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAllClientsQuery,
    GetAllClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetAllClientsQuery,
    GetAllClientsQueryVariables
  >(GetAllClientsDocument, options);
}
export function useGetAllClientsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllClientsQuery,
    GetAllClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetAllClientsQuery,
    GetAllClientsQueryVariables
  >(GetAllClientsDocument, options);
}
export type GetAllClientsQueryHookResult = ReturnType<
  typeof useGetAllClientsQuery
>;
export type GetAllClientsLazyQueryHookResult = ReturnType<
  typeof useGetAllClientsLazyQuery
>;
export type GetAllClientsQueryResult = ApolloReactCommon.QueryResult<
  GetAllClientsQuery,
  GetAllClientsQueryVariables
>;
export const GetClientBasicInfoDocument = gql`
  query GetClientBasicInfo($id: ID!) {
    client(id: $id) {
      id
      nif
      name
      phone
      alternatePhone
      volcanoClientId
      volcanoEmail
      email
      communicationLocale
      hasWebPanelAccount
      loginEnabled
    }
  }
`;

/**
 * __useGetClientBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetClientBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientBasicInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientBasicInfoQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetClientBasicInfoQuery,
    GetClientBasicInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetClientBasicInfoQuery,
    GetClientBasicInfoQueryVariables
  >(GetClientBasicInfoDocument, options);
}
export function useGetClientBasicInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetClientBasicInfoQuery,
    GetClientBasicInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetClientBasicInfoQuery,
    GetClientBasicInfoQueryVariables
  >(GetClientBasicInfoDocument, options);
}
export type GetClientBasicInfoQueryHookResult = ReturnType<
  typeof useGetClientBasicInfoQuery
>;
export type GetClientBasicInfoLazyQueryHookResult = ReturnType<
  typeof useGetClientBasicInfoLazyQuery
>;
export type GetClientBasicInfoQueryResult = ApolloReactCommon.QueryResult<
  GetClientBasicInfoQuery,
  GetClientBasicInfoQueryVariables
>;
export const GetClientTemplateDocument = gql`
  query GetClientTemplate($id: ID!) {
    client(id: $id) {
      id
      template {
        id
        name
        body
        heading
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __useGetClientTemplateQuery__
 *
 * To run a query within a React component, call `useGetClientTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientTemplateQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetClientTemplateQuery,
    GetClientTemplateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetClientTemplateQuery,
    GetClientTemplateQueryVariables
  >(GetClientTemplateDocument, options);
}
export function useGetClientTemplateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetClientTemplateQuery,
    GetClientTemplateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetClientTemplateQuery,
    GetClientTemplateQueryVariables
  >(GetClientTemplateDocument, options);
}
export type GetClientTemplateQueryHookResult = ReturnType<
  typeof useGetClientTemplateQuery
>;
export type GetClientTemplateLazyQueryHookResult = ReturnType<
  typeof useGetClientTemplateLazyQuery
>;
export type GetClientTemplateQueryResult = ApolloReactCommon.QueryResult<
  GetClientTemplateQuery,
  GetClientTemplateQueryVariables
>;
export const OnNewClientDocument = gql`
  subscription OnNewClient {
    onNewClient {
      id
      nif
      name
      phone
      alternatePhone
      volcanoClientId
      volcanoEmail
      email
      communicationLocale
    }
  }
`;

/**
 * __useOnNewClientSubscription__
 *
 * To run a query within a React component, call `useOnNewClientSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNewClientSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNewClientSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnNewClientSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    OnNewClientSubscription,
    OnNewClientSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSubscription<
    OnNewClientSubscription,
    OnNewClientSubscriptionVariables
  >(OnNewClientDocument, options);
}
export type OnNewClientSubscriptionHookResult = ReturnType<
  typeof useOnNewClientSubscription
>;
export type OnNewClientSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<OnNewClientSubscription>;
export const OnUpdateClientDocument = gql`
  subscription OnUpdateClient {
    onUpdateClient {
      id
      nif
      name
      phone
      alternatePhone
      volcanoClientId
      volcanoEmail
      email
      communicationLocale
    }
  }
`;

/**
 * __useOnUpdateClientSubscription__
 *
 * To run a query within a React component, call `useOnUpdateClientSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateClientSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateClientSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnUpdateClientSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    OnUpdateClientSubscription,
    OnUpdateClientSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSubscription<
    OnUpdateClientSubscription,
    OnUpdateClientSubscriptionVariables
  >(OnUpdateClientDocument, options);
}
export type OnUpdateClientSubscriptionHookResult = ReturnType<
  typeof useOnUpdateClientSubscription
>;
export type OnUpdateClientSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<OnUpdateClientSubscription>;
export const CreateClientEmployeeDocument = gql`
  mutation CreateClientEmployee(
    $email: String!
    $password: String!
    $name: String!
    $phone: String
  ) {
    createClientEmployee(
      email: $email
      password: $password
      name: $name
      phone: $phone
    ) {
      id
      createdAt
      email
      name
      phone
      loginEnabled
      hasWebPanelAccount
    }
  }
`;
export type CreateClientEmployeeMutationFn = ApolloReactCommon.MutationFunction<
  CreateClientEmployeeMutation,
  CreateClientEmployeeMutationVariables
>;

/**
 * __useCreateClientEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateClientEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientEmployeeMutation, { data, loading, error }] = useCreateClientEmployeeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      name: // value for 'name'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useCreateClientEmployeeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateClientEmployeeMutation,
    CreateClientEmployeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreateClientEmployeeMutation,
    CreateClientEmployeeMutationVariables
  >(CreateClientEmployeeDocument, options);
}
export type CreateClientEmployeeMutationHookResult = ReturnType<
  typeof useCreateClientEmployeeMutation
>;
export type CreateClientEmployeeMutationResult =
  ApolloReactCommon.MutationResult<CreateClientEmployeeMutation>;
export type CreateClientEmployeeMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateClientEmployeeMutation,
    CreateClientEmployeeMutationVariables
  >;
export const UpdateClientEmployeeDocument = gql`
  mutation UpdateClientEmployee($id: ID!, $data: UpdateClientEmployeeInput!) {
    updateClientEmployee(id: $id, data: $data) {
      id
      createdAt
      email
      name
      phone
      loginEnabled
      hasWebPanelAccount
    }
  }
`;
export type UpdateClientEmployeeMutationFn = ApolloReactCommon.MutationFunction<
  UpdateClientEmployeeMutation,
  UpdateClientEmployeeMutationVariables
>;

/**
 * __useUpdateClientEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateClientEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientEmployeeMutation, { data, loading, error }] = useUpdateClientEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClientEmployeeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateClientEmployeeMutation,
    UpdateClientEmployeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateClientEmployeeMutation,
    UpdateClientEmployeeMutationVariables
  >(UpdateClientEmployeeDocument, options);
}
export type UpdateClientEmployeeMutationHookResult = ReturnType<
  typeof useUpdateClientEmployeeMutation
>;
export type UpdateClientEmployeeMutationResult =
  ApolloReactCommon.MutationResult<UpdateClientEmployeeMutation>;
export type UpdateClientEmployeeMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateClientEmployeeMutation,
    UpdateClientEmployeeMutationVariables
  >;
export const DeleteClientEmployeeDocument = gql`
  mutation DeleteClientEmployee($id: ID!) {
    deleteClientEmployee(id: $id) {
      deleted
      reason
    }
  }
`;
export type DeleteClientEmployeeMutationFn = ApolloReactCommon.MutationFunction<
  DeleteClientEmployeeMutation,
  DeleteClientEmployeeMutationVariables
>;

/**
 * __useDeleteClientEmployeeMutation__
 *
 * To run a mutation, you first call `useDeleteClientEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientEmployeeMutation, { data, loading, error }] = useDeleteClientEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientEmployeeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteClientEmployeeMutation,
    DeleteClientEmployeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DeleteClientEmployeeMutation,
    DeleteClientEmployeeMutationVariables
  >(DeleteClientEmployeeDocument, options);
}
export type DeleteClientEmployeeMutationHookResult = ReturnType<
  typeof useDeleteClientEmployeeMutation
>;
export type DeleteClientEmployeeMutationResult =
  ApolloReactCommon.MutationResult<DeleteClientEmployeeMutation>;
export type DeleteClientEmployeeMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteClientEmployeeMutation,
    DeleteClientEmployeeMutationVariables
  >;
export const ClientEmployeesDocument = gql`
  query ClientEmployees {
    clientEmployees {
      id
      createdAt
      email
      name
      phone
      loginEnabled
      hasWebPanelAccount
    }
  }
`;

/**
 * __useClientEmployeesQuery__
 *
 * To run a query within a React component, call `useClientEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientEmployeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientEmployeesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ClientEmployeesQuery,
    ClientEmployeesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    ClientEmployeesQuery,
    ClientEmployeesQueryVariables
  >(ClientEmployeesDocument, options);
}
export function useClientEmployeesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ClientEmployeesQuery,
    ClientEmployeesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    ClientEmployeesQuery,
    ClientEmployeesQueryVariables
  >(ClientEmployeesDocument, options);
}
export type ClientEmployeesQueryHookResult = ReturnType<
  typeof useClientEmployeesQuery
>;
export type ClientEmployeesLazyQueryHookResult = ReturnType<
  typeof useClientEmployeesLazyQuery
>;
export type ClientEmployeesQueryResult = ApolloReactCommon.QueryResult<
  ClientEmployeesQuery,
  ClientEmployeesQueryVariables
>;
export const ClientEmployeeDocument = gql`
  query ClientEmployee($id: ID!) {
    clientEmployee(id: $id) {
      id
      createdAt
      email
      name
      phone
      loginEnabled
      hasWebPanelAccount
    }
  }
`;

/**
 * __useClientEmployeeQuery__
 *
 * To run a query within a React component, call `useClientEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientEmployeeQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ClientEmployeeQuery,
    ClientEmployeeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    ClientEmployeeQuery,
    ClientEmployeeQueryVariables
  >(ClientEmployeeDocument, options);
}
export function useClientEmployeeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ClientEmployeeQuery,
    ClientEmployeeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    ClientEmployeeQuery,
    ClientEmployeeQueryVariables
  >(ClientEmployeeDocument, options);
}
export type ClientEmployeeQueryHookResult = ReturnType<
  typeof useClientEmployeeQuery
>;
export type ClientEmployeeLazyQueryHookResult = ReturnType<
  typeof useClientEmployeeLazyQuery
>;
export type ClientEmployeeQueryResult = ApolloReactCommon.QueryResult<
  ClientEmployeeQuery,
  ClientEmployeeQueryVariables
>;
export const CreateContactDocument = gql`
  mutation CreateContact($name: String!, $email: String!, $phone: String) {
    createContact(name: $name, email: $email, phone: $phone) {
      id
      name
      phone
      email
    }
  }
`;
export type CreateContactMutationFn = ApolloReactCommon.MutationFunction<
  CreateContactMutation,
  CreateContactMutationVariables
>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useCreateContactMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateContactMutation,
    CreateContactMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreateContactMutation,
    CreateContactMutationVariables
  >(CreateContactDocument, options);
}
export type CreateContactMutationHookResult = ReturnType<
  typeof useCreateContactMutation
>;
export type CreateContactMutationResult =
  ApolloReactCommon.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateContactMutation,
    CreateContactMutationVariables
  >;
export const ContactsDocument = gql`
  query Contacts {
    contacts {
      ...ContactFragment
    }
  }
  ${ContactFragmentFragmentDoc}
`;

/**
 * __useContactsQuery__
 *
 * To run a query within a React component, call `useContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ContactsQuery,
    ContactsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<ContactsQuery, ContactsQueryVariables>(
    ContactsDocument,
    options,
  );
}
export function useContactsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ContactsQuery,
    ContactsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<ContactsQuery, ContactsQueryVariables>(
    ContactsDocument,
    options,
  );
}
export type ContactsQueryHookResult = ReturnType<typeof useContactsQuery>;
export type ContactsLazyQueryHookResult = ReturnType<
  typeof useContactsLazyQuery
>;
export type ContactsQueryResult = ApolloReactCommon.QueryResult<
  ContactsQuery,
  ContactsQueryVariables
>;
export const GetDriverDocument = gql`
  query GetDriver($id: ID) {
    driver(id: $id) {
      ...DriverBasicInfoFragment
    }
  }
  ${DriverBasicInfoFragmentFragmentDoc}
`;

/**
 * __useGetDriverQuery__
 *
 * To run a query within a React component, call `useGetDriverQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDriverQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetDriverQuery,
    GetDriverQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetDriverQuery, GetDriverQueryVariables>(
    GetDriverDocument,
    options,
  );
}
export function useGetDriverLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetDriverQuery,
    GetDriverQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetDriverQuery, GetDriverQueryVariables>(
    GetDriverDocument,
    options,
  );
}
export type GetDriverQueryHookResult = ReturnType<typeof useGetDriverQuery>;
export type GetDriverLazyQueryHookResult = ReturnType<
  typeof useGetDriverLazyQuery
>;
export type GetDriverQueryResult = ApolloReactCommon.QueryResult<
  GetDriverQuery,
  GetDriverQueryVariables
>;
export const GetDriverDrivingCompanyDocument = gql`
  query GetDriverDrivingCompany {
    driver {
      ...DriverBasicInfoFragment
      drivingCompany {
        volcanoId
        phone
        email
        name
        id
      }
    }
  }
  ${DriverBasicInfoFragmentFragmentDoc}
`;

/**
 * __useGetDriverDrivingCompanyQuery__
 *
 * To run a query within a React component, call `useGetDriverDrivingCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverDrivingCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverDrivingCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDriverDrivingCompanyQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetDriverDrivingCompanyQuery,
    GetDriverDrivingCompanyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetDriverDrivingCompanyQuery,
    GetDriverDrivingCompanyQueryVariables
  >(GetDriverDrivingCompanyDocument, options);
}
export function useGetDriverDrivingCompanyLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetDriverDrivingCompanyQuery,
    GetDriverDrivingCompanyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetDriverDrivingCompanyQuery,
    GetDriverDrivingCompanyQueryVariables
  >(GetDriverDrivingCompanyDocument, options);
}
export type GetDriverDrivingCompanyQueryHookResult = ReturnType<
  typeof useGetDriverDrivingCompanyQuery
>;
export type GetDriverDrivingCompanyLazyQueryHookResult = ReturnType<
  typeof useGetDriverDrivingCompanyLazyQuery
>;
export type GetDriverDrivingCompanyQueryResult = ApolloReactCommon.QueryResult<
  GetDriverDrivingCompanyQuery,
  GetDriverDrivingCompanyQueryVariables
>;
export const GetAllDriversLocationDocument = gql`
  query GetAllDriversLocation {
    drivers {
      id
      name
      location {
        latitude
        longitude
      }
    }
  }
`;

/**
 * __useGetAllDriversLocationQuery__
 *
 * To run a query within a React component, call `useGetAllDriversLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDriversLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDriversLocationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDriversLocationQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAllDriversLocationQuery,
    GetAllDriversLocationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetAllDriversLocationQuery,
    GetAllDriversLocationQueryVariables
  >(GetAllDriversLocationDocument, options);
}
export function useGetAllDriversLocationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllDriversLocationQuery,
    GetAllDriversLocationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetAllDriversLocationQuery,
    GetAllDriversLocationQueryVariables
  >(GetAllDriversLocationDocument, options);
}
export type GetAllDriversLocationQueryHookResult = ReturnType<
  typeof useGetAllDriversLocationQuery
>;
export type GetAllDriversLocationLazyQueryHookResult = ReturnType<
  typeof useGetAllDriversLocationLazyQuery
>;
export type GetAllDriversLocationQueryResult = ApolloReactCommon.QueryResult<
  GetAllDriversLocationQuery,
  GetAllDriversLocationQueryVariables
>;
export const OnNewDriverDocument = gql`
  subscription OnNewDriver {
    onNewDriver {
      ...DriverBasicInfoFragment
    }
  }
  ${DriverBasicInfoFragmentFragmentDoc}
`;

/**
 * __useOnNewDriverSubscription__
 *
 * To run a query within a React component, call `useOnNewDriverSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNewDriverSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNewDriverSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnNewDriverSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    OnNewDriverSubscription,
    OnNewDriverSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSubscription<
    OnNewDriverSubscription,
    OnNewDriverSubscriptionVariables
  >(OnNewDriverDocument, options);
}
export type OnNewDriverSubscriptionHookResult = ReturnType<
  typeof useOnNewDriverSubscription
>;
export type OnNewDriverSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<OnNewDriverSubscription>;
export const OnAnyDriverLocationUpdateDocument = gql`
  subscription OnAnyDriverLocationUpdate {
    onAnyDriverLocationUpdate {
      location {
        longitude
        latitude
      }
      ...DriverBasicInfoFragment
    }
  }
  ${DriverBasicInfoFragmentFragmentDoc}
`;

/**
 * __useOnAnyDriverLocationUpdateSubscription__
 *
 * To run a query within a React component, call `useOnAnyDriverLocationUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAnyDriverLocationUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAnyDriverLocationUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnAnyDriverLocationUpdateSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    OnAnyDriverLocationUpdateSubscription,
    OnAnyDriverLocationUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSubscription<
    OnAnyDriverLocationUpdateSubscription,
    OnAnyDriverLocationUpdateSubscriptionVariables
  >(OnAnyDriverLocationUpdateDocument, options);
}
export type OnAnyDriverLocationUpdateSubscriptionHookResult = ReturnType<
  typeof useOnAnyDriverLocationUpdateSubscription
>;
export type OnAnyDriverLocationUpdateSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<OnAnyDriverLocationUpdateSubscription>;
export const DeleteDriverDocument = gql`
  mutation DeleteDriver($id: ID) {
    deleteDriver(id: $id) {
      deleted
      reason
    }
  }
`;
export type DeleteDriverMutationFn = ApolloReactCommon.MutationFunction<
  DeleteDriverMutation,
  DeleteDriverMutationVariables
>;

/**
 * __useDeleteDriverMutation__
 *
 * To run a mutation, you first call `useDeleteDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDriverMutation, { data, loading, error }] = useDeleteDriverMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDriverMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteDriverMutation,
    DeleteDriverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DeleteDriverMutation,
    DeleteDriverMutationVariables
  >(DeleteDriverDocument, options);
}
export type DeleteDriverMutationHookResult = ReturnType<
  typeof useDeleteDriverMutation
>;
export type DeleteDriverMutationResult =
  ApolloReactCommon.MutationResult<DeleteDriverMutation>;
export type DeleteDriverMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteDriverMutation,
  DeleteDriverMutationVariables
>;
export const GetAllDriversDocument = gql`
  query GetAllDrivers($fetchDrivingCompany: Boolean!) {
    drivers {
      ...DriverBasicInfoFragment
      drivingCompany @include(if: $fetchDrivingCompany) {
        id
        volcanoId
        email
        phone
      }
    }
  }
  ${DriverBasicInfoFragmentFragmentDoc}
`;

/**
 * __useGetAllDriversQuery__
 *
 * To run a query within a React component, call `useGetAllDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDriversQuery({
 *   variables: {
 *      fetchDrivingCompany: // value for 'fetchDrivingCompany'
 *   },
 * });
 */
export function useGetAllDriversQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetAllDriversQuery,
    GetAllDriversQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetAllDriversQuery,
    GetAllDriversQueryVariables
  >(GetAllDriversDocument, options);
}
export function useGetAllDriversLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllDriversQuery,
    GetAllDriversQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetAllDriversQuery,
    GetAllDriversQueryVariables
  >(GetAllDriversDocument, options);
}
export type GetAllDriversQueryHookResult = ReturnType<
  typeof useGetAllDriversQuery
>;
export type GetAllDriversLazyQueryHookResult = ReturnType<
  typeof useGetAllDriversLazyQuery
>;
export type GetAllDriversQueryResult = ApolloReactCommon.QueryResult<
  GetAllDriversQuery,
  GetAllDriversQueryVariables
>;
export const GiveDriverAccessToAppDocument = gql`
  mutation GiveDriverAccessToApp(
    $id: ID!
    $email: String!
    $password: String!
  ) {
    giveDriverAccessToApp(email: $email, id: $id, password: $password) {
      ...DriverBasicInfoFragment
    }
  }
  ${DriverBasicInfoFragmentFragmentDoc}
`;
export type GiveDriverAccessToAppMutationFn =
  ApolloReactCommon.MutationFunction<
    GiveDriverAccessToAppMutation,
    GiveDriverAccessToAppMutationVariables
  >;

/**
 * __useGiveDriverAccessToAppMutation__
 *
 * To run a mutation, you first call `useGiveDriverAccessToAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGiveDriverAccessToAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [giveDriverAccessToAppMutation, { data, loading, error }] = useGiveDriverAccessToAppMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGiveDriverAccessToAppMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    GiveDriverAccessToAppMutation,
    GiveDriverAccessToAppMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    GiveDriverAccessToAppMutation,
    GiveDriverAccessToAppMutationVariables
  >(GiveDriverAccessToAppDocument, options);
}
export type GiveDriverAccessToAppMutationHookResult = ReturnType<
  typeof useGiveDriverAccessToAppMutation
>;
export type GiveDriverAccessToAppMutationResult =
  ApolloReactCommon.MutationResult<GiveDriverAccessToAppMutation>;
export type GiveDriverAccessToAppMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    GiveDriverAccessToAppMutation,
    GiveDriverAccessToAppMutationVariables
  >;
export const CreateDriverDocument = gql`
  mutation CreateDriver(
    $name: String
    $email: String
    $password: String
    $notificationsToken: String
    $volcanoDriverId: String
    $phone: String
    $profilePicURI: String
    $type: String
    $status: String
    $drivingCompanyId: String
    $loginMethod: LoginMethod
  ) {
    createDriver(
      name: $name
      email: $email
      password: $password
      notificationsToken: $notificationsToken
      volcanoDriverId: $volcanoDriverId
      phone: $phone
      profilePicURI: $profilePicURI
      type: $type
      status: $status
      drivingCompanyId: $drivingCompanyId
      loginMethod: $loginMethod
    ) {
      id
      firebaseId
      volcanoDriverId
      name
      email
      volcanoEmail
      phone
      loginMethod
      loginEnabled
      inVolcano
      inPrisma
      alternatePhone
      communicationLocale
      hasLoginCredentials
      name
      profilePicURI
      providerId
      received
      status
      type
      profilePicURI
      drivingCompany {
        id
      }
    }
  }
`;
export type CreateDriverMutationFn = ApolloReactCommon.MutationFunction<
  CreateDriverMutation,
  CreateDriverMutationVariables
>;

/**
 * __useCreateDriverMutation__
 *
 * To run a mutation, you first call `useCreateDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDriverMutation, { data, loading, error }] = useCreateDriverMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      notificationsToken: // value for 'notificationsToken'
 *      volcanoDriverId: // value for 'volcanoDriverId'
 *      phone: // value for 'phone'
 *      profilePicURI: // value for 'profilePicURI'
 *      type: // value for 'type'
 *      status: // value for 'status'
 *      drivingCompanyId: // value for 'drivingCompanyId'
 *      loginMethod: // value for 'loginMethod'
 *   },
 * });
 */
export function useCreateDriverMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateDriverMutation,
    CreateDriverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreateDriverMutation,
    CreateDriverMutationVariables
  >(CreateDriverDocument, options);
}
export type CreateDriverMutationHookResult = ReturnType<
  typeof useCreateDriverMutation
>;
export type CreateDriverMutationResult =
  ApolloReactCommon.MutationResult<CreateDriverMutation>;
export type CreateDriverMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateDriverMutation,
  CreateDriverMutationVariables
>;
export const UpdateDriverDocument = gql`
  mutation UpdateDriver(
    $id: ID!
    $name: String
    $email: String
    $loginMethod: LoginMethod
    $disableLogin: Boolean
    $phone: String
    $type: String
    $status: String
    $drivingCompanyId: String
    $profilePicURI: String
  ) {
    updateDriver(
      id: $id
      name: $name
      email: $email
      loginMethod: $loginMethod
      disableLogin: $disableLogin
      phone: $phone
      type: $type
      status: $status
      drivingCompanyId: $drivingCompanyId
      profilePicURI: $profilePicURI
    ) {
      id
      firebaseId
      volcanoDriverId
      name
      email
      volcanoEmail
      phone
      loginMethod
      loginEnabled
      inVolcano
      inPrisma
      alternatePhone
      communicationLocale
      hasLoginCredentials
      name
      profilePicURI
      providerId
      received
      status
      type
      profilePicURI
      drivingCompany {
        id
      }
    }
  }
`;
export type UpdateDriverMutationFn = ApolloReactCommon.MutationFunction<
  UpdateDriverMutation,
  UpdateDriverMutationVariables
>;

/**
 * __useUpdateDriverMutation__
 *
 * To run a mutation, you first call `useUpdateDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverMutation, { data, loading, error }] = useUpdateDriverMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      loginMethod: // value for 'loginMethod'
 *      disableLogin: // value for 'disableLogin'
 *      phone: // value for 'phone'
 *      type: // value for 'type'
 *      status: // value for 'status'
 *      drivingCompanyId: // value for 'drivingCompanyId'
 *      profilePicURI: // value for 'profilePicURI'
 *   },
 * });
 */
export function useUpdateDriverMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateDriverMutation,
    UpdateDriverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateDriverMutation,
    UpdateDriverMutationVariables
  >(UpdateDriverDocument, options);
}
export type UpdateDriverMutationHookResult = ReturnType<
  typeof useUpdateDriverMutation
>;
export type UpdateDriverMutationResult =
  ApolloReactCommon.MutationResult<UpdateDriverMutation>;
export type UpdateDriverMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateDriverMutation,
  UpdateDriverMutationVariables
>;
export const GetDriverByEmailDocument = gql`
  query GetDriverByEmail($email: String!, $includeDrivingCompany: Boolean!) {
    driverByEmail(email: $email) {
      ...DriverBasicInfoFragment
      drivingCompany @include(if: $includeDrivingCompany) {
        id
        email
        phone
        emailHasWebPanelAccount
        volcanoId
        name
      }
    }
  }
  ${DriverBasicInfoFragmentFragmentDoc}
`;

/**
 * __useGetDriverByEmailQuery__
 *
 * To run a query within a React component, call `useGetDriverByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *      includeDrivingCompany: // value for 'includeDrivingCompany'
 *   },
 * });
 */
export function useGetDriverByEmailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetDriverByEmailQuery,
    GetDriverByEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetDriverByEmailQuery,
    GetDriverByEmailQueryVariables
  >(GetDriverByEmailDocument, options);
}
export function useGetDriverByEmailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetDriverByEmailQuery,
    GetDriverByEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetDriverByEmailQuery,
    GetDriverByEmailQueryVariables
  >(GetDriverByEmailDocument, options);
}
export type GetDriverByEmailQueryHookResult = ReturnType<
  typeof useGetDriverByEmailQuery
>;
export type GetDriverByEmailLazyQueryHookResult = ReturnType<
  typeof useGetDriverByEmailLazyQuery
>;
export type GetDriverByEmailQueryResult = ApolloReactCommon.QueryResult<
  GetDriverByEmailQuery,
  GetDriverByEmailQueryVariables
>;
export const GetAllDrivingCompaniesDocument = gql`
  query GetAllDrivingCompanies {
    drivingCompanies {
      id
      volcanoId
      name
      phone
      email
    }
  }
`;

/**
 * __useGetAllDrivingCompaniesQuery__
 *
 * To run a query within a React component, call `useGetAllDrivingCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDrivingCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDrivingCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDrivingCompaniesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAllDrivingCompaniesQuery,
    GetAllDrivingCompaniesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetAllDrivingCompaniesQuery,
    GetAllDrivingCompaniesQueryVariables
  >(GetAllDrivingCompaniesDocument, options);
}
export function useGetAllDrivingCompaniesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllDrivingCompaniesQuery,
    GetAllDrivingCompaniesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetAllDrivingCompaniesQuery,
    GetAllDrivingCompaniesQueryVariables
  >(GetAllDrivingCompaniesDocument, options);
}
export type GetAllDrivingCompaniesQueryHookResult = ReturnType<
  typeof useGetAllDrivingCompaniesQuery
>;
export type GetAllDrivingCompaniesLazyQueryHookResult = ReturnType<
  typeof useGetAllDrivingCompaniesLazyQuery
>;
export type GetAllDrivingCompaniesQueryResult = ApolloReactCommon.QueryResult<
  GetAllDrivingCompaniesQuery,
  GetAllDrivingCompaniesQueryVariables
>;
export const GetAllDrivingCompaniesListDocument = gql`
  query GetAllDrivingCompaniesList {
    drivingCompanies {
      id
      volcanoId
      name
      phone
      email
      teamMemberships {
        role
        createdAt
      }
    }
  }
`;

/**
 * __useGetAllDrivingCompaniesListQuery__
 *
 * To run a query within a React component, call `useGetAllDrivingCompaniesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDrivingCompaniesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDrivingCompaniesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDrivingCompaniesListQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAllDrivingCompaniesListQuery,
    GetAllDrivingCompaniesListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetAllDrivingCompaniesListQuery,
    GetAllDrivingCompaniesListQueryVariables
  >(GetAllDrivingCompaniesListDocument, options);
}
export function useGetAllDrivingCompaniesListLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllDrivingCompaniesListQuery,
    GetAllDrivingCompaniesListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetAllDrivingCompaniesListQuery,
    GetAllDrivingCompaniesListQueryVariables
  >(GetAllDrivingCompaniesListDocument, options);
}
export type GetAllDrivingCompaniesListQueryHookResult = ReturnType<
  typeof useGetAllDrivingCompaniesListQuery
>;
export type GetAllDrivingCompaniesListLazyQueryHookResult = ReturnType<
  typeof useGetAllDrivingCompaniesListLazyQuery
>;
export type GetAllDrivingCompaniesListQueryResult =
  ApolloReactCommon.QueryResult<
    GetAllDrivingCompaniesListQuery,
    GetAllDrivingCompaniesListQueryVariables
  >;
export const GetDrivingCompanyDriversDocument = gql`
  query GetDrivingCompanyDrivers($id: ID!) {
    drivingCompany(id: $id) {
      id
      drivers {
        ...DriverBasicInfoFragment
      }
    }
  }
  ${DriverBasicInfoFragmentFragmentDoc}
`;

/**
 * __useGetDrivingCompanyDriversQuery__
 *
 * To run a query within a React component, call `useGetDrivingCompanyDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrivingCompanyDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrivingCompanyDriversQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDrivingCompanyDriversQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetDrivingCompanyDriversQuery,
    GetDrivingCompanyDriversQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetDrivingCompanyDriversQuery,
    GetDrivingCompanyDriversQueryVariables
  >(GetDrivingCompanyDriversDocument, options);
}
export function useGetDrivingCompanyDriversLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetDrivingCompanyDriversQuery,
    GetDrivingCompanyDriversQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetDrivingCompanyDriversQuery,
    GetDrivingCompanyDriversQueryVariables
  >(GetDrivingCompanyDriversDocument, options);
}
export type GetDrivingCompanyDriversQueryHookResult = ReturnType<
  typeof useGetDrivingCompanyDriversQuery
>;
export type GetDrivingCompanyDriversLazyQueryHookResult = ReturnType<
  typeof useGetDrivingCompanyDriversLazyQuery
>;
export type GetDrivingCompanyDriversQueryResult = ApolloReactCommon.QueryResult<
  GetDrivingCompanyDriversQuery,
  GetDrivingCompanyDriversQueryVariables
>;
export const DrivingCompanyDocument = gql`
  query DrivingCompany($id: ID!, $fetchDrivers: Boolean!) {
    drivingCompany(id: $id) {
      id
      volcanoId
      name
      email
      phone
      emailHasWebPanelAccount
      drivers @include(if: $fetchDrivers) {
        ...DriverBasicInfoFragment
      }
    }
  }
  ${DriverBasicInfoFragmentFragmentDoc}
`;

/**
 * __useDrivingCompanyQuery__
 *
 * To run a query within a React component, call `useDrivingCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrivingCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrivingCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      fetchDrivers: // value for 'fetchDrivers'
 *   },
 * });
 */
export function useDrivingCompanyQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    DrivingCompanyQuery,
    DrivingCompanyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    DrivingCompanyQuery,
    DrivingCompanyQueryVariables
  >(DrivingCompanyDocument, options);
}
export function useDrivingCompanyLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    DrivingCompanyQuery,
    DrivingCompanyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    DrivingCompanyQuery,
    DrivingCompanyQueryVariables
  >(DrivingCompanyDocument, options);
}
export type DrivingCompanyQueryHookResult = ReturnType<
  typeof useDrivingCompanyQuery
>;
export type DrivingCompanyLazyQueryHookResult = ReturnType<
  typeof useDrivingCompanyLazyQuery
>;
export type DrivingCompanyQueryResult = ApolloReactCommon.QueryResult<
  DrivingCompanyQuery,
  DrivingCompanyQueryVariables
>;
export const DrivingCompanyMembershipsDocument = gql`
  query DrivingCompanyMemberships($id: ID!) {
    drivingCompany(id: $id) {
      id
      teamMemberships {
        id
        createdAt
        role
        member {
          id
          name
          email
          disabled
        }
      }
    }
  }
`;

/**
 * __useDrivingCompanyMembershipsQuery__
 *
 * To run a query within a React component, call `useDrivingCompanyMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrivingCompanyMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrivingCompanyMembershipsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDrivingCompanyMembershipsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    DrivingCompanyMembershipsQuery,
    DrivingCompanyMembershipsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    DrivingCompanyMembershipsQuery,
    DrivingCompanyMembershipsQueryVariables
  >(DrivingCompanyMembershipsDocument, options);
}
export function useDrivingCompanyMembershipsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    DrivingCompanyMembershipsQuery,
    DrivingCompanyMembershipsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    DrivingCompanyMembershipsQuery,
    DrivingCompanyMembershipsQueryVariables
  >(DrivingCompanyMembershipsDocument, options);
}
export type DrivingCompanyMembershipsQueryHookResult = ReturnType<
  typeof useDrivingCompanyMembershipsQuery
>;
export type DrivingCompanyMembershipsLazyQueryHookResult = ReturnType<
  typeof useDrivingCompanyMembershipsLazyQuery
>;
export type DrivingCompanyMembershipsQueryResult =
  ApolloReactCommon.QueryResult<
    DrivingCompanyMembershipsQuery,
    DrivingCompanyMembershipsQueryVariables
  >;
export const CreateDrivingCompanyAdminDocument = gql`
  mutation CreateDrivingCompanyAdmin(
    $id: ID!
    $email: String!
    $password: String
    $name: String!
  ) {
    DrivingCompany(id: $id) {
      createTeamMembership(
        email: $email
        password: $password
        role: ADMIN
        name: $name
      ) {
        id
        volcanoId
        name
        email
        phone
        teamMemberships {
          createdAt
          role
        }
      }
    }
  }
`;
export type CreateDrivingCompanyAdminMutationFn =
  ApolloReactCommon.MutationFunction<
    CreateDrivingCompanyAdminMutation,
    CreateDrivingCompanyAdminMutationVariables
  >;

/**
 * __useCreateDrivingCompanyAdminMutation__
 *
 * To run a mutation, you first call `useCreateDrivingCompanyAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDrivingCompanyAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDrivingCompanyAdminMutation, { data, loading, error }] = useCreateDrivingCompanyAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateDrivingCompanyAdminMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateDrivingCompanyAdminMutation,
    CreateDrivingCompanyAdminMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreateDrivingCompanyAdminMutation,
    CreateDrivingCompanyAdminMutationVariables
  >(CreateDrivingCompanyAdminDocument, options);
}
export type CreateDrivingCompanyAdminMutationHookResult = ReturnType<
  typeof useCreateDrivingCompanyAdminMutation
>;
export type CreateDrivingCompanyAdminMutationResult =
  ApolloReactCommon.MutationResult<CreateDrivingCompanyAdminMutation>;
export type CreateDrivingCompanyAdminMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateDrivingCompanyAdminMutation,
    CreateDrivingCompanyAdminMutationVariables
  >;
export const UpdateMembershipDocument = gql`
  mutation UpdateMembership(
    $drivingCompanyId: ID!
    $membershipId: ID!
    $userId: ID!
    $userEmail: String
    $userName: String
    $role: DrivingCompanyTeamMemberShipRole
  ) {
    updateUser(email: $userEmail, id: $userId, name: $userName) {
      id
      name
      email
    }
    DrivingCompany(id: $drivingCompanyId) {
      Membership(id: $membershipId) {
        update(role: $role) {
          id
          teamMemberships {
            createdAt
            role
          }
        }
      }
    }
  }
`;
export type UpdateMembershipMutationFn = ApolloReactCommon.MutationFunction<
  UpdateMembershipMutation,
  UpdateMembershipMutationVariables
>;

/**
 * __useUpdateMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMembershipMutation, { data, loading, error }] = useUpdateMembershipMutation({
 *   variables: {
 *      drivingCompanyId: // value for 'drivingCompanyId'
 *      membershipId: // value for 'membershipId'
 *      userId: // value for 'userId'
 *      userEmail: // value for 'userEmail'
 *      userName: // value for 'userName'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateMembershipMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateMembershipMutation,
    UpdateMembershipMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateMembershipMutation,
    UpdateMembershipMutationVariables
  >(UpdateMembershipDocument, options);
}
export type UpdateMembershipMutationHookResult = ReturnType<
  typeof useUpdateMembershipMutation
>;
export type UpdateMembershipMutationResult =
  ApolloReactCommon.MutationResult<UpdateMembershipMutation>;
export type UpdateMembershipMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateMembershipMutation,
    UpdateMembershipMutationVariables
  >;
export const ConfirmItineraryDocument = gql`
  mutation ConfirmItinerary($id: ID!) {
    confirmItinerary(id: $id) {
      ...ItineraryBasicFragment
    }
  }
  ${ItineraryBasicFragmentFragmentDoc}
`;
export type ConfirmItineraryMutationFn = ApolloReactCommon.MutationFunction<
  ConfirmItineraryMutation,
  ConfirmItineraryMutationVariables
>;

/**
 * __useConfirmItineraryMutation__
 *
 * To run a mutation, you first call `useConfirmItineraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmItineraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmItineraryMutation, { data, loading, error }] = useConfirmItineraryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmItineraryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ConfirmItineraryMutation,
    ConfirmItineraryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    ConfirmItineraryMutation,
    ConfirmItineraryMutationVariables
  >(ConfirmItineraryDocument, options);
}
export type ConfirmItineraryMutationHookResult = ReturnType<
  typeof useConfirmItineraryMutation
>;
export type ConfirmItineraryMutationResult =
  ApolloReactCommon.MutationResult<ConfirmItineraryMutation>;
export type ConfirmItineraryMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ConfirmItineraryMutation,
    ConfirmItineraryMutationVariables
  >;
export const CreatePassengerDocument = gql`
  mutation CreatePassenger($email: String!, $phone: String, $name: String) {
    createPassenger(email: $email, phone: $phone, name: $name) {
      ...PassengerInfo
      id
      email
      phone
      name
    }
  }
  ${PassengerInfoFragmentDoc}
`;
export type CreatePassengerMutationFn = ApolloReactCommon.MutationFunction<
  CreatePassengerMutation,
  CreatePassengerMutationVariables
>;

/**
 * __useCreatePassengerMutation__
 *
 * To run a mutation, you first call `useCreatePassengerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePassengerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPassengerMutation, { data, loading, error }] = useCreatePassengerMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreatePassengerMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreatePassengerMutation,
    CreatePassengerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreatePassengerMutation,
    CreatePassengerMutationVariables
  >(CreatePassengerDocument, options);
}
export type CreatePassengerMutationHookResult = ReturnType<
  typeof useCreatePassengerMutation
>;
export type CreatePassengerMutationResult =
  ApolloReactCommon.MutationResult<CreatePassengerMutation>;
export type CreatePassengerMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreatePassengerMutation,
    CreatePassengerMutationVariables
  >;
export const GetPassengerDocument = gql`
  query GetPassenger($id: ID!) {
    passenger(id: $id) {
      ...PassengerInfo
    }
  }
  ${PassengerInfoFragmentDoc}
`;

/**
 * __useGetPassengerQuery__
 *
 * To run a query within a React component, call `useGetPassengerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPassengerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPassengerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPassengerQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPassengerQuery,
    GetPassengerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetPassengerQuery,
    GetPassengerQueryVariables
  >(GetPassengerDocument, options);
}
export function useGetPassengerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPassengerQuery,
    GetPassengerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetPassengerQuery,
    GetPassengerQueryVariables
  >(GetPassengerDocument, options);
}
export type GetPassengerQueryHookResult = ReturnType<
  typeof useGetPassengerQuery
>;
export type GetPassengerLazyQueryHookResult = ReturnType<
  typeof useGetPassengerLazyQuery
>;
export type GetPassengerQueryResult = ApolloReactCommon.QueryResult<
  GetPassengerQuery,
  GetPassengerQueryVariables
>;
export const GetPassengersDocument = gql`
  query GetPassengers {
    passengers {
      ...PassengerInfo
    }
  }
  ${PassengerInfoFragmentDoc}
`;

/**
 * __useGetPassengersQuery__
 *
 * To run a query within a React component, call `useGetPassengersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPassengersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPassengersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPassengersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetPassengersQuery,
    GetPassengersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetPassengersQuery,
    GetPassengersQueryVariables
  >(GetPassengersDocument, options);
}
export function useGetPassengersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPassengersQuery,
    GetPassengersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetPassengersQuery,
    GetPassengersQueryVariables
  >(GetPassengersDocument, options);
}
export type GetPassengersQueryHookResult = ReturnType<
  typeof useGetPassengersQuery
>;
export type GetPassengersLazyQueryHookResult = ReturnType<
  typeof useGetPassengersLazyQuery
>;
export type GetPassengersQueryResult = ApolloReactCommon.QueryResult<
  GetPassengersQuery,
  GetPassengersQueryVariables
>;
export const GetRatesDocument = gql`
  query GetRates {
    rates {
      id
      isGlobal
      name
      clients {
        id
        volcanoClientId
      }
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetRatesQuery__
 *
 * To run a query within a React component, call `useGetRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRatesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetRatesQuery,
    GetRatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetRatesQuery, GetRatesQueryVariables>(
    GetRatesDocument,
    options,
  );
}
export function useGetRatesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetRatesQuery,
    GetRatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetRatesQuery, GetRatesQueryVariables>(
    GetRatesDocument,
    options,
  );
}
export type GetRatesQueryHookResult = ReturnType<typeof useGetRatesQuery>;
export type GetRatesLazyQueryHookResult = ReturnType<
  typeof useGetRatesLazyQuery
>;
export type GetRatesQueryResult = ApolloReactCommon.QueryResult<
  GetRatesQuery,
  GetRatesQueryVariables
>;
export const GetARateDocument = gql`
  query GetARate($id: ID!) {
    rate(id: $id) {
      id
      isGlobal
      name
      clients {
        id
        volcanoClientId
        name
      }
      createdAt
      updatedAt
      serviceTypes {
        id
        name
        description
        subtypes {
          id
          name
          hours
          dinner
          description
          priceConditions {
            vehicle {
              basePrice
              extraHourPrice
              numPassengers
              description
              id
              name
              vehicleBrandId
              vehicleModelId
              vehicleTypeId
            }
          }
          fulfillingCondition {
            conditionType
            conditionActivation
            description
            id
            name
            threshold
          }
        }
      }
      vehicleCategories {
        id
        name
        description
        vehicleBrand {
          id
          brand
        }
        vehicleModel {
          id
          name
        }
        vehicleCapacity
        vehicleType {
          id
          name
        }
      }
      vehiclePriceVariables {
        id
        extraHourPrice
        extraPricePerKm
        tollPricePerKm
        paxNumber
        airportPrice
        parkingMontserrat
        vehicleBrandId
        vehicleModelId
        vehicleTypeId
      }
    }
  }
`;

/**
 * __useGetARateQuery__
 *
 * To run a query within a React component, call `useGetARateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetARateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetARateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetARateQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetARateQuery,
    GetARateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetARateQuery, GetARateQueryVariables>(
    GetARateDocument,
    options,
  );
}
export function useGetARateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetARateQuery,
    GetARateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetARateQuery, GetARateQueryVariables>(
    GetARateDocument,
    options,
  );
}
export type GetARateQueryHookResult = ReturnType<typeof useGetARateQuery>;
export type GetARateLazyQueryHookResult = ReturnType<
  typeof useGetARateLazyQuery
>;
export type GetARateQueryResult = ApolloReactCommon.QueryResult<
  GetARateQuery,
  GetARateQueryVariables
>;
export const CloneARateDocument = gql`
  mutation CloneARate($rateToClone: ID!, $name: String!) {
    cloneRate(rateToClone: $rateToClone, name: $name) {
      id
      isGlobal
      name
      clients {
        id
        volcanoClientId
      }
      createdAt
      updatedAt
    }
  }
`;
export type CloneARateMutationFn = ApolloReactCommon.MutationFunction<
  CloneARateMutation,
  CloneARateMutationVariables
>;

/**
 * __useCloneARateMutation__
 *
 * To run a mutation, you first call `useCloneARateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneARateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneARateMutation, { data, loading, error }] = useCloneARateMutation({
 *   variables: {
 *      rateToClone: // value for 'rateToClone'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCloneARateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CloneARateMutation,
    CloneARateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CloneARateMutation,
    CloneARateMutationVariables
  >(CloneARateDocument, options);
}
export type CloneARateMutationHookResult = ReturnType<
  typeof useCloneARateMutation
>;
export type CloneARateMutationResult =
  ApolloReactCommon.MutationResult<CloneARateMutation>;
export type CloneARateMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CloneARateMutation,
  CloneARateMutationVariables
>;
export const UpdateARateDocument = gql`
  mutation UpdateARate($rate: ID!, $name: String) {
    updateRate(rate: $rate, name: $name) {
      id
      isGlobal
      name
      clients {
        id
        volcanoClientId
      }
      createdAt
      updatedAt
    }
  }
`;
export type UpdateARateMutationFn = ApolloReactCommon.MutationFunction<
  UpdateARateMutation,
  UpdateARateMutationVariables
>;

/**
 * __useUpdateARateMutation__
 *
 * To run a mutation, you first call `useUpdateARateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateARateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateARateMutation, { data, loading, error }] = useUpdateARateMutation({
 *   variables: {
 *      rate: // value for 'rate'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateARateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateARateMutation,
    UpdateARateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateARateMutation,
    UpdateARateMutationVariables
  >(UpdateARateDocument, options);
}
export type UpdateARateMutationHookResult = ReturnType<
  typeof useUpdateARateMutation
>;
export type UpdateARateMutationResult =
  ApolloReactCommon.MutationResult<UpdateARateMutation>;
export type UpdateARateMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateARateMutation,
  UpdateARateMutationVariables
>;
export const DeleteARateDocument = gql`
  mutation DeleteARate($rate: ID!) {
    deleteRate(rate: $rate)
  }
`;
export type DeleteARateMutationFn = ApolloReactCommon.MutationFunction<
  DeleteARateMutation,
  DeleteARateMutationVariables
>;

/**
 * __useDeleteARateMutation__
 *
 * To run a mutation, you first call `useDeleteARateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteARateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteARateMutation, { data, loading, error }] = useDeleteARateMutation({
 *   variables: {
 *      rate: // value for 'rate'
 *   },
 * });
 */
export function useDeleteARateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteARateMutation,
    DeleteARateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DeleteARateMutation,
    DeleteARateMutationVariables
  >(DeleteARateDocument, options);
}
export type DeleteARateMutationHookResult = ReturnType<
  typeof useDeleteARateMutation
>;
export type DeleteARateMutationResult =
  ApolloReactCommon.MutationResult<DeleteARateMutation>;
export type DeleteARateMutationOptions = ApolloReactCommon.BaseMutationOptions<
  DeleteARateMutation,
  DeleteARateMutationVariables
>;
export const AssignClientsToRateDocument = gql`
  mutation assignClientsToRate($clients: [String!]!, $rateId: ID!) {
    assignRateToClients(clients: $clients, rateId: $rateId) {
      id
      isGlobal
      name
      clients {
        id
        volcanoClientId
        name
      }
      createdAt
      updatedAt
    }
  }
`;
export type AssignClientsToRateMutationFn = ApolloReactCommon.MutationFunction<
  AssignClientsToRateMutation,
  AssignClientsToRateMutationVariables
>;

/**
 * __useAssignClientsToRateMutation__
 *
 * To run a mutation, you first call `useAssignClientsToRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignClientsToRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignClientsToRateMutation, { data, loading, error }] = useAssignClientsToRateMutation({
 *   variables: {
 *      clients: // value for 'clients'
 *      rateId: // value for 'rateId'
 *   },
 * });
 */
export function useAssignClientsToRateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AssignClientsToRateMutation,
    AssignClientsToRateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AssignClientsToRateMutation,
    AssignClientsToRateMutationVariables
  >(AssignClientsToRateDocument, options);
}
export type AssignClientsToRateMutationHookResult = ReturnType<
  typeof useAssignClientsToRateMutation
>;
export type AssignClientsToRateMutationResult =
  ApolloReactCommon.MutationResult<AssignClientsToRateMutation>;
export type AssignClientsToRateMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AssignClientsToRateMutation,
    AssignClientsToRateMutationVariables
  >;
export const DisassignClientsFromRateDocument = gql`
  mutation disassignClientsFromRate($clients: [String!]!, $rateId: ID!) {
    disassignRateFromClients(clients: $clients, rateId: $rateId) {
      id
      isGlobal
      name
      clients {
        id
        volcanoClientId
        name
      }
      createdAt
      updatedAt
    }
  }
`;
export type DisassignClientsFromRateMutationFn =
  ApolloReactCommon.MutationFunction<
    DisassignClientsFromRateMutation,
    DisassignClientsFromRateMutationVariables
  >;

/**
 * __useDisassignClientsFromRateMutation__
 *
 * To run a mutation, you first call `useDisassignClientsFromRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisassignClientsFromRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disassignClientsFromRateMutation, { data, loading, error }] = useDisassignClientsFromRateMutation({
 *   variables: {
 *      clients: // value for 'clients'
 *      rateId: // value for 'rateId'
 *   },
 * });
 */
export function useDisassignClientsFromRateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DisassignClientsFromRateMutation,
    DisassignClientsFromRateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DisassignClientsFromRateMutation,
    DisassignClientsFromRateMutationVariables
  >(DisassignClientsFromRateDocument, options);
}
export type DisassignClientsFromRateMutationHookResult = ReturnType<
  typeof useDisassignClientsFromRateMutation
>;
export type DisassignClientsFromRateMutationResult =
  ApolloReactCommon.MutationResult<DisassignClientsFromRateMutation>;
export type DisassignClientsFromRateMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DisassignClientsFromRateMutation,
    DisassignClientsFromRateMutationVariables
  >;
export const GetClientRateDocument = gql`
  query GetClientRate($clientId: ID!) {
    client(id: $clientId) {
      id
      rate {
        id
        isGlobal
        serviceTypes {
          id
          name
          description
          subtypes {
            id
            name
            hours
            dinner
            description
            priceConditions {
              vehicle {
                basePrice
                extraHourPrice
                numPassengers
                description
                id
                name
                vehicleBrandId
                vehicleModelId
                vehicleTypeId
              }
            }
            fulfillingCondition {
              conditionType
              conditionActivation
              description
              id
              name
              threshold
            }
          }
        }
        vehicleCategories {
          id
          name
          description
          vehicleBrand {
            id
            brand
          }
          vehicleModel {
            id
            name
          }
          vehicleCapacity
          vehicleType {
            id
            name
          }
        }
        vehiclePriceVariables {
          id
          extraHourPrice
          extraPricePerKm
          tollPricePerKm
          paxNumber
          airportPrice
          parkingMontserrat
          vehicleBrandId
          vehicleModelId
          vehicleTypeId
        }
      }
    }
  }
`;

/**
 * __useGetClientRateQuery__
 *
 * To run a query within a React component, call `useGetClientRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientRateQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetClientRateQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetClientRateQuery,
    GetClientRateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetClientRateQuery,
    GetClientRateQueryVariables
  >(GetClientRateDocument, options);
}
export function useGetClientRateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetClientRateQuery,
    GetClientRateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetClientRateQuery,
    GetClientRateQueryVariables
  >(GetClientRateDocument, options);
}
export type GetClientRateQueryHookResult = ReturnType<
  typeof useGetClientRateQuery
>;
export type GetClientRateLazyQueryHookResult = ReturnType<
  typeof useGetClientRateLazyQuery
>;
export type GetClientRateQueryResult = ApolloReactCommon.QueryResult<
  GetClientRateQuery,
  GetClientRateQueryVariables
>;
export const GetGlobalRateDocument = gql`
  query GetGlobalRate {
    globalRate {
      id
      isGlobal
      serviceTypes {
        id
        name
        description
        subtypes {
          id
          name
          hours
          dinner
          description
          priceConditions {
            vehicle {
              basePrice
              extraHourPrice
              numPassengers
              description
              id
              name
              vehicleBrandId
              vehicleModelId
              vehicleTypeId
            }
          }
          fulfillingCondition {
            conditionType
            conditionActivation
            description
            id
            name
            threshold
          }
        }
      }
      vehicleCategories {
        id
        name
        description
        vehicleBrand {
          id
          brand
        }
        vehicleModel {
          id
          name
        }
        vehicleCapacity
        vehicleType {
          id
          name
        }
      }
      vehiclePriceVariables {
        id
        extraHourPrice
        extraPricePerKm
        tollPricePerKm
        paxNumber
        airportPrice
        parkingMontserrat
        vehicleBrandId
        vehicleModelId
        vehicleTypeId
      }
    }
  }
`;

/**
 * __useGetGlobalRateQuery__
 *
 * To run a query within a React component, call `useGetGlobalRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalRateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGlobalRateQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetGlobalRateQuery,
    GetGlobalRateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetGlobalRateQuery,
    GetGlobalRateQueryVariables
  >(GetGlobalRateDocument, options);
}
export function useGetGlobalRateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetGlobalRateQuery,
    GetGlobalRateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetGlobalRateQuery,
    GetGlobalRateQueryVariables
  >(GetGlobalRateDocument, options);
}
export type GetGlobalRateQueryHookResult = ReturnType<
  typeof useGetGlobalRateQuery
>;
export type GetGlobalRateLazyQueryHookResult = ReturnType<
  typeof useGetGlobalRateLazyQuery
>;
export type GetGlobalRateQueryResult = ApolloReactCommon.QueryResult<
  GetGlobalRateQuery,
  GetGlobalRateQueryVariables
>;
export const CreateVehiclePriceConditionDocument = gql`
  mutation CreateVehiclePriceCondition(
    $description: String
    $extraHourPrice: Float
    $name: String!
    $numPassengers: Int
    $price: Float!
    $rateId: String!
    $serviceSubtypeId: ID!
    $vehicleBrandId: String
    $vehicleModelId: String
    $vehicleTypeId: String
  ) {
    createVehiclePriceCondition(
      description: $description
      extraHourPrice: $extraHourPrice
      name: $name
      numPassengers: $numPassengers
      price: $price
      rateId: $rateId
      serviceSubtypeId: $serviceSubtypeId
      vehicleBrandId: $vehicleBrandId
      vehicleModelId: $vehicleModelId
      vehicleTypeId: $vehicleTypeId
    ) {
      ...VehiclePriceConditionFragment
    }
  }
  ${VehiclePriceConditionFragmentFragmentDoc}
`;
export type CreateVehiclePriceConditionMutationFn =
  ApolloReactCommon.MutationFunction<
    CreateVehiclePriceConditionMutation,
    CreateVehiclePriceConditionMutationVariables
  >;

/**
 * __useCreateVehiclePriceConditionMutation__
 *
 * To run a mutation, you first call `useCreateVehiclePriceConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehiclePriceConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVehiclePriceConditionMutation, { data, loading, error }] = useCreateVehiclePriceConditionMutation({
 *   variables: {
 *      description: // value for 'description'
 *      extraHourPrice: // value for 'extraHourPrice'
 *      name: // value for 'name'
 *      numPassengers: // value for 'numPassengers'
 *      price: // value for 'price'
 *      rateId: // value for 'rateId'
 *      serviceSubtypeId: // value for 'serviceSubtypeId'
 *      vehicleBrandId: // value for 'vehicleBrandId'
 *      vehicleModelId: // value for 'vehicleModelId'
 *      vehicleTypeId: // value for 'vehicleTypeId'
 *   },
 * });
 */
export function useCreateVehiclePriceConditionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateVehiclePriceConditionMutation,
    CreateVehiclePriceConditionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreateVehiclePriceConditionMutation,
    CreateVehiclePriceConditionMutationVariables
  >(CreateVehiclePriceConditionDocument, options);
}
export type CreateVehiclePriceConditionMutationHookResult = ReturnType<
  typeof useCreateVehiclePriceConditionMutation
>;
export type CreateVehiclePriceConditionMutationResult =
  ApolloReactCommon.MutationResult<CreateVehiclePriceConditionMutation>;
export type CreateVehiclePriceConditionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateVehiclePriceConditionMutation,
    CreateVehiclePriceConditionMutationVariables
  >;
export const UpdateVehiclePriceConditionDocument = gql`
  mutation UpdateVehiclePriceCondition(
    $description: String
    $extraHourPrice: Float
    $name: String!
    $numPassengers: Int
    $price: Float!
    $vehicleBrandId: String
    $vehicleModelId: String
    $vehicleTypeId: String
    $id: ID!
  ) {
    updateVehiclePriceCondition(
      description: $description
      extraHourPrice: $extraHourPrice
      name: $name
      numPassengers: $numPassengers
      price: $price
      vehicleBrandId: $vehicleBrandId
      vehicleModelId: $vehicleModelId
      vehicleTypeId: $vehicleTypeId
      id: $id
    ) {
      ...VehiclePriceConditionFragment
    }
  }
  ${VehiclePriceConditionFragmentFragmentDoc}
`;
export type UpdateVehiclePriceConditionMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateVehiclePriceConditionMutation,
    UpdateVehiclePriceConditionMutationVariables
  >;

/**
 * __useUpdateVehiclePriceConditionMutation__
 *
 * To run a mutation, you first call `useUpdateVehiclePriceConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehiclePriceConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehiclePriceConditionMutation, { data, loading, error }] = useUpdateVehiclePriceConditionMutation({
 *   variables: {
 *      description: // value for 'description'
 *      extraHourPrice: // value for 'extraHourPrice'
 *      name: // value for 'name'
 *      numPassengers: // value for 'numPassengers'
 *      price: // value for 'price'
 *      vehicleBrandId: // value for 'vehicleBrandId'
 *      vehicleModelId: // value for 'vehicleModelId'
 *      vehicleTypeId: // value for 'vehicleTypeId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateVehiclePriceConditionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateVehiclePriceConditionMutation,
    UpdateVehiclePriceConditionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateVehiclePriceConditionMutation,
    UpdateVehiclePriceConditionMutationVariables
  >(UpdateVehiclePriceConditionDocument, options);
}
export type UpdateVehiclePriceConditionMutationHookResult = ReturnType<
  typeof useUpdateVehiclePriceConditionMutation
>;
export type UpdateVehiclePriceConditionMutationResult =
  ApolloReactCommon.MutationResult<UpdateVehiclePriceConditionMutation>;
export type UpdateVehiclePriceConditionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateVehiclePriceConditionMutation,
    UpdateVehiclePriceConditionMutationVariables
  >;
export const DeleteVehiclePriceConditionDocument = gql`
  mutation DeleteVehiclePriceCondition($id: ID!) {
    deleteVehiclePriceCondition(id: $id) {
      deleted
      reason
    }
  }
`;
export type DeleteVehiclePriceConditionMutationFn =
  ApolloReactCommon.MutationFunction<
    DeleteVehiclePriceConditionMutation,
    DeleteVehiclePriceConditionMutationVariables
  >;

/**
 * __useDeleteVehiclePriceConditionMutation__
 *
 * To run a mutation, you first call `useDeleteVehiclePriceConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehiclePriceConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVehiclePriceConditionMutation, { data, loading, error }] = useDeleteVehiclePriceConditionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVehiclePriceConditionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteVehiclePriceConditionMutation,
    DeleteVehiclePriceConditionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DeleteVehiclePriceConditionMutation,
    DeleteVehiclePriceConditionMutationVariables
  >(DeleteVehiclePriceConditionDocument, options);
}
export type DeleteVehiclePriceConditionMutationHookResult = ReturnType<
  typeof useDeleteVehiclePriceConditionMutation
>;
export type DeleteVehiclePriceConditionMutationResult =
  ApolloReactCommon.MutationResult<DeleteVehiclePriceConditionMutation>;
export type DeleteVehiclePriceConditionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteVehiclePriceConditionMutation,
    DeleteVehiclePriceConditionMutationVariables
  >;
export const CreateVehiclePriceVariableDocument = gql`
  mutation CreateVehiclePriceVariable(
    $extraHourPrice: Float
    $numPassengers: Int
    $vehicleBrandId: String
    $vehicleModelId: String
    $vehicleTypeId: String
    $rateID: ID!
    $airportPrice: Float
    $extraKmPrice: Float
    $extraTollPrice: Float
    $parkingMontserratPrice: Float
  ) {
    createVehiclePriceVariable(
      extraHourPrice: $extraHourPrice
      extraTollPrice: $extraTollPrice
      numPassengers: $numPassengers
      vehicleBrandId: $vehicleBrandId
      vehicleModelId: $vehicleModelId
      vehicleTypeId: $vehicleTypeId
      rateId: $rateID
      airportPrice: $airportPrice
      extraKmPrice: $extraKmPrice
      parkingMontserratPrice: $parkingMontserratPrice
    ) {
      ...VehiclePriceVariableFragment
    }
  }
  ${VehiclePriceVariableFragmentFragmentDoc}
`;
export type CreateVehiclePriceVariableMutationFn =
  ApolloReactCommon.MutationFunction<
    CreateVehiclePriceVariableMutation,
    CreateVehiclePriceVariableMutationVariables
  >;

/**
 * __useCreateVehiclePriceVariableMutation__
 *
 * To run a mutation, you first call `useCreateVehiclePriceVariableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehiclePriceVariableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVehiclePriceVariableMutation, { data, loading, error }] = useCreateVehiclePriceVariableMutation({
 *   variables: {
 *      extraHourPrice: // value for 'extraHourPrice'
 *      numPassengers: // value for 'numPassengers'
 *      vehicleBrandId: // value for 'vehicleBrandId'
 *      vehicleModelId: // value for 'vehicleModelId'
 *      vehicleTypeId: // value for 'vehicleTypeId'
 *      rateID: // value for 'rateID'
 *      airportPrice: // value for 'airportPrice'
 *      extraKmPrice: // value for 'extraKmPrice'
 *      extraTollPrice: // value for 'extraTollPrice'
 *      parkingMontserratPrice: // value for 'parkingMontserratPrice'
 *   },
 * });
 */
export function useCreateVehiclePriceVariableMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateVehiclePriceVariableMutation,
    CreateVehiclePriceVariableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreateVehiclePriceVariableMutation,
    CreateVehiclePriceVariableMutationVariables
  >(CreateVehiclePriceVariableDocument, options);
}
export type CreateVehiclePriceVariableMutationHookResult = ReturnType<
  typeof useCreateVehiclePriceVariableMutation
>;
export type CreateVehiclePriceVariableMutationResult =
  ApolloReactCommon.MutationResult<CreateVehiclePriceVariableMutation>;
export type CreateVehiclePriceVariableMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateVehiclePriceVariableMutation,
    CreateVehiclePriceVariableMutationVariables
  >;
export const UpdateVehiclePriceVariableDocument = gql`
  mutation UpdateVehiclePriceVariable(
    $extraHourPrice: Float
    $numPassengers: Int
    $vehicleBrandId: String
    $vehicleModelId: String
    $vehicleTypeId: String
    $id: ID!
    $airportPrice: Float
    $extraKmPrice: Float
    $parkingMontserratPrice: Float
    $extraTollPrice: Float
  ) {
    updateVehiclePriceVariable(
      extraHourPrice: $extraHourPrice
      numPassengers: $numPassengers
      vehicleBrandId: $vehicleBrandId
      vehicleModelId: $vehicleModelId
      vehicleTypeId: $vehicleTypeId
      airportPrice: $airportPrice
      extraKmPrice: $extraKmPrice
      extraTollPrice: $extraTollPrice
      parkingMontserratPrice: $parkingMontserratPrice
      id: $id
    ) {
      ...VehiclePriceVariableFragment
    }
  }
  ${VehiclePriceVariableFragmentFragmentDoc}
`;
export type UpdateVehiclePriceVariableMutationFn =
  ApolloReactCommon.MutationFunction<
    UpdateVehiclePriceVariableMutation,
    UpdateVehiclePriceVariableMutationVariables
  >;

/**
 * __useUpdateVehiclePriceVariableMutation__
 *
 * To run a mutation, you first call `useUpdateVehiclePriceVariableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehiclePriceVariableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehiclePriceVariableMutation, { data, loading, error }] = useUpdateVehiclePriceVariableMutation({
 *   variables: {
 *      extraHourPrice: // value for 'extraHourPrice'
 *      numPassengers: // value for 'numPassengers'
 *      vehicleBrandId: // value for 'vehicleBrandId'
 *      vehicleModelId: // value for 'vehicleModelId'
 *      vehicleTypeId: // value for 'vehicleTypeId'
 *      id: // value for 'id'
 *      airportPrice: // value for 'airportPrice'
 *      extraKmPrice: // value for 'extraKmPrice'
 *      parkingMontserratPrice: // value for 'parkingMontserratPrice'
 *      extraTollPrice: // value for 'extraTollPrice'
 *   },
 * });
 */
export function useUpdateVehiclePriceVariableMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateVehiclePriceVariableMutation,
    UpdateVehiclePriceVariableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateVehiclePriceVariableMutation,
    UpdateVehiclePriceVariableMutationVariables
  >(UpdateVehiclePriceVariableDocument, options);
}
export type UpdateVehiclePriceVariableMutationHookResult = ReturnType<
  typeof useUpdateVehiclePriceVariableMutation
>;
export type UpdateVehiclePriceVariableMutationResult =
  ApolloReactCommon.MutationResult<UpdateVehiclePriceVariableMutation>;
export type UpdateVehiclePriceVariableMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateVehiclePriceVariableMutation,
    UpdateVehiclePriceVariableMutationVariables
  >;
export const DeleteVehiclePriceVariableDocument = gql`
  mutation DeleteVehiclePriceVariable($id: ID!) {
    deleteVehiclePriceVariable(id: $id) {
      deleted
      reason
    }
  }
`;
export type DeleteVehiclePriceVariableMutationFn =
  ApolloReactCommon.MutationFunction<
    DeleteVehiclePriceVariableMutation,
    DeleteVehiclePriceVariableMutationVariables
  >;

/**
 * __useDeleteVehiclePriceVariableMutation__
 *
 * To run a mutation, you first call `useDeleteVehiclePriceVariableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehiclePriceVariableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVehiclePriceVariableMutation, { data, loading, error }] = useDeleteVehiclePriceVariableMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVehiclePriceVariableMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteVehiclePriceVariableMutation,
    DeleteVehiclePriceVariableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DeleteVehiclePriceVariableMutation,
    DeleteVehiclePriceVariableMutationVariables
  >(DeleteVehiclePriceVariableDocument, options);
}
export type DeleteVehiclePriceVariableMutationHookResult = ReturnType<
  typeof useDeleteVehiclePriceVariableMutation
>;
export type DeleteVehiclePriceVariableMutationResult =
  ApolloReactCommon.MutationResult<DeleteVehiclePriceVariableMutation>;
export type DeleteVehiclePriceVariableMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteVehiclePriceVariableMutation,
    DeleteVehiclePriceVariableMutationVariables
  >;
export const UpdateServiceSubtypeDocument = gql`
  mutation UpdateServiceSubtype(
    $description: String
    $distanceInMeters: Float
    $id: ID!
    $name: String
    $rateId: String!
  ) {
    updateServiceSubtype(
      description: $description
      distanceInMeters: $distanceInMeters
      id: $id
      name: $name
      rateId: $rateId
    ) {
      id
      name
      description
      dinner
      hours
    }
  }
`;
export type UpdateServiceSubtypeMutationFn = ApolloReactCommon.MutationFunction<
  UpdateServiceSubtypeMutation,
  UpdateServiceSubtypeMutationVariables
>;

/**
 * __useUpdateServiceSubtypeMutation__
 *
 * To run a mutation, you first call `useUpdateServiceSubtypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceSubtypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceSubtypeMutation, { data, loading, error }] = useUpdateServiceSubtypeMutation({
 *   variables: {
 *      description: // value for 'description'
 *      distanceInMeters: // value for 'distanceInMeters'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      rateId: // value for 'rateId'
 *   },
 * });
 */
export function useUpdateServiceSubtypeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateServiceSubtypeMutation,
    UpdateServiceSubtypeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateServiceSubtypeMutation,
    UpdateServiceSubtypeMutationVariables
  >(UpdateServiceSubtypeDocument, options);
}
export type UpdateServiceSubtypeMutationHookResult = ReturnType<
  typeof useUpdateServiceSubtypeMutation
>;
export type UpdateServiceSubtypeMutationResult =
  ApolloReactCommon.MutationResult<UpdateServiceSubtypeMutation>;
export type UpdateServiceSubtypeMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateServiceSubtypeMutation,
    UpdateServiceSubtypeMutationVariables
  >;
export const CancelServiceDocument = gql`
  mutation CancelService($id: ID!, $reason: String) {
    cancelService(id: $id, reason: $reason) {
      success
      reason
    }
  }
`;
export type CancelServiceMutationFn = ApolloReactCommon.MutationFunction<
  CancelServiceMutation,
  CancelServiceMutationVariables
>;

/**
 * __useCancelServiceMutation__
 *
 * To run a mutation, you first call `useCancelServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelServiceMutation, { data, loading, error }] = useCancelServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelServiceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CancelServiceMutation,
    CancelServiceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CancelServiceMutation,
    CancelServiceMutationVariables
  >(CancelServiceDocument, options);
}
export type CancelServiceMutationHookResult = ReturnType<
  typeof useCancelServiceMutation
>;
export type CancelServiceMutationResult =
  ApolloReactCommon.MutationResult<CancelServiceMutation>;
export type CancelServiceMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CancelServiceMutation,
    CancelServiceMutationVariables
  >;
export const OnNewServiceSubscriptionDocument = gql`
  subscription OnNewServiceSubscription {
    onNewService {
      ...FullServiceFragment
    }
  }
  ${FullServiceFragmentFragmentDoc}
`;

/**
 * __useOnNewServiceSubscriptionSubscription__
 *
 * To run a query within a React component, call `useOnNewServiceSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNewServiceSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNewServiceSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnNewServiceSubscriptionSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    OnNewServiceSubscriptionSubscription,
    OnNewServiceSubscriptionSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSubscription<
    OnNewServiceSubscriptionSubscription,
    OnNewServiceSubscriptionSubscriptionVariables
  >(OnNewServiceSubscriptionDocument, options);
}
export type OnNewServiceSubscriptionSubscriptionHookResult = ReturnType<
  typeof useOnNewServiceSubscriptionSubscription
>;
export type OnNewServiceSubscriptionSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<OnNewServiceSubscriptionSubscription>;
export const OnUpdateServiceSubscriptionDocument = gql`
  subscription OnUpdateServiceSubscription {
    onUpdateService {
      ...FullServiceFragment
    }
  }
  ${FullServiceFragmentFragmentDoc}
`;

/**
 * __useOnUpdateServiceSubscriptionSubscription__
 *
 * To run a query within a React component, call `useOnUpdateServiceSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateServiceSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateServiceSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnUpdateServiceSubscriptionSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    OnUpdateServiceSubscriptionSubscription,
    OnUpdateServiceSubscriptionSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSubscription<
    OnUpdateServiceSubscriptionSubscription,
    OnUpdateServiceSubscriptionSubscriptionVariables
  >(OnUpdateServiceSubscriptionDocument, options);
}
export type OnUpdateServiceSubscriptionSubscriptionHookResult = ReturnType<
  typeof useOnUpdateServiceSubscriptionSubscription
>;
export type OnUpdateServiceSubscriptionSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<OnUpdateServiceSubscriptionSubscription>;
export const GetServiceDetailsDocument = gql`
  query GetServiceDetails($id: ID!) {
    service(id: $id) {
      ...FullServiceFragment
    }
  }
  ${FullServiceFragmentFragmentDoc}
`;

/**
 * __useGetServiceDetailsQuery__
 *
 * To run a query within a React component, call `useGetServiceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceDetailsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetServiceDetailsQuery,
    GetServiceDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetServiceDetailsQuery,
    GetServiceDetailsQueryVariables
  >(GetServiceDetailsDocument, options);
}
export function useGetServiceDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetServiceDetailsQuery,
    GetServiceDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetServiceDetailsQuery,
    GetServiceDetailsQueryVariables
  >(GetServiceDetailsDocument, options);
}
export type GetServiceDetailsQueryHookResult = ReturnType<
  typeof useGetServiceDetailsQuery
>;
export type GetServiceDetailsLazyQueryHookResult = ReturnType<
  typeof useGetServiceDetailsLazyQuery
>;
export type GetServiceDetailsQueryResult = ApolloReactCommon.QueryResult<
  GetServiceDetailsQuery,
  GetServiceDetailsQueryVariables
>;
export const ServiceTypesDocument = gql`
  query ServiceTypes {
    serviceTypes {
      id
      typeId
      description
      name
    }
  }
`;

/**
 * __useServiceTypesQuery__
 *
 * To run a query within a React component, call `useServiceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useServiceTypesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ServiceTypesQuery,
    ServiceTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    ServiceTypesQuery,
    ServiceTypesQueryVariables
  >(ServiceTypesDocument, options);
}
export function useServiceTypesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ServiceTypesQuery,
    ServiceTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    ServiceTypesQuery,
    ServiceTypesQueryVariables
  >(ServiceTypesDocument, options);
}
export type ServiceTypesQueryHookResult = ReturnType<
  typeof useServiceTypesQuery
>;
export type ServiceTypesLazyQueryHookResult = ReturnType<
  typeof useServiceTypesLazyQuery
>;
export type ServiceTypesQueryResult = ApolloReactCommon.QueryResult<
  ServiceTypesQuery,
  ServiceTypesQueryVariables
>;
export const CreateServiceDocument = gql`
  mutation CreateService(
    $departureTime: String!
    $departureDate: String!
    $presentationTime: String!
    $arrivalDate: String!
    $arrivalTime: String!
    $type: String!
    $clientId: String
    $mainDriverId: String
    $secondaryDriverId: String
    $vehicleId: String
    $passengers: [String!]
    $numOfPassengers: Int!
    $description: String!
    $notes: String
    $flightNumber: String
    $reference: String
    $departureAddress: String
    $departureLat: Float
    $departureLon: Float
    $arrivalAddress: String
    $arrivalLat: Float
    $arrivalLon: Float
    $groupName: String
    $groupOwner: String
  ) {
    createService(
      departureTime: $departureTime
      departureDate: $departureDate
      arrivalDate: $arrivalDate
      arrivalTime: $arrivalTime
      presentationTime: $presentationTime
      type: $type
      clientId: $clientId
      mainDriverId: $mainDriverId
      secondaryDriverId: $secondaryDriverId
      vehicleId: $vehicleId
      passengers: $passengers
      numOfPassengers: $numOfPassengers
      description: $description
      notes: $notes
      flightNumber: $flightNumber
      reference: $reference
      departureAddress: $departureAddress
      departureLat: $departureLat
      departureLon: $departureLon
      arrivalAddress: $arrivalAddress
      arrivalLat: $arrivalLat
      arrivalLon: $arrivalLon
      groupName: $groupName
      groupOwner: $groupOwner
    ) {
      ...FullServiceFragment
    }
  }
  ${FullServiceFragmentFragmentDoc}
`;
export type CreateServiceMutationFn = ApolloReactCommon.MutationFunction<
  CreateServiceMutation,
  CreateServiceMutationVariables
>;

/**
 * __useCreateServiceMutation__
 *
 * To run a mutation, you first call `useCreateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceMutation, { data, loading, error }] = useCreateServiceMutation({
 *   variables: {
 *      departureTime: // value for 'departureTime'
 *      departureDate: // value for 'departureDate'
 *      presentationTime: // value for 'presentationTime'
 *      arrivalDate: // value for 'arrivalDate'
 *      arrivalTime: // value for 'arrivalTime'
 *      type: // value for 'type'
 *      clientId: // value for 'clientId'
 *      mainDriverId: // value for 'mainDriverId'
 *      secondaryDriverId: // value for 'secondaryDriverId'
 *      vehicleId: // value for 'vehicleId'
 *      passengers: // value for 'passengers'
 *      numOfPassengers: // value for 'numOfPassengers'
 *      description: // value for 'description'
 *      notes: // value for 'notes'
 *      flightNumber: // value for 'flightNumber'
 *      reference: // value for 'reference'
 *      departureAddress: // value for 'departureAddress'
 *      departureLat: // value for 'departureLat'
 *      departureLon: // value for 'departureLon'
 *      arrivalAddress: // value for 'arrivalAddress'
 *      arrivalLat: // value for 'arrivalLat'
 *      arrivalLon: // value for 'arrivalLon'
 *      groupName: // value for 'groupName'
 *      groupOwner: // value for 'groupOwner'
 *   },
 * });
 */
export function useCreateServiceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateServiceMutation,
    CreateServiceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreateServiceMutation,
    CreateServiceMutationVariables
  >(CreateServiceDocument, options);
}
export type CreateServiceMutationHookResult = ReturnType<
  typeof useCreateServiceMutation
>;
export type CreateServiceMutationResult =
  ApolloReactCommon.MutationResult<CreateServiceMutation>;
export type CreateServiceMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateServiceMutation,
    CreateServiceMutationVariables
  >;
export const EditServiceDocument = gql`
  mutation EditService(
    $id: ID!
    $volcanoServiceId: String!
    $departureTime: String!
    $departureDate: String!
    $presentationTime: String!
    $arrivalDate: String!
    $arrivalTime: String!
    $mainDriverId: String
    $secondaryDriverId: String
    $vehicleId: String
    $passengers: [String!]
    $numOfPassengers: Int!
    $description: String!
    $notes: String
    $departureAddress: String
    $departureLat: Float
    $departureLon: Float
    $arrivalAddress: String
    $arrivalLat: Float
    $arrivalLon: Float
  ) {
    editService(
      id: $id
      volcanoServiceId: $volcanoServiceId
      departureTime: $departureTime
      departureDate: $departureDate
      arrivalDate: $arrivalDate
      arrivalTime: $arrivalTime
      presentationTime: $presentationTime
      mainDriverId: $mainDriverId
      secondaryDriverId: $secondaryDriverId
      vehicleId: $vehicleId
      passengers: $passengers
      numOfPassengers: $numOfPassengers
      description: $description
      notes: $notes
      departureAddress: $departureAddress
      departureLat: $departureLat
      departureLon: $departureLon
      arrivalAddress: $arrivalAddress
      arrivalLat: $arrivalLat
      arrivalLon: $arrivalLon
    ) {
      ...FullServiceFragment
    }
  }
  ${FullServiceFragmentFragmentDoc}
`;
export type EditServiceMutationFn = ApolloReactCommon.MutationFunction<
  EditServiceMutation,
  EditServiceMutationVariables
>;

/**
 * __useEditServiceMutation__
 *
 * To run a mutation, you first call `useEditServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editServiceMutation, { data, loading, error }] = useEditServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      volcanoServiceId: // value for 'volcanoServiceId'
 *      departureTime: // value for 'departureTime'
 *      departureDate: // value for 'departureDate'
 *      presentationTime: // value for 'presentationTime'
 *      arrivalDate: // value for 'arrivalDate'
 *      arrivalTime: // value for 'arrivalTime'
 *      mainDriverId: // value for 'mainDriverId'
 *      secondaryDriverId: // value for 'secondaryDriverId'
 *      vehicleId: // value for 'vehicleId'
 *      passengers: // value for 'passengers'
 *      numOfPassengers: // value for 'numOfPassengers'
 *      description: // value for 'description'
 *      notes: // value for 'notes'
 *      departureAddress: // value for 'departureAddress'
 *      departureLat: // value for 'departureLat'
 *      departureLon: // value for 'departureLon'
 *      arrivalAddress: // value for 'arrivalAddress'
 *      arrivalLat: // value for 'arrivalLat'
 *      arrivalLon: // value for 'arrivalLon'
 *   },
 * });
 */
export function useEditServiceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EditServiceMutation,
    EditServiceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    EditServiceMutation,
    EditServiceMutationVariables
  >(EditServiceDocument, options);
}
export type EditServiceMutationHookResult = ReturnType<
  typeof useEditServiceMutation
>;
export type EditServiceMutationResult =
  ApolloReactCommon.MutationResult<EditServiceMutation>;
export type EditServiceMutationOptions = ApolloReactCommon.BaseMutationOptions<
  EditServiceMutation,
  EditServiceMutationVariables
>;
export const ServiceDocument = gql`
  query Service($id: ID!) {
    service(id: $id) {
      ...FullServiceFragment
    }
  }
  ${FullServiceFragmentFragmentDoc}
`;

/**
 * __useServiceQuery__
 *
 * To run a query within a React component, call `useServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServiceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ServiceQuery,
    ServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<ServiceQuery, ServiceQueryVariables>(
    ServiceDocument,
    options,
  );
}
export function useServiceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ServiceQuery,
    ServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<ServiceQuery, ServiceQueryVariables>(
    ServiceDocument,
    options,
  );
}
export type ServiceQueryHookResult = ReturnType<typeof useServiceQuery>;
export type ServiceLazyQueryHookResult = ReturnType<typeof useServiceLazyQuery>;
export type ServiceQueryResult = ApolloReactCommon.QueryResult<
  ServiceQuery,
  ServiceQueryVariables
>;
export const SearchServicesDocument = gql`
  query SearchServices($text: String!) {
    searchServices(text: $text) {
      ...BasicServiceFragment
    }
  }
  ${BasicServiceFragmentFragmentDoc}
`;

/**
 * __useSearchServicesQuery__
 *
 * To run a query within a React component, call `useSearchServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchServicesQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useSearchServicesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    SearchServicesQuery,
    SearchServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    SearchServicesQuery,
    SearchServicesQueryVariables
  >(SearchServicesDocument, options);
}
export function useSearchServicesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SearchServicesQuery,
    SearchServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    SearchServicesQuery,
    SearchServicesQueryVariables
  >(SearchServicesDocument, options);
}
export type SearchServicesQueryHookResult = ReturnType<
  typeof useSearchServicesQuery
>;
export type SearchServicesLazyQueryHookResult = ReturnType<
  typeof useSearchServicesLazyQuery
>;
export type SearchServicesQueryResult = ApolloReactCommon.QueryResult<
  SearchServicesQuery,
  SearchServicesQueryVariables
>;
export const OfferServiceDocument = gql`
  mutation OfferService($serviceIds: [ID!]!) {
    createServiceOffer(serviceIds: $serviceIds) {
      id
      createdAt
      updatedAt
    }
  }
`;
export type OfferServiceMutationFn = ApolloReactCommon.MutationFunction<
  OfferServiceMutation,
  OfferServiceMutationVariables
>;

/**
 * __useOfferServiceMutation__
 *
 * To run a mutation, you first call `useOfferServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerServiceMutation, { data, loading, error }] = useOfferServiceMutation({
 *   variables: {
 *      serviceIds: // value for 'serviceIds'
 *   },
 * });
 */
export function useOfferServiceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    OfferServiceMutation,
    OfferServiceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    OfferServiceMutation,
    OfferServiceMutationVariables
  >(OfferServiceDocument, options);
}
export type OfferServiceMutationHookResult = ReturnType<
  typeof useOfferServiceMutation
>;
export type OfferServiceMutationResult =
  ApolloReactCommon.MutationResult<OfferServiceMutation>;
export type OfferServiceMutationOptions = ApolloReactCommon.BaseMutationOptions<
  OfferServiceMutation,
  OfferServiceMutationVariables
>;
export const ServiceOffersDocument = gql`
  query ServiceOffers {
    serviceOffers {
      id
      createdAt
      updatedAt
      service {
        id
        volcanoServiceId
        departure {
          address
          date
          time
        }
        arrival {
          address
          date
          time
        }
        description
        client {
          name
        }
        numOfPassengers
        reference
        requestedVehicleDescription
        vehicle {
          id
          type
          origin
          typeID
          typeDescription
          brand
          model
        }
      }
      bids {
        id
        createdAt
        updatedAt
        status
        drivingCompany {
          id
          volcanoId
          name
        }
      }
    }
  }
`;

/**
 * __useServiceOffersQuery__
 *
 * To run a query within a React component, call `useServiceOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceOffersQuery({
 *   variables: {
 *   },
 * });
 */
export function useServiceOffersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ServiceOffersQuery,
    ServiceOffersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    ServiceOffersQuery,
    ServiceOffersQueryVariables
  >(ServiceOffersDocument, options);
}
export function useServiceOffersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ServiceOffersQuery,
    ServiceOffersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    ServiceOffersQuery,
    ServiceOffersQueryVariables
  >(ServiceOffersDocument, options);
}
export type ServiceOffersQueryHookResult = ReturnType<
  typeof useServiceOffersQuery
>;
export type ServiceOffersLazyQueryHookResult = ReturnType<
  typeof useServiceOffersLazyQuery
>;
export type ServiceOffersQueryResult = ApolloReactCommon.QueryResult<
  ServiceOffersQuery,
  ServiceOffersQueryVariables
>;
export const DeleteServiceOfferDocument = gql`
  mutation DeleteServiceOffer($id: ID!) {
    ServiceOffer(id: $id) {
      delete {
        deleted
        reason
      }
    }
  }
`;
export type DeleteServiceOfferMutationFn = ApolloReactCommon.MutationFunction<
  DeleteServiceOfferMutation,
  DeleteServiceOfferMutationVariables
>;

/**
 * __useDeleteServiceOfferMutation__
 *
 * To run a mutation, you first call `useDeleteServiceOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceOfferMutation, { data, loading, error }] = useDeleteServiceOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteServiceOfferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteServiceOfferMutation,
    DeleteServiceOfferMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DeleteServiceOfferMutation,
    DeleteServiceOfferMutationVariables
  >(DeleteServiceOfferDocument, options);
}
export type DeleteServiceOfferMutationHookResult = ReturnType<
  typeof useDeleteServiceOfferMutation
>;
export type DeleteServiceOfferMutationResult =
  ApolloReactCommon.MutationResult<DeleteServiceOfferMutation>;
export type DeleteServiceOfferMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteServiceOfferMutation,
    DeleteServiceOfferMutationVariables
  >;
export const DeleteServiceOffersDocument = gql`
  mutation DeleteServiceOffers($ids: [ID!]!) {
    deleteServiceOffer(ids: $ids)
  }
`;
export type DeleteServiceOffersMutationFn = ApolloReactCommon.MutationFunction<
  DeleteServiceOffersMutation,
  DeleteServiceOffersMutationVariables
>;

/**
 * __useDeleteServiceOffersMutation__
 *
 * To run a mutation, you first call `useDeleteServiceOffersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceOffersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceOffersMutation, { data, loading, error }] = useDeleteServiceOffersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteServiceOffersMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteServiceOffersMutation,
    DeleteServiceOffersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DeleteServiceOffersMutation,
    DeleteServiceOffersMutationVariables
  >(DeleteServiceOffersDocument, options);
}
export type DeleteServiceOffersMutationHookResult = ReturnType<
  typeof useDeleteServiceOffersMutation
>;
export type DeleteServiceOffersMutationResult =
  ApolloReactCommon.MutationResult<DeleteServiceOffersMutation>;
export type DeleteServiceOffersMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteServiceOffersMutation,
    DeleteServiceOffersMutationVariables
  >;
export const AcceptServiceOfferBidDocument = gql`
  mutation AcceptServiceOfferBid($serviceOfferId: ID!, $bidId: ID!) {
    ServiceOffer(id: $serviceOfferId) {
      acceptBid(id: $bidId) {
        id
        updatedAt
        createdAt
        bids {
          updatedAt
          id
          status
        }
      }
    }
  }
`;
export type AcceptServiceOfferBidMutationFn =
  ApolloReactCommon.MutationFunction<
    AcceptServiceOfferBidMutation,
    AcceptServiceOfferBidMutationVariables
  >;

/**
 * __useAcceptServiceOfferBidMutation__
 *
 * To run a mutation, you first call `useAcceptServiceOfferBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptServiceOfferBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptServiceOfferBidMutation, { data, loading, error }] = useAcceptServiceOfferBidMutation({
 *   variables: {
 *      serviceOfferId: // value for 'serviceOfferId'
 *      bidId: // value for 'bidId'
 *   },
 * });
 */
export function useAcceptServiceOfferBidMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AcceptServiceOfferBidMutation,
    AcceptServiceOfferBidMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AcceptServiceOfferBidMutation,
    AcceptServiceOfferBidMutationVariables
  >(AcceptServiceOfferBidDocument, options);
}
export type AcceptServiceOfferBidMutationHookResult = ReturnType<
  typeof useAcceptServiceOfferBidMutation
>;
export type AcceptServiceOfferBidMutationResult =
  ApolloReactCommon.MutationResult<AcceptServiceOfferBidMutation>;
export type AcceptServiceOfferBidMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AcceptServiceOfferBidMutation,
    AcceptServiceOfferBidMutationVariables
  >;
export const RejectServiceOfferBidDocument = gql`
  mutation RejectServiceOfferBid($serviceOfferId: ID!, $bidId: ID!) {
    ServiceOffer(id: $serviceOfferId) {
      rejectBid(id: $bidId) {
        id
        updatedAt
        createdAt
        bids {
          updatedAt
          id
          status
        }
      }
    }
  }
`;
export type RejectServiceOfferBidMutationFn =
  ApolloReactCommon.MutationFunction<
    RejectServiceOfferBidMutation,
    RejectServiceOfferBidMutationVariables
  >;

/**
 * __useRejectServiceOfferBidMutation__
 *
 * To run a mutation, you first call `useRejectServiceOfferBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectServiceOfferBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectServiceOfferBidMutation, { data, loading, error }] = useRejectServiceOfferBidMutation({
 *   variables: {
 *      serviceOfferId: // value for 'serviceOfferId'
 *      bidId: // value for 'bidId'
 *   },
 * });
 */
export function useRejectServiceOfferBidMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RejectServiceOfferBidMutation,
    RejectServiceOfferBidMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    RejectServiceOfferBidMutation,
    RejectServiceOfferBidMutationVariables
  >(RejectServiceOfferBidDocument, options);
}
export type RejectServiceOfferBidMutationHookResult = ReturnType<
  typeof useRejectServiceOfferBidMutation
>;
export type RejectServiceOfferBidMutationResult =
  ApolloReactCommon.MutationResult<RejectServiceOfferBidMutation>;
export type RejectServiceOfferBidMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RejectServiceOfferBidMutation,
    RejectServiceOfferBidMutationVariables
  >;
export const IgnoreServiceOfferBidDocument = gql`
  mutation IgnoreServiceOfferBid($serviceOfferId: ID!, $bidId: ID!) {
    ServiceOffer(id: $serviceOfferId) {
      ignoreBid(id: $bidId) {
        id
        updatedAt
        createdAt
        bids {
          updatedAt
          id
          status
        }
      }
    }
  }
`;
export type IgnoreServiceOfferBidMutationFn =
  ApolloReactCommon.MutationFunction<
    IgnoreServiceOfferBidMutation,
    IgnoreServiceOfferBidMutationVariables
  >;

/**
 * __useIgnoreServiceOfferBidMutation__
 *
 * To run a mutation, you first call `useIgnoreServiceOfferBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreServiceOfferBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreServiceOfferBidMutation, { data, loading, error }] = useIgnoreServiceOfferBidMutation({
 *   variables: {
 *      serviceOfferId: // value for 'serviceOfferId'
 *      bidId: // value for 'bidId'
 *   },
 * });
 */
export function useIgnoreServiceOfferBidMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    IgnoreServiceOfferBidMutation,
    IgnoreServiceOfferBidMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    IgnoreServiceOfferBidMutation,
    IgnoreServiceOfferBidMutationVariables
  >(IgnoreServiceOfferBidDocument, options);
}
export type IgnoreServiceOfferBidMutationHookResult = ReturnType<
  typeof useIgnoreServiceOfferBidMutation
>;
export type IgnoreServiceOfferBidMutationResult =
  ApolloReactCommon.MutationResult<IgnoreServiceOfferBidMutation>;
export type IgnoreServiceOfferBidMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    IgnoreServiceOfferBidMutation,
    IgnoreServiceOfferBidMutationVariables
  >;
export const BidServiceOfferDocument = gql`
  mutation BidServiceOffer($id: ID!) {
    ServiceOffer(id: $id) {
      bid {
        id
        bids {
          id
          drivingCompany {
            id
          }
          createdAt
          updatedAt
        }
      }
    }
  }
`;
export type BidServiceOfferMutationFn = ApolloReactCommon.MutationFunction<
  BidServiceOfferMutation,
  BidServiceOfferMutationVariables
>;

/**
 * __useBidServiceOfferMutation__
 *
 * To run a mutation, you first call `useBidServiceOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBidServiceOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bidServiceOfferMutation, { data, loading, error }] = useBidServiceOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBidServiceOfferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    BidServiceOfferMutation,
    BidServiceOfferMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    BidServiceOfferMutation,
    BidServiceOfferMutationVariables
  >(BidServiceOfferDocument, options);
}
export type BidServiceOfferMutationHookResult = ReturnType<
  typeof useBidServiceOfferMutation
>;
export type BidServiceOfferMutationResult =
  ApolloReactCommon.MutationResult<BidServiceOfferMutation>;
export type BidServiceOfferMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    BidServiceOfferMutation,
    BidServiceOfferMutationVariables
  >;
export const UnbidServiceOfferDocument = gql`
  mutation UnbidServiceOffer($id: ID!) {
    ServiceOffer(id: $id) {
      unbid {
        id
        bids {
          id
          drivingCompany {
            id
          }
          createdAt
          updatedAt
        }
      }
    }
  }
`;
export type UnbidServiceOfferMutationFn = ApolloReactCommon.MutationFunction<
  UnbidServiceOfferMutation,
  UnbidServiceOfferMutationVariables
>;

/**
 * __useUnbidServiceOfferMutation__
 *
 * To run a mutation, you first call `useUnbidServiceOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnbidServiceOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unbidServiceOfferMutation, { data, loading, error }] = useUnbidServiceOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnbidServiceOfferMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UnbidServiceOfferMutation,
    UnbidServiceOfferMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UnbidServiceOfferMutation,
    UnbidServiceOfferMutationVariables
  >(UnbidServiceOfferDocument, options);
}
export type UnbidServiceOfferMutationHookResult = ReturnType<
  typeof useUnbidServiceOfferMutation
>;
export type UnbidServiceOfferMutationResult =
  ApolloReactCommon.MutationResult<UnbidServiceOfferMutation>;
export type UnbidServiceOfferMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UnbidServiceOfferMutation,
    UnbidServiceOfferMutationVariables
  >;
export const ServicesDocument = gql`
  query Services(
    $departureDateMin: String
    $departureDateMax: String
    $includeOffers: Boolean!
    $includeDrivingCompany: Boolean!
  ) {
    services(
      departureDateMin: $departureDateMin
      departureDateMax: $departureDateMax
    ) {
      id
      volcanoServiceId
      budgetReadableId
      description
      requestedVehicleDescription
      status
      reference
      client {
        id
        email
        name
        volcanoClientId
      }
      itineraryDescription
      numOfPassengers
      departure {
        date
        time
        address
      }
      drivingCompany @include(if: $includeDrivingCompany) {
        id
        name
        email
        phone
        volcanoId
      }
      offers @include(if: $includeOffers) {
        id
        createdAt
        updatedAt
      }
      arrival {
        date
        time
        address
      }
    }
  }
`;

/**
 * __useServicesQuery__
 *
 * To run a query within a React component, call `useServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesQuery({
 *   variables: {
 *      departureDateMin: // value for 'departureDateMin'
 *      departureDateMax: // value for 'departureDateMax'
 *      includeOffers: // value for 'includeOffers'
 *      includeDrivingCompany: // value for 'includeDrivingCompany'
 *   },
 * });
 */
export function useServicesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ServicesQuery,
    ServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<ServicesQuery, ServicesQueryVariables>(
    ServicesDocument,
    options,
  );
}
export function useServicesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ServicesQuery,
    ServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<ServicesQuery, ServicesQueryVariables>(
    ServicesDocument,
    options,
  );
}
export type ServicesQueryHookResult = ReturnType<typeof useServicesQuery>;
export type ServicesLazyQueryHookResult = ReturnType<
  typeof useServicesLazyQuery
>;
export type ServicesQueryResult = ApolloReactCommon.QueryResult<
  ServicesQuery,
  ServicesQueryVariables
>;
export const ListTemplatesDocument = gql`
  query ListTemplates {
    templates {
      id
      name
      heading
      body
      createdAt
      updatedAt
      numClients
    }
  }
`;

/**
 * __useListTemplatesQuery__
 *
 * To run a query within a React component, call `useListTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListTemplatesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ListTemplatesQuery,
    ListTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    ListTemplatesQuery,
    ListTemplatesQueryVariables
  >(ListTemplatesDocument, options);
}
export function useListTemplatesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ListTemplatesQuery,
    ListTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    ListTemplatesQuery,
    ListTemplatesQueryVariables
  >(ListTemplatesDocument, options);
}
export type ListTemplatesQueryHookResult = ReturnType<
  typeof useListTemplatesQuery
>;
export type ListTemplatesLazyQueryHookResult = ReturnType<
  typeof useListTemplatesLazyQuery
>;
export type ListTemplatesQueryResult = ApolloReactCommon.QueryResult<
  ListTemplatesQuery,
  ListTemplatesQueryVariables
>;
export const CreateTemplateDocument = gql`
  mutation CreateTemplate(
    $name: String!
    $heading: JSONObject!
    $body: JSONObject!
  ) {
    createTemplate(name: $name, heading: $heading, body: $body) {
      id
      name
      heading
      body
      createdAt
      updatedAt
    }
  }
`;
export type CreateTemplateMutationFn = ApolloReactCommon.MutationFunction<
  CreateTemplateMutation,
  CreateTemplateMutationVariables
>;

/**
 * __useCreateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateMutation, { data, loading, error }] = useCreateTemplateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      heading: // value for 'heading'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateTemplateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateTemplateMutation,
    CreateTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreateTemplateMutation,
    CreateTemplateMutationVariables
  >(CreateTemplateDocument, options);
}
export type CreateTemplateMutationHookResult = ReturnType<
  typeof useCreateTemplateMutation
>;
export type CreateTemplateMutationResult =
  ApolloReactCommon.MutationResult<CreateTemplateMutation>;
export type CreateTemplateMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateTemplateMutation,
    CreateTemplateMutationVariables
  >;
export const DeleteTemplateDocument = gql`
  mutation DeleteTemplate($id: Int!) {
    deleteTemplate(id: $id)
  }
`;
export type DeleteTemplateMutationFn = ApolloReactCommon.MutationFunction<
  DeleteTemplateMutation,
  DeleteTemplateMutationVariables
>;

/**
 * __useDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateMutation, { data, loading, error }] = useDeleteTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteTemplateMutation,
    DeleteTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DeleteTemplateMutation,
    DeleteTemplateMutationVariables
  >(DeleteTemplateDocument, options);
}
export type DeleteTemplateMutationHookResult = ReturnType<
  typeof useDeleteTemplateMutation
>;
export type DeleteTemplateMutationResult =
  ApolloReactCommon.MutationResult<DeleteTemplateMutation>;
export type DeleteTemplateMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteTemplateMutation,
    DeleteTemplateMutationVariables
  >;
export const UpdateTemplateDocument = gql`
  mutation UpdateTemplate(
    $id: Int!
    $name: String
    $heading: JSONObject
    $body: JSONObject
  ) {
    updateTemplate(id: $id, name: $name, heading: $heading, body: $body) {
      id
      name
      heading
      body
      createdAt
      updatedAt
    }
  }
`;
export type UpdateTemplateMutationFn = ApolloReactCommon.MutationFunction<
  UpdateTemplateMutation,
  UpdateTemplateMutationVariables
>;

/**
 * __useUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateMutation, { data, loading, error }] = useUpdateTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      heading: // value for 'heading'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateTemplateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateTemplateMutation,
    UpdateTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateTemplateMutation,
    UpdateTemplateMutationVariables
  >(UpdateTemplateDocument, options);
}
export type UpdateTemplateMutationHookResult = ReturnType<
  typeof useUpdateTemplateMutation
>;
export type UpdateTemplateMutationResult =
  ApolloReactCommon.MutationResult<UpdateTemplateMutation>;
export type UpdateTemplateMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateTemplateMutation,
    UpdateTemplateMutationVariables
  >;
export const DuplicateTemplateDocument = gql`
  mutation DuplicateTemplate($id: Int!) {
    duplicateTemplate(id: $id) {
      id
      name
      heading
      body
      createdAt
      updatedAt
    }
  }
`;
export type DuplicateTemplateMutationFn = ApolloReactCommon.MutationFunction<
  DuplicateTemplateMutation,
  DuplicateTemplateMutationVariables
>;

/**
 * __useDuplicateTemplateMutation__
 *
 * To run a mutation, you first call `useDuplicateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateTemplateMutation, { data, loading, error }] = useDuplicateTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateTemplateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DuplicateTemplateMutation,
    DuplicateTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DuplicateTemplateMutation,
    DuplicateTemplateMutationVariables
  >(DuplicateTemplateDocument, options);
}
export type DuplicateTemplateMutationHookResult = ReturnType<
  typeof useDuplicateTemplateMutation
>;
export type DuplicateTemplateMutationResult =
  ApolloReactCommon.MutationResult<DuplicateTemplateMutation>;
export type DuplicateTemplateMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DuplicateTemplateMutation,
    DuplicateTemplateMutationVariables
  >;
export const GetTemplateClientsDocument = gql`
  query GetTemplateClients($id: Int!) {
    template(id: $id) {
      id
      name
      heading
      body
      createdAt
      updatedAt
      numClients
      clients {
        id
        volcanoClientId
        name
      }
    }
  }
`;

/**
 * __useGetTemplateClientsQuery__
 *
 * To run a query within a React component, call `useGetTemplateClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateClientsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTemplateClientsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetTemplateClientsQuery,
    GetTemplateClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetTemplateClientsQuery,
    GetTemplateClientsQueryVariables
  >(GetTemplateClientsDocument, options);
}
export function useGetTemplateClientsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetTemplateClientsQuery,
    GetTemplateClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetTemplateClientsQuery,
    GetTemplateClientsQueryVariables
  >(GetTemplateClientsDocument, options);
}
export type GetTemplateClientsQueryHookResult = ReturnType<
  typeof useGetTemplateClientsQuery
>;
export type GetTemplateClientsLazyQueryHookResult = ReturnType<
  typeof useGetTemplateClientsLazyQuery
>;
export type GetTemplateClientsQueryResult = ApolloReactCommon.QueryResult<
  GetTemplateClientsQuery,
  GetTemplateClientsQueryVariables
>;
export const AssignTemplateToClientsDocument = gql`
  mutation AssignTemplateToClients($clients: [String!]!, $templateId: Int!) {
    assignTemplateToClients(clients: $clients, templateId: $templateId) {
      id
      name
      heading
      body
      createdAt
      updatedAt
      numClients
      clients {
        id
        volcanoClientId
        name
      }
    }
  }
`;
export type AssignTemplateToClientsMutationFn =
  ApolloReactCommon.MutationFunction<
    AssignTemplateToClientsMutation,
    AssignTemplateToClientsMutationVariables
  >;

/**
 * __useAssignTemplateToClientsMutation__
 *
 * To run a mutation, you first call `useAssignTemplateToClientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTemplateToClientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTemplateToClientsMutation, { data, loading, error }] = useAssignTemplateToClientsMutation({
 *   variables: {
 *      clients: // value for 'clients'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useAssignTemplateToClientsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AssignTemplateToClientsMutation,
    AssignTemplateToClientsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AssignTemplateToClientsMutation,
    AssignTemplateToClientsMutationVariables
  >(AssignTemplateToClientsDocument, options);
}
export type AssignTemplateToClientsMutationHookResult = ReturnType<
  typeof useAssignTemplateToClientsMutation
>;
export type AssignTemplateToClientsMutationResult =
  ApolloReactCommon.MutationResult<AssignTemplateToClientsMutation>;
export type AssignTemplateToClientsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AssignTemplateToClientsMutation,
    AssignTemplateToClientsMutationVariables
  >;
export const DisassociateTemplateFromClientsDocument = gql`
  mutation DisassociateTemplateFromClients(
    $clients: [String!]!
    $templateId: Int!
  ) {
    disassociateTemplateFromClients(
      clients: $clients
      templateId: $templateId
    ) {
      id
      name
      heading
      body
      createdAt
      updatedAt
      numClients
      clients {
        id
        volcanoClientId
        name
      }
    }
  }
`;
export type DisassociateTemplateFromClientsMutationFn =
  ApolloReactCommon.MutationFunction<
    DisassociateTemplateFromClientsMutation,
    DisassociateTemplateFromClientsMutationVariables
  >;

/**
 * __useDisassociateTemplateFromClientsMutation__
 *
 * To run a mutation, you first call `useDisassociateTemplateFromClientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisassociateTemplateFromClientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disassociateTemplateFromClientsMutation, { data, loading, error }] = useDisassociateTemplateFromClientsMutation({
 *   variables: {
 *      clients: // value for 'clients'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useDisassociateTemplateFromClientsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DisassociateTemplateFromClientsMutation,
    DisassociateTemplateFromClientsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DisassociateTemplateFromClientsMutation,
    DisassociateTemplateFromClientsMutationVariables
  >(DisassociateTemplateFromClientsDocument, options);
}
export type DisassociateTemplateFromClientsMutationHookResult = ReturnType<
  typeof useDisassociateTemplateFromClientsMutation
>;
export type DisassociateTemplateFromClientsMutationResult =
  ApolloReactCommon.MutationResult<DisassociateTemplateFromClientsMutation>;
export type DisassociateTemplateFromClientsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DisassociateTemplateFromClientsMutation,
    DisassociateTemplateFromClientsMutationVariables
  >;
export const Get_Matching_Prisma_User_Or_DriverDocument = gql`
  query GET_MATCHING_PRISMA_USER_OR_DRIVER {
    userOrDriver {
      __typename
      ... on User {
        ...UserBasicFragment
      }
      ... on Driver {
        ...DriverBasicFragment
      }
    }
  }
  ${UserBasicFragmentFragmentDoc}
  ${DriverBasicFragmentFragmentDoc}
`;

/**
 * __useGet_Matching_Prisma_User_Or_DriverQuery__
 *
 * To run a query within a React component, call `useGet_Matching_Prisma_User_Or_DriverQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Matching_Prisma_User_Or_DriverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Matching_Prisma_User_Or_DriverQuery({
 *   variables: {
 *   },
 * });
 */
export function useGet_Matching_Prisma_User_Or_DriverQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    Get_Matching_Prisma_User_Or_DriverQuery,
    Get_Matching_Prisma_User_Or_DriverQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    Get_Matching_Prisma_User_Or_DriverQuery,
    Get_Matching_Prisma_User_Or_DriverQueryVariables
  >(Get_Matching_Prisma_User_Or_DriverDocument, options);
}
export function useGet_Matching_Prisma_User_Or_DriverLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    Get_Matching_Prisma_User_Or_DriverQuery,
    Get_Matching_Prisma_User_Or_DriverQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    Get_Matching_Prisma_User_Or_DriverQuery,
    Get_Matching_Prisma_User_Or_DriverQueryVariables
  >(Get_Matching_Prisma_User_Or_DriverDocument, options);
}
export type Get_Matching_Prisma_User_Or_DriverQueryHookResult = ReturnType<
  typeof useGet_Matching_Prisma_User_Or_DriverQuery
>;
export type Get_Matching_Prisma_User_Or_DriverLazyQueryHookResult = ReturnType<
  typeof useGet_Matching_Prisma_User_Or_DriverLazyQuery
>;
export type Get_Matching_Prisma_User_Or_DriverQueryResult =
  ApolloReactCommon.QueryResult<
    Get_Matching_Prisma_User_Or_DriverQuery,
    Get_Matching_Prisma_User_Or_DriverQueryVariables
  >;
export const GetMeDocument = gql`
  query GetMe {
    user {
      ...UserBasicFragment
    }
  }
  ${UserBasicFragmentFragmentDoc}
`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetMeQuery,
    GetMeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<GetMeQuery, GetMeQueryVariables>(
    GetMeDocument,
    options,
  );
}
export function useGetMeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMeQuery,
    GetMeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<GetMeQuery, GetMeQueryVariables>(
    GetMeDocument,
    options,
  );
}
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = ApolloReactCommon.QueryResult<
  GetMeQuery,
  GetMeQueryVariables
>;
export const GetUserByEmailDocument = gql`
  query GetUserByEmail($email: String!) {
    userByEmail(email: $email) {
      ...UserBasicFragment
    }
  }
  ${UserBasicFragmentFragmentDoc}
`;

/**
 * __useGetUserByEmailQuery__
 *
 * To run a query within a React component, call `useGetUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserByEmailQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetUserByEmailQuery,
    GetUserByEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetUserByEmailQuery,
    GetUserByEmailQueryVariables
  >(GetUserByEmailDocument, options);
}
export function useGetUserByEmailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetUserByEmailQuery,
    GetUserByEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetUserByEmailQuery,
    GetUserByEmailQueryVariables
  >(GetUserByEmailDocument, options);
}
export type GetUserByEmailQueryHookResult = ReturnType<
  typeof useGetUserByEmailQuery
>;
export type GetUserByEmailLazyQueryHookResult = ReturnType<
  typeof useGetUserByEmailLazyQuery
>;
export type GetUserByEmailQueryResult = ApolloReactCommon.QueryResult<
  GetUserByEmailQuery,
  GetUserByEmailQueryVariables
>;
export const OnUpdateMeDocument = gql`
  subscription onUpdateMe {
    onUpdateMe {
      ...UserBasicFragment
    }
  }
  ${UserBasicFragmentFragmentDoc}
`;

/**
 * __useOnUpdateMeSubscription__
 *
 * To run a query within a React component, call `useOnUpdateMeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateMeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateMeSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnUpdateMeSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    OnUpdateMeSubscription,
    OnUpdateMeSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSubscription<
    OnUpdateMeSubscription,
    OnUpdateMeSubscriptionVariables
  >(OnUpdateMeDocument, options);
}
export type OnUpdateMeSubscriptionHookResult = ReturnType<
  typeof useOnUpdateMeSubscription
>;
export type OnUpdateMeSubscriptionResult =
  ApolloReactCommon.SubscriptionResult<OnUpdateMeSubscription>;
export const DeleteVehicleBrandDocument = gql`
  mutation DeleteVehicleBrand($id: ID!) {
    deleteVehicleBrand(id: $id) {
      deleted
      reason
    }
  }
`;
export type DeleteVehicleBrandMutationFn = ApolloReactCommon.MutationFunction<
  DeleteVehicleBrandMutation,
  DeleteVehicleBrandMutationVariables
>;

/**
 * __useDeleteVehicleBrandMutation__
 *
 * To run a mutation, you first call `useDeleteVehicleBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehicleBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVehicleBrandMutation, { data, loading, error }] = useDeleteVehicleBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVehicleBrandMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteVehicleBrandMutation,
    DeleteVehicleBrandMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DeleteVehicleBrandMutation,
    DeleteVehicleBrandMutationVariables
  >(DeleteVehicleBrandDocument, options);
}
export type DeleteVehicleBrandMutationHookResult = ReturnType<
  typeof useDeleteVehicleBrandMutation
>;
export type DeleteVehicleBrandMutationResult =
  ApolloReactCommon.MutationResult<DeleteVehicleBrandMutation>;
export type DeleteVehicleBrandMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteVehicleBrandMutation,
    DeleteVehicleBrandMutationVariables
  >;
export const UpdateVehicleBrandDocument = gql`
  mutation UpdateVehicleBrand($id: ID!, $name: String) {
    updateVehicleBrand(id: $id, name: $name) {
      id
      brand
    }
  }
`;
export type UpdateVehicleBrandMutationFn = ApolloReactCommon.MutationFunction<
  UpdateVehicleBrandMutation,
  UpdateVehicleBrandMutationVariables
>;

/**
 * __useUpdateVehicleBrandMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleBrandMutation, { data, loading, error }] = useUpdateVehicleBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateVehicleBrandMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateVehicleBrandMutation,
    UpdateVehicleBrandMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateVehicleBrandMutation,
    UpdateVehicleBrandMutationVariables
  >(UpdateVehicleBrandDocument, options);
}
export type UpdateVehicleBrandMutationHookResult = ReturnType<
  typeof useUpdateVehicleBrandMutation
>;
export type UpdateVehicleBrandMutationResult =
  ApolloReactCommon.MutationResult<UpdateVehicleBrandMutation>;
export type UpdateVehicleBrandMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateVehicleBrandMutation,
    UpdateVehicleBrandMutationVariables
  >;
export const DeleteVehicleModelDocument = gql`
  mutation DeleteVehicleModel($id: ID!) {
    deleteVehicleModel(id: $id) {
      deleted
      reason
    }
  }
`;
export type DeleteVehicleModelMutationFn = ApolloReactCommon.MutationFunction<
  DeleteVehicleModelMutation,
  DeleteVehicleModelMutationVariables
>;

/**
 * __useDeleteVehicleModelMutation__
 *
 * To run a mutation, you first call `useDeleteVehicleModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehicleModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVehicleModelMutation, { data, loading, error }] = useDeleteVehicleModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVehicleModelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteVehicleModelMutation,
    DeleteVehicleModelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DeleteVehicleModelMutation,
    DeleteVehicleModelMutationVariables
  >(DeleteVehicleModelDocument, options);
}
export type DeleteVehicleModelMutationHookResult = ReturnType<
  typeof useDeleteVehicleModelMutation
>;
export type DeleteVehicleModelMutationResult =
  ApolloReactCommon.MutationResult<DeleteVehicleModelMutation>;
export type DeleteVehicleModelMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteVehicleModelMutation,
    DeleteVehicleModelMutationVariables
  >;
export const GetVehicleBrandModelsDocument = gql`
  query GetVehicleBrandModels {
    vehicleBrandModels {
      id
      brand
      models {
        id
        name
      }
    }
  }
`;

/**
 * __useGetVehicleBrandModelsQuery__
 *
 * To run a query within a React component, call `useGetVehicleBrandModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleBrandModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleBrandModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVehicleBrandModelsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetVehicleBrandModelsQuery,
    GetVehicleBrandModelsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetVehicleBrandModelsQuery,
    GetVehicleBrandModelsQueryVariables
  >(GetVehicleBrandModelsDocument, options);
}
export function useGetVehicleBrandModelsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetVehicleBrandModelsQuery,
    GetVehicleBrandModelsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetVehicleBrandModelsQuery,
    GetVehicleBrandModelsQueryVariables
  >(GetVehicleBrandModelsDocument, options);
}
export type GetVehicleBrandModelsQueryHookResult = ReturnType<
  typeof useGetVehicleBrandModelsQuery
>;
export type GetVehicleBrandModelsLazyQueryHookResult = ReturnType<
  typeof useGetVehicleBrandModelsLazyQuery
>;
export type GetVehicleBrandModelsQueryResult = ApolloReactCommon.QueryResult<
  GetVehicleBrandModelsQuery,
  GetVehicleBrandModelsQueryVariables
>;
export const GetVehicleBrandDocument = gql`
  query GetVehicleBrand($id: ID!) {
    vehicleBrand(id: $id) {
      id
      brand
      models {
        id
        name
      }
    }
  }
`;

/**
 * __useGetVehicleBrandQuery__
 *
 * To run a query within a React component, call `useGetVehicleBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleBrandQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVehicleBrandQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetVehicleBrandQuery,
    GetVehicleBrandQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetVehicleBrandQuery,
    GetVehicleBrandQueryVariables
  >(GetVehicleBrandDocument, options);
}
export function useGetVehicleBrandLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetVehicleBrandQuery,
    GetVehicleBrandQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetVehicleBrandQuery,
    GetVehicleBrandQueryVariables
  >(GetVehicleBrandDocument, options);
}
export type GetVehicleBrandQueryHookResult = ReturnType<
  typeof useGetVehicleBrandQuery
>;
export type GetVehicleBrandLazyQueryHookResult = ReturnType<
  typeof useGetVehicleBrandLazyQuery
>;
export type GetVehicleBrandQueryResult = ApolloReactCommon.QueryResult<
  GetVehicleBrandQuery,
  GetVehicleBrandQueryVariables
>;
export const GetVehicleModelDocument = gql`
  query GetVehicleModel($id: ID!) {
    vehicleModel(id: $id) {
      id
      name
    }
  }
`;

/**
 * __useGetVehicleModelQuery__
 *
 * To run a query within a React component, call `useGetVehicleModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleModelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVehicleModelQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetVehicleModelQuery,
    GetVehicleModelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetVehicleModelQuery,
    GetVehicleModelQueryVariables
  >(GetVehicleModelDocument, options);
}
export function useGetVehicleModelLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetVehicleModelQuery,
    GetVehicleModelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetVehicleModelQuery,
    GetVehicleModelQueryVariables
  >(GetVehicleModelDocument, options);
}
export type GetVehicleModelQueryHookResult = ReturnType<
  typeof useGetVehicleModelQuery
>;
export type GetVehicleModelLazyQueryHookResult = ReturnType<
  typeof useGetVehicleModelLazyQuery
>;
export type GetVehicleModelQueryResult = ApolloReactCommon.QueryResult<
  GetVehicleModelQuery,
  GetVehicleModelQueryVariables
>;
export const UpdateVehicleModelDocument = gql`
  mutation UpdateVehicleModel($id: ID!, $name: String!) {
    updateVehicleModel(id: $id, name: $name) {
      id
      name
    }
  }
`;
export type UpdateVehicleModelMutationFn = ApolloReactCommon.MutationFunction<
  UpdateVehicleModelMutation,
  UpdateVehicleModelMutationVariables
>;

/**
 * __useUpdateVehicleModelMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleModelMutation, { data, loading, error }] = useUpdateVehicleModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateVehicleModelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateVehicleModelMutation,
    UpdateVehicleModelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UpdateVehicleModelMutation,
    UpdateVehicleModelMutationVariables
  >(UpdateVehicleModelDocument, options);
}
export type UpdateVehicleModelMutationHookResult = ReturnType<
  typeof useUpdateVehicleModelMutation
>;
export type UpdateVehicleModelMutationResult =
  ApolloReactCommon.MutationResult<UpdateVehicleModelMutation>;
export type UpdateVehicleModelMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateVehicleModelMutation,
    UpdateVehicleModelMutationVariables
  >;
export const GetAllVehiclesLocationDocument = gql`
  query GetAllVehiclesLocation {
    vehicles {
      id
      brand
      licensePlate
      model
      volcanoVehicleId
      location {
        latitude
        longitude
      }
    }
  }
`;

/**
 * __useGetAllVehiclesLocationQuery__
 *
 * To run a query within a React component, call `useGetAllVehiclesLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVehiclesLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVehiclesLocationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllVehiclesLocationQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAllVehiclesLocationQuery,
    GetAllVehiclesLocationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetAllVehiclesLocationQuery,
    GetAllVehiclesLocationQueryVariables
  >(GetAllVehiclesLocationDocument, options);
}
export function useGetAllVehiclesLocationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllVehiclesLocationQuery,
    GetAllVehiclesLocationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetAllVehiclesLocationQuery,
    GetAllVehiclesLocationQueryVariables
  >(GetAllVehiclesLocationDocument, options);
}
export type GetAllVehiclesLocationQueryHookResult = ReturnType<
  typeof useGetAllVehiclesLocationQuery
>;
export type GetAllVehiclesLocationLazyQueryHookResult = ReturnType<
  typeof useGetAllVehiclesLocationLazyQuery
>;
export type GetAllVehiclesLocationQueryResult = ApolloReactCommon.QueryResult<
  GetAllVehiclesLocationQuery,
  GetAllVehiclesLocationQueryVariables
>;
export const GetAllVehiclesDocument = gql`
  query GetAllVehicles {
    vehicles {
      id
      volcanoVehicleId
      origin
      type
      typeID
      typeDescription
      status
      licensePlate
      brand
      model
    }
  }
`;

/**
 * __useGetAllVehiclesQuery__
 *
 * To run a query within a React component, call `useGetAllVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVehiclesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllVehiclesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAllVehiclesQuery,
    GetAllVehiclesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetAllVehiclesQuery,
    GetAllVehiclesQueryVariables
  >(GetAllVehiclesDocument, options);
}
export function useGetAllVehiclesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllVehiclesQuery,
    GetAllVehiclesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetAllVehiclesQuery,
    GetAllVehiclesQueryVariables
  >(GetAllVehiclesDocument, options);
}
export type GetAllVehiclesQueryHookResult = ReturnType<
  typeof useGetAllVehiclesQuery
>;
export type GetAllVehiclesLazyQueryHookResult = ReturnType<
  typeof useGetAllVehiclesLazyQuery
>;
export type GetAllVehiclesQueryResult = ApolloReactCommon.QueryResult<
  GetAllVehiclesQuery,
  GetAllVehiclesQueryVariables
>;
export const VehicleTypesDocument = gql`
  query VehicleTypes {
    vehicleTypes {
      id
      name
      category
    }
  }
`;

/**
 * __useVehicleTypesQuery__
 *
 * To run a query within a React component, call `useVehicleTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useVehicleTypesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    VehicleTypesQuery,
    VehicleTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    VehicleTypesQuery,
    VehicleTypesQueryVariables
  >(VehicleTypesDocument, options);
}
export function useVehicleTypesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    VehicleTypesQuery,
    VehicleTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    VehicleTypesQuery,
    VehicleTypesQueryVariables
  >(VehicleTypesDocument, options);
}
export type VehicleTypesQueryHookResult = ReturnType<
  typeof useVehicleTypesQuery
>;
export type VehicleTypesLazyQueryHookResult = ReturnType<
  typeof useVehicleTypesLazyQuery
>;
export type VehicleTypesQueryResult = ApolloReactCommon.QueryResult<
  VehicleTypesQuery,
  VehicleTypesQueryVariables
>;
export const CreateVehicleBrandDocument = gql`
  mutation CreateVehicleBrand($name: String!) {
    createVehicleBrand(name: $name) {
      id
      brand
    }
  }
`;
export type CreateVehicleBrandMutationFn = ApolloReactCommon.MutationFunction<
  CreateVehicleBrandMutation,
  CreateVehicleBrandMutationVariables
>;

/**
 * __useCreateVehicleBrandMutation__
 *
 * To run a mutation, you first call `useCreateVehicleBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehicleBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVehicleBrandMutation, { data, loading, error }] = useCreateVehicleBrandMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateVehicleBrandMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateVehicleBrandMutation,
    CreateVehicleBrandMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreateVehicleBrandMutation,
    CreateVehicleBrandMutationVariables
  >(CreateVehicleBrandDocument, options);
}
export type CreateVehicleBrandMutationHookResult = ReturnType<
  typeof useCreateVehicleBrandMutation
>;
export type CreateVehicleBrandMutationResult =
  ApolloReactCommon.MutationResult<CreateVehicleBrandMutation>;
export type CreateVehicleBrandMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateVehicleBrandMutation,
    CreateVehicleBrandMutationVariables
  >;
export const CreateVehicleModelDocument = gql`
  mutation CreateVehicleModel($name: String!, $id: ID!) {
    createVehicleModel(id: $id, name: $name) {
      id
      name
    }
  }
`;
export type CreateVehicleModelMutationFn = ApolloReactCommon.MutationFunction<
  CreateVehicleModelMutation,
  CreateVehicleModelMutationVariables
>;

/**
 * __useCreateVehicleModelMutation__
 *
 * To run a mutation, you first call `useCreateVehicleModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehicleModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVehicleModelMutation, { data, loading, error }] = useCreateVehicleModelMutation({
 *   variables: {
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateVehicleModelMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateVehicleModelMutation,
    CreateVehicleModelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreateVehicleModelMutation,
    CreateVehicleModelMutationVariables
  >(CreateVehicleModelDocument, options);
}
export type CreateVehicleModelMutationHookResult = ReturnType<
  typeof useCreateVehicleModelMutation
>;
export type CreateVehicleModelMutationResult =
  ApolloReactCommon.MutationResult<CreateVehicleModelMutation>;
export type CreateVehicleModelMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateVehicleModelMutation,
    CreateVehicleModelMutationVariables
  >;
